import { fmtMoneda } from '../../utils/moneda';
import { analizarPolizaIA, primaNetaIA, matchCatalogo } from '../../utils/docIA';
import { describirCambioHTML } from '../../utils/endosoDetalle';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { supabase, insertRow, updateRow, deleteRow, fetchAutoLimiteOpciones, fetchCoberturaDescripciones, fetchReferidos, ensureTipoDocRUV } from '../../db/engine';
import { decisionesNoRenueva, decidioNoRenovar, etiquetaEstadoPoliza } from '../../db/renovaciones';
import { aplicarCambioEndoso, aplicarPrimaEndoso, reversarCambioEndoso, targetAplica } from '../../db/endosos';
import { registrarFacturaPeriodo, registrarDeclaracion, etiquetaPeriodo } from '../../db/periodos';
import { useApp } from '../../context/AppContext';
import { abrirDocumento } from '../../utils/archivos';
import PolizaSelect from '../../components/PolizaSelect';
import { useNavigate } from 'react-router-dom';
import { Plus, Edit2, Trash2, Eye, X, FileText, UserPlus, Building2, AlertTriangle, Save, ChevronDown, ChevronUp, RotateCw, Lock, Paperclip, Search } from 'lucide-react';
import SearchSelect from '../../components/SearchSelect';
import ClienteSelect from '../../components/ClienteSelect';
import CoberturaDesc from '../../components/CoberturaDesc';
import EndosoCambiosMulti from '../../components/EndosoCambiosMulti';
import VehiculoListInput, { validarVehiculos } from '../../components/VehiculoListInput';
import { detectAutoTipo, autoOpcionesPorTipo } from '../../utils/autoLimites';
import DocManager from '../../components/DocManager';
import RegularizacionPanel from '../../components/RegularizacionPanel';
import RenovacionesView from './RenovacionesView';
import BeneficiarioConfidencial from '../../components/BeneficiarioConfidencial';
import ReciboCobroExito from '../../components/ReciboCobroExito';
import { reaplicarSacoPoliza } from '../cobros/Cobros';
import { generarComisionesDelCobro, ajustarComisionesPorCambioDePct } from '../../db/comisiones';
import { fmtFecha, fmtFechaHora, sumarUnAnioISO } from '../../utils/fecha';
import { marcaImpresion, getMarca, getAbrev } from '../../utils/marca';
import { imprimirHTML } from '../../utils/imprimir';
import { loadXLSX } from '../../utils/xlsx';

const EMPTY = {
  numero:'', cliente_id:'', aseguradora_id:'', ramo_id:'', subramo_id:'', ejecutivo_id:'', ejecutivo_cobro_id:'', ejecutivo_reclamo_id:'',
  tipo:'nueva', tipo_emision:'nueva', estado:'activa', prima:'', fecha_inicio:'', fecha_vencimiento:'',
  fecha_emision:'', notas:'', impuesto:'5', comision_ramo:'', poliza_anterior_id:'',
  forma_pago:'', frecuencia_pago:'mensual', num_cuotas:'1',
  // ── Facturación periódica (colectivos vida/salud y declarativas) ──
  // 'cuotas' = plan fijo al emitir (default). 'periodica' = cada período la aseguradora
  // factura, el ejecutivo la registra (ver src/db/periodos.js). declarativa_modo solo
  // aplica a transporte/incendio declarativa: 'mensual' o 'acumulativo' (ajuste anual).
  facturacion_modo:'cuotas', periodo_frecuencia:'mensual', declarativa_modo:'',
  gastos_expedicion:'', participacion:'', descripcion_riesgo:'',
  beneficiario_nombre:'', beneficiario_cedula:'', beneficiario_oneroso: false,
  asegurado_nombre:'', asegurado_cedula:'',
  tomador_nombre:'', tomador_cedula:'',
  es_fee:false, monto_fee:'',
  sobrecomision_tipo:'', sobrecomision_valor:'', sobrecomision_reparto:'ru',
  // ── Modalidad declarativa (incendio / transporte) ──
  es_declarativa:false, modalidad_declarativa:'', arquitectura:'',
  tasa:'', tasa_unidad:'por_mil', tasa_guerra:'',
  prima_deposito:'', prima_minima:'', deposito_es_ganado:false,
  suma_maxima:'', suma_total:'', periodicidad_declaracion:'mensual',
  base_valuacion:'', factor_valuacion:'1.10',
  // ── Sub-modo FIANZA (garantía sobre monto afianzado, pago único, vigencia libre) ──
  es_fianza:false, monto_afianzado:'', tarifa_fianza:'', beneficiario_fianza:'',
  // ── Referido (referidor) ──
  referido_id:'', referido_comision_pct:'',
};

const FRECUENCIAS = [
  { value:'mensual',    label:'Mensual',    meses:1  },
  { value:'bimensual',  label:'Bimensual',  meses:2  },
  { value:'trimestral', label:'Trimestral', meses:3  },
  { value:'semestral',  label:'Semestral',  meses:6  },
  { value:'anual',      label:'Anual',      meses:12 },
];

function calcularCuotas(prima, impuesto, frecuencia, numCuotas, fechaInicio) {
  const total = parseFloat(prima||0) * (1 + parseFloat(impuesto||0)/100);
  const n = parseInt(numCuotas)||1;
  const frec = FRECUENCIAS.find(f=>f.value===frecuencia) || FRECUENCIAS[0];
  const montoCuota = Math.round(total / n * 100) / 100;
  const cuotas = [];
  for (let i = 0; i < n; i++) {
    const fecha = fechaInicio ? new Date(fechaInicio + 'T12:00:00') : null;
    if (fecha) fecha.setMonth(fecha.getMonth() + i * frec.meses);
    const monto = i === n-1
      ? Math.round((total - montoCuota*(n-1))*100)/100
      : montoCuota;
    cuotas.push({ num: i+1, monto, fecha: fecha ? fecha.toISOString().slice(0,10) : null });
  }
  return { total, cuotas, mesesTotal: n * frec.meses };
}

const EMPTY_CLI = {
  tipo:'natural', primer_nombre:'', segundo_nombre:'', primer_apellido:'',
  segundo_apellido:'', apellido_casada:'', nombre:'',
  cedula_ruc:'', telefono:'', email:'',
};

const EMPTY_ASEG = { nombre:'', codigo:'', contacto:'', telefono:'', email:'' };

const EMPTY_AUTO = {
  anio:'', marca:'', modelo:'', color:'', tipo_vehiculo:'',
  pasajeros:'', no_motor:'', chasis:'', chasis_igual_motor:true,
  placa:'', placa_por_reportar:false,
  dueno_igual:true, dueno_nombre:'', dueno_cedula:'',
};

const ESTADO_BADGE = {
  activa:'badge-success', vencida:'badge-danger',
  cancelada:'badge-neutral', en_renovacion:'badge-warning',
  borrador:'badge-info', renovada:'badge-info', no_renovada:'badge-neutral',
};

// Estados de reclamo (mismo criterio que el módulo Reclamos)
const RECLAMO_BADGE = {
  abierto:'badge-danger', en_proceso:'badge-warning', en_revision:'badge-info',
  aprobado:'badge-success', rechazado:'badge-neutral', cerrado:'badge-neutral',
};
const RECLAMO_ABIERTO = ['abierto', 'en_proceso', 'en_revision'];

// ── Auditoría de la edición de una póliza ──────────────────────────────────────
// Campos que se registran en bitácora al editar. Los marcados `riesgo` son los que
// mueven dinero o cobertura: cambiarlos exige escribir un motivo.
// OJO: esto NO reemplaza al candado (`bloqueada_edicion`), lo complementa. El candado
// evita el cambio; esto deja el rastro cuando el cambio SÍ se permite — incluidas las
// pólizas viejas, que no tienen candado y antes se editaban sin dejar ninguna huella.
const CAMPOS_AUDITADOS = [
  { k: 'numero',            label: 'Número de póliza',    riesgo: true },
  { k: 'prima',             label: 'Prima',               riesgo: true },
  { k: 'fecha_inicio',      label: 'Inicio de vigencia',  riesgo: true },
  { k: 'fecha_vencimiento', label: 'Vencimiento',         riesgo: true },
  { k: 'impuesto',          label: 'Impuesto',            riesgo: true },
  { k: 'comision_ramo',     label: '% de comisión',       riesgo: true },
  { k: 'forma_pago',        label: 'Forma de pago',       riesgo: true },
  { k: 'frecuencia_pago',   label: 'Frecuencia de pago',  riesgo: true },
  { k: 'num_cuotas',        label: 'N° de cuotas',        riesgo: true },
  { k: 'aseguradora_id',    label: 'Aseguradora',         riesgo: true },
  { k: 'ramo_id',           label: 'Ramo',                riesgo: true },
  { k: 'subramo_id',        label: 'Subramo',             riesgo: true },
  { k: 'estado',            label: 'Estado' },
  { k: 'ejecutivo_id',      label: 'Ejecutivo de cuenta' },
  { k: 'ejecutivo_cobro_id',   label: 'Ejecutivo de cobro' },
  { k: 'ejecutivo_reclamo_id', label: 'Ejecutivo de reclamo' },
  { k: 'referido_id',       label: 'Referido' },
  { k: 'notas',             label: 'Notas' },
];
// El formulario guarda todo como texto y la base devuelve números/fechas: se comparan
// normalizados para no reportar "cambios" que no lo son (5 vs "5.00", fecha con hora).
const normAudit = (v) => {
  if (v === null || v === undefined) return '';
  const s = String(v).trim();
  if (s === '') return '';
  return /^\d{4}-\d{2}-\d{2}T/.test(s) ? s.slice(0, 10) : s;
};
const igualAudit = (a, b) => {
  const na = normAudit(a), nb = normAudit(b);
  if (na === nb) return true;
  if (na !== '' && nb !== '' && !isNaN(Number(na)) && !isNaN(Number(nb))) return Number(na) === Number(nb);
  return false;
};
// Diferencias entre lo que hay en el formulario y la póliza guardada.
const cambiosDePoliza = (valores, original) => {
  if (!valores || !original) return [];
  return CAMPOS_AUDITADOS
    .filter(c => Object.prototype.hasOwnProperty.call(valores, c.k))
    .filter(c => !igualAudit(valores[c.k], original[c.k]))
    .map(c => ({ ...c, antes: normAudit(original[c.k]), despues: normAudit(valores[c.k]) }));
};
// Una línea legible para la bitácora: "Prima: 210 → 260 · Vencimiento: … → …"
const detalleCambios = (difs) =>
  difs.map(d => `${d.label}: ${d.antes || '—'} → ${d.despues || '—'}`).join(' · ');

// Firma de las coberturas para saber si cambiaron entre que se abrió el formulario y se
// guardó. Hace falta porque al editar se BORRAN y se reinsertan siempre: sin comparar,
// un cambio de suma o de deducible no se distinguiría de un guardado sin tocar nada.
const firmaCoberturas = (lista) => (lista || [])
  .map(c => [
    c.nombre || '', c.tipo_limite || 'limite',
    normAudit(c.suma_asegurada), normAudit(c.deducible), c.otros || '',
  ].join('|'))
  .sort()
  .join(' ;; ');

const fmt$ = fmtMoneda;

// Ciclo de estados de una solicitud de endoso (para mostrar el paso actual y exigir su cierre).
const ENDOSO_PASOS = ['borrador', 'enviada_aseg', 'endoso_recibido', 'enviado_cliente'];
const ENDOSO_ESTADO_LABEL = {
  borrador: 'Borrador',
  enviada_aseg: 'Enviada a aseguradora',
  endoso_recibido: 'Endoso recibido',
  enviado_cliente: 'Enviado al cliente',
};

// ── Export Excel/PDF de la lista de pólizas (mismo patrón que Comisiones) ──

// Columnas del export (label + función que extrae el valor de la fila)
const POL_EXPORT_COLS = (subramoNombre) => [
  ['Número',        r => r.numero || ''],
  ['Cliente',       r => r.cliente || ''],
  ['Ramo',          r => r.ramo || ''],
  ['Subramo',       r => subramoNombre(r.subramo_id) || ''],
  ['Aseguradora',   r => r.aseguradora || ''],
  ['Ejecutivo',     r => r.ejecutivo || ''],
  ['Prima',         r => r.prima != null ? Number(r.prima) : ''],
  ['Estado',        r => r.estado || ''],
  ['Vig. inicial',  r => r.fecha_inicio ? String(r.fecha_inicio).slice(0,10) : ''],
  ['Vencimiento',   r => r.fecha_vencimiento ? String(r.fecha_vencimiento).slice(0,10) : ''],
];

async function exportarPolizasExcel(rows, subramoNombre, resumenFiltro) {
  const M = marcaImpresion();
  const XLSX = await loadXLSX();
  const cols = POL_EXPORT_COLS(subramoNombre);
  const aoa = [
    [`${M.nombre} — Listado de Pólizas`],
    [resumenFiltro || ''],
    [`${rows.length} póliza(s)`],
    [],
    cols.map(c => c[0]),
  ];
  let totalPrima = 0;
  for (const r of rows) {
    aoa.push(cols.map(c => c[1](r)));
    totalPrima += parseFloat(r.prima) || 0;
  }
  aoa.push([]);
  const totalRow = cols.map(() => '');
  totalRow[0] = 'TOTAL PRIMA';
  totalRow[6] = totalPrima;
  aoa.push(totalRow);
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws['!cols'] = [{wch:18},{wch:26},{wch:16},{wch:18},{wch:18},{wch:16},{wch:12},{wch:14},{wch:12},{wch:12}];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Pólizas');
  XLSX.writeFile(wb, `Polizas_${new Date().toISOString().slice(0,10)}.xlsx`);
}

function exportarPolizasPDF(rows, subramoNombre, resumenFiltro) {
  const M = marcaImpresion();
  const cols = POL_EXPORT_COLS(subramoNombre);
  let totalPrima = 0;
  const body = rows.map(r => {
    totalPrima += parseFloat(r.prima) || 0;
    return '<tr>' + cols.map((c,i) => {
      const v = c[1](r);
      const val = (i === 6 && v !== '') ? fmt$(v) : (i >= 8 && v ? fmtFecha(v) : v);
      return `<td${i===6?' style="text-align:right"':''}>${val == null ? '' : String(val)}</td>`;
    }).join('') + '</tr>';
  }).join('');
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>Pólizas</title>
    <style>
      body{font-family:Arial,sans-serif;font-size:11px;color:#111;margin:20px}
      .brand{display:flex;align-items:center;gap:10px;margin-bottom:12px;border-bottom:2px solid ${M.colores.steel};padding-bottom:10px}
      .brand-name{font-size:16px;font-weight:800;color:${M.colores.steel};letter-spacing:1px}
      .brand-tag{font-size:10px;color:${M.colores.sky}}
      h2{font-size:14px;margin:0 0 2px}
      .sub{font-size:11px;color:#555;margin-bottom:12px}
      table{width:100%;border-collapse:collapse;font-size:10px}
      th{background:${M.colores.steel};color:#fff;padding:6px 4px;text-align:left}
      td{padding:5px 4px;border-bottom:1px solid #e0e0e0}
      tr:nth-child(even) td{background:#f7f9fb}
      .total-row td{font-weight:700;border-top:2px solid ${M.colores.steel};background:#e8f0f8}
      @media print{body{margin:10px}}
    </style></head><body>
    <div class="brand">${M.logo}<div><div class="brand-name" style="text-transform:uppercase">${M.nombre}</div><div class="brand-tag">${M.tagline}</div></div></div>
    <h2>Listado de Pólizas</h2>
    <div class="sub">${resumenFiltro || ''} · ${rows.length} póliza(s)</div>
    <table><thead><tr>${cols.map((c,i)=>`<th${i===6?' style="text-align:right"':''}>${c[0]}</th>`).join('')}</tr></thead>
    <tbody>${body}
      <tr class="total-row"><td colspan="6" style="text-align:right">TOTAL PRIMA</td><td style="text-align:right">${fmt$(totalPrima)}</td><td colspan="3"></td></tr>
    </tbody></table>
  </body></html>`;
  imprimirHTML(html);
}

// Nombre del mes (para el plan de cobros de pólizas declarativas: cuotas por mes)
const MESES_ES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const nombreMes = (fecha) => {
  if (!fecha) return '—';
  const d = new Date(String(fecha).slice(0,10) + 'T12:00:00');
  return isNaN(d) ? '—' : `${MESES_ES[d.getMonth()]} ${d.getFullYear()}`;
};

function buildNombre(f) {
  if (f.tipo === 'juridica') return f.nombre;
  return [f.primer_nombre, f.segundo_nombre, f.primer_apellido, f.segundo_apellido, f.apellido_casada]
    .filter(Boolean).join(' ');
}

function formatDeducible(c) {
  if (!c.tiene_deducible) return null;
  switch (c.deducible_tipo) {
    case 'persona_evento':
      return `$${c.ded_por_persona || 0} por persona / $${c.ded_por_evento || 0} por evento`;
    case 'evento':
      return `$${c.ded_por_evento || 0} por evento`;
    case 'pct_minimo':
      return `${c.ded_pct || 0}% de la SA, mínimo $${c.ded_minimo || 0}`;
    case 'pct':
      return `${c.ded_pct || 0}% de la SA`;
    case 'personalizado':
      return c.ded_personalizado || '';
    default:
      return null;
  }
}

// Interpreta un texto/etiqueta de límite "por persona / por accidente" (ej: "5,000 / 10,000").
// Devuelve { persona, accidente } o null si no tiene esa forma de dos montos separados por "/".
function parsePersonaAccidente(str) {
  if (!str) return null;
  const partes = String(str).split('/').map(s => s.trim());
  if (partes.length !== 2) return null;
  const toNum = s => { const n = parseFloat(String(s).replace(/[^0-9.]/g, '')); return isNaN(n) ? null : n; };
  const persona = toNum(partes[0]), accidente = toNum(partes[1]);
  if (persona == null || accidente == null) return null;
  return { persona, accidente };
}

function newCobFromTemplate(c) {
  return {
    cobertura_id: c.id,
    nombre: c.nombre,
    descripcion: c.descripcion || '',
    tipo_limite: 'limite',
    suma_asegurada: '',
    incluida: false, // NUNCA marcar automático: la persona decide qué cobertura incluir
    es_personalizada: false,
    tiene_deducible: false,
    deducible_tipo: 'evento',
    ded_por_persona: '', ded_por_evento: '',
    ded_pct: '', ded_minimo: '', ded_personalizado: '',
    otros: '',
    expanded: false,
  };
}

export default function Polizas() {
  const { canEdit, user, agenteScope, esAgenteRestringido } = useApp();
  const abrev = getAbrev();
  const navigate = useNavigate();
  const autoOpenRef = useRef(false);
  const canCreateAseg = user?.es_master || user?.rol_nombre?.toLowerCase().includes('operativ');
  const esDirectorOSuperior = user?.es_master || user?.rol_nombre?.toLowerCase().includes('director');

  // Filtros persistidos en la sesión: al ir a crear un endoso (u otra navegación) y volver,
  // la lista conserva los mismos filtros en vez de resetearse.
  const savedFiltros = (() => { try { return JSON.parse(sessionStorage.getItem('polFiltros') || '{}'); } catch { return {}; } })();

  const [rows, setRows]               = useState([]);
  const [vista, setVista]             = useState('lista'); // 'lista' | 'renovaciones'
  const [filterPoliza, setFilterPoliza] = useState(savedFiltros.filterPoliza || '');
  const [filterEstado, setFilterEstado] = useState(savedFiltros.filterEstado || '');
  const [filterCliente, setFilterCliente] = useState(savedFiltros.filterCliente || '');
  const [filterAseguradora, setFilterAseguradora] = useState(savedFiltros.filterAseguradora || '');
  const [filterRamo, setFilterRamo]   = useState(savedFiltros.filterRamo || '');
  const [filterFechaTipo, setFilterFechaTipo] = useState(savedFiltros.filterFechaTipo || '');   // ''|'vigencia'|'creacion'
  const [filterFechaDesde, setFilterFechaDesde] = useState(savedFiltros.filterFechaDesde || '');
  const [filterFechaHasta, setFilterFechaHasta] = useState(savedFiltros.filterFechaHasta || '');
  const [sortCol, setSortCol]         = useState('fecha_vencimiento');
  const [sortDir, setSortDir]         = useState('asc');
  const [modal, setModal]             = useState(null);
  const [selected, setSelected]       = useState(null);
  const [form, setForm]               = useState(EMPTY);

  const [clientes, setClientes]         = useState([]);
  const [agentes, setAgentes]           = useState([]);
  const [aseguradoras, setAseguradoras] = useState([]);
  const [ramos, setRamos]               = useState([]);
  const [allSubramos, setAllSubramos]   = useState([]);
  const [subramos, setSubramos]         = useState([]);
  const [ejecutivos, setEjecutivos]     = useState([]);
  const [referidos, setReferidos]       = useState([]);
  // Candado de edición: si la póliza está bloqueada y el usuario no es master, se
  // edita solo lo administrativo (ejecutivos/referido/notas) por un modal compacto.
  const [adminModal, setAdminModal]     = useState(null);
  const [adminForm, setAdminForm]       = useState(null);
  const [savingAdmin, setSavingAdmin]   = useState(false);
  // Por qué se está editando la póliza. Obligatorio si el cambio toca datos de riesgo.
  const [motivoCambio, setMotivoCambio] = useState('');
  // Firma de las coberturas tal como se abrieron, para detectar si se tocaron al guardar.
  const cobsBaseRef = useRef('');
  // Flota: la póliza tiene más de un vehículo → los vehículos se editan por endoso.
  const [polTieneFlota, setPolTieneFlota] = useState(false);

  const [polizaAgentes, setPolizaAgentes]       = useState([]);
  const [polizaCoberturas, setPolizaCoberturas] = useState([]);
  const [agenteSelector, setAgenteSelector]     = useState('');
  const [comisionRamoBase, setComisionRamoBase] = useState(null);
  const [ejecutivoBase, setEjecutivoBase]       = useState(null);
  const [nuevaCobertura, setNuevaCobertura]     = useState('');
  const [showAddCob, setShowAddCob]             = useState(false);
  const [isAuto, setIsAuto]                     = useState(false);
  const [autoLimiteOpciones, setAutoLimiteOpciones] = useState([]);
  const [autoForm, setAutoForm]                 = useState(EMPTY_AUTO);
  // Al EMITIR (crear/renovar) una póliza de auto se pueden cargar varias unidades (flota).
  // Después de emitida, las unidades se cambian por endoso.
  const [autoList, setAutoList]                 = useState([{ ...EMPTY_AUTO }]);
  const [coberturasCatalogo, setCoberturasCatalogo] = useState([]);
  const [cobSelector, setCobSelector]           = useState('');
  const [tienePagosAplicados, setTienePagosAplicados] = useState(false);
  const [showAjusteConfirm, setShowAjusteConfirm] = useState(false);
  const [pendingAjuste, setPendingAjuste]         = useState(null);

  // View modal state
  const [viewTab, setViewTab]           = useState('info');
  const [viewAgentes, setViewAgentes]   = useState([]);
  const [viewCoberturas, setViewCoberturas] = useState([]);
  const [viewAutos, setViewAutos]       = useState([]); // todos los vehículos (flota) para la vista
  const [viewPagos, setViewPagos]       = useState([]);
  const [viewEndosos, setViewEndosos]   = useState([]);
  const [viewReclamos, setViewReclamos] = useState([]);
  const [viewPeriodos, setViewPeriodos] = useState([]);
  const [viewUnidades, setViewUnidades] = useState([]);
  // Grupos por fecha en la pestaña Unidades (asegurados de colectivos), plegados por defecto.
  const [unidadesGrupoOpen, setUnidadesGrupoOpen] = useState({});
  // Detalle de un endoso aplicado (clic en la línea de la pestaña Endosos).
  const [endosoDetalle, setEndosoDetalle] = useState(null);
  // Lectura de la póliza con IA al crear (autocompleta el formulario; el usuario revisa).
  const [leyendoPolizaIA, setLeyendoPolizaIA] = useState(false);
  const [iaPolizaInfo, setIaPolizaInfo] = useState(null); // { aseguradora, ramo } detectados (referencia)
  const polizaIAFileRef = useRef(null);
  // Registro de la factura de un período (modo periódico): { periodo, monto, ... }
  const [periodoFactura, setPeriodoFactura] = useState(null);
  const [guardandoPeriodo, setGuardandoPeriodo] = useState(false);
  // Declarativas: registro de una declaración (endoso + letra) directo desde la pestaña.
  const [declForm, setDeclForm]         = useState(null); // { fecha, monto, descripcion, numero_endoso, tipoDocId, files:[] }
  const [savingDecl, setSavingDecl]     = useState(false);
  const [viewPeriodoDocs, setViewPeriodoDocs] = useState([]); // documentos de respaldo ligados a períodos
  const [tiposDocPoliza, setTiposDocPoliza]   = useState([]); // tipos_documento categoría 'poliza' (selector)
  const [viewArchivosSol, setViewArchivosSol] = useState([]);
  const [viewSolicitud, setViewSolicitud] = useState(null);
  const [viewPolizaAnterior, setViewPolizaAnterior] = useState(null); // número de la vigencia anterior (si es renovación)
  const [cpModal, setCpModal] = useState(null); // modal "Cambiar prima mensual" (salud): { monto, fecha, file, guardando }
  const [anularEndosoTarget, setAnularEndosoTarget] = useState(null);
  const [motivoAnularEndoso, setMotivoAnularEndoso] = useState('');
  const [anulandoEndoso, setAnulandoEndoso] = useState(false);
  const [viewEndosoSolicitudes, setViewEndosoSolicitudes] = useState([]); // solicitudes de endoso pendientes de esta póliza
  const [viewEndosoCancelados, setViewEndosoCancelados] = useState([]);   // solicitudes de endoso eliminadas/canceladas (con motivo)
  const [endosoTiposMap, setEndosoTiposMap] = useState({}); // {id: nombre} del catálogo de tipos de endoso
  const [endosoTiposLista, setEndosoTiposLista] = useState([]); // catálogo completo (target/ramo) para endoso interno
  // Endoso interno: cambio interno (la aseguradora NO envía documento). Modal directo.
  const [eiModal, setEiModal] = useState(null); // póliza sobre la que se hace el endoso interno
  const [eiForm, setEiForm]   = useState(null);
  const [savingEI, setSavingEI] = useState(false);
  const [viewBitacoraCobros, setViewBitacoraCobros] = useState([]);   // gestiones de cobro de la póliza
  const [viewBitacoraPolizas, setViewBitacoraPolizas] = useState([]); // gestiones de póliza/renovación
  // Registrar pago inline (pestaña Plan de Cobros)
  const [showPagoModal, setShowPagoModal] = useState(false);
  const [pagoForm, setPagoForm] = useState({ monto_recibido:'', donde_pago:'Aseguradora', fecha_pago_aseg:'', forma_pago_real:'', num_recibo_aseg:'', notas_cobro:'' });
  const [savingPago, setSavingPago] = useState(false);
  const [reciboExito, setReciboExito] = useState(null); // recibo tras pago en oficina

  const [showCrearCliente, setShowCrearCliente] = useState(false);
  const [cliForm, setCliForm]     = useState(EMPTY_CLI);
  const [savingCli, setSavingCli] = useState(false);

  const [showCrearAseg, setShowCrearAseg] = useState(false);
  const [asegForm, setAsegForm]   = useState(EMPTY_ASEG);
  const [savingAseg, setSavingAseg] = useState(false);

  const loadCatalogos = async () => {
    const [c, a, s, r, e] = await Promise.all([
      supabase.from('clientes').select('id, nombre, numero_cliente, ejecutivo_id').order('nombre'),
      supabase.from('agentes').select('id, nombre, comision_nueva_agente, comision_renovacion_agente').eq('activo', true).order('nombre'),
      supabase.from('aseguradoras').select('id, nombre').eq('activa', true).order('nombre'),
      supabase.from('ramos').select('id, nombre, es_fianza').eq('activo', true).order('nombre'),
      supabase.from('ejecutivos').select('id, nombre, ejec_cuenta, ejec_cobro, ejec_reclamo').eq('activo', true).order('nombre'),
    ]);
    setClientes((c.data || []).map(x => ({
      ...x, nombre: x.numero_cliente ? `${x.nombre} (${x.numero_cliente})` : x.nombre,
    })));
    setAgentes(a.data || []);
    setAseguradoras(s.data || []);
    setRamos(r.data || []);
    // Las funciones (cuenta/cobro/reclamo) viven en la ficha del ejecutivo y
    // filtran los selectores de la póliza: cuenta / cobro / reclamo.
    setEjecutivos((e.data || []).map(x => ({
      ...x, func: { cuenta:!!x.ejec_cuenta, cobro:!!x.ejec_cobro, reclamo:!!x.ejec_reclamo },
    })));

    const { data: allSubs } = await supabase.from('subramos')
      .select('id, nombre, ramo_id, es_declarativa, ramos(nombre)').eq('activo', true).order('nombre');
    setAllSubramos((allSubs || []).map(s => ({
      id: s.id, nombre: s.nombre, ramo_id: s.ramo_id, es_declarativa: !!s.es_declarativa, meta: s.ramos?.nombre || '',
    })));

    // Niveles de límite de Auto (tolerante: si la tabla no existe, queda vacío)
    setAutoLimiteOpciones(await fetchAutoLimiteOpciones());

    // Referidos activos (tolerante: si la tabla no existe, queda vacío)
    setReferidos(await fetchReferidos());

    // Catálogo de tipos de endoso (para mostrar el nombre en las solicitudes de endoso;
    // se resuelve por lookup porque NO hay FK/embed solicitudes→catalogo_endoso_tipos).
    try {
      const { data: tipos } = await supabase.from('catalogo_endoso_tipos')
        .select('id, nombre, comportamiento, target, ramo_id, activo, orden').order('orden').order('nombre');
      const map = {}; (tipos || []).forEach(t => { map[t.id] = t.nombre; });
      setEndosoTiposMap(map);
      setEndosoTiposLista((tipos || []).filter(t => t.activo !== false));
    } catch { /* si la tabla no existe, queda vacío */ }
  };

  const load = useCallback(async () => {
    // Agente restringido: esperar a tener el alcance (sus pólizas) antes de consultar,
    // para no hacer una carga vacía que pise el resultado bueno.
    if (esAgenteRestringido && !agenteScope) return;
    let q = supabase.from('polizas')
      .select('*, clientes(nombre), aseguradoras(nombre), ramos(nombre), ejecutivos!polizas_ejecutivo_id_fkey(nombre)')
      .order('fecha_vencimiento', { ascending:true });
    if (filterEstado) q = q.eq('estado', filterEstado);
    // Agente restringido: solo sus pólizas
    if (esAgenteRestringido) q = q.in('id', agenteScope?.polizaIds?.length ? agenteScope.polizaIds : [-1]);
    const { data } = await q;
    let arr = (data || []).map(p => ({
      ...p,
      cliente: p.clientes?.nombre,
      aseguradora: p.aseguradoras?.nombre,
      ramo: p.ramos?.nombre,
      ejecutivo: p.ejecutivos?.nombre,
    }));
    setRows(arr);
  }, [filterEstado, esAgenteRestringido, agenteScope]);

  useEffect(() => { loadCatalogos(); }, []);
  useEffect(() => { load(); }, [load]);

  // Guardar filtros en la sesión para conservarlos al navegar y volver (p. ej. crear endoso).
  useEffect(() => {
    sessionStorage.setItem('polFiltros', JSON.stringify({
      filterPoliza, filterEstado, filterCliente, filterAseguradora, filterRamo,
      filterFechaTipo, filterFechaDesde, filterFechaHasta,
    }));
  }, [filterPoliza, filterEstado, filterCliente, filterAseguradora, filterRamo, filterFechaTipo, filterFechaDesde, filterFechaHasta]);

  // Auto-abrir póliza si viene navegando desde Solicitudes
  useEffect(() => {
    const polizaId = sessionStorage.getItem('openPolizaId');
    if (!polizaId || autoOpenRef.current) return;
    autoOpenRef.current = true;
    sessionStorage.removeItem('openPolizaId');
    const tabRetorno = sessionStorage.getItem('openPolizaTab');
    sessionStorage.removeItem('openPolizaTab');
    supabase.from('polizas')
      .select('*, clientes(nombre), aseguradoras(nombre), ramos(nombre), ejecutivos!polizas_ejecutivo_id_fkey(nombre)')
      .eq('id', polizaId).single()
      .then(async ({ data }) => {
        if (!data) return;
        await openView({ ...data, cliente: data.clientes?.nombre, aseguradora: data.aseguradoras?.nombre, ramo: data.ramos?.nombre, ejecutivo: data.ejecutivos?.nombre });
        if (tabRetorno) setViewTab(tabRetorno);
      });
  }, []);  // eslint-disable-line

  // ── Auto-actualización de estados por fecha (corre al entrar a Pólizas) ──
  // Regla: activa = hoy dentro de su vigencia; renovada = pasó el vencimiento y existe
  // una póliza que la renueva; no_renovada = pasó el vencimiento sin renovación y en el
  // CRM se cerró su tarea como "Cliente no renueva" (se gestionó y se decidió);
  // vencida = pasó el vencimiento sin renovación y SIN esa decisión (nadie la cerró).
  // No toca cancelada / borrador / en_renovacion (estados manuales).
  const estadoFixRef = useRef(false);
  useEffect(() => {
    if (estadoFixRef.current || esAgenteRestringido) return; // solo la operación dispara la corrección masiva
    estadoFixRef.current = true;
    (async () => {
      try {
        const hoyStr = new Date().toISOString().slice(0, 10);
        const { data: pols } = await supabase.from('polizas')
          .select('id, estado, fecha_vencimiento')
          .in('estado', ['activa', 'vencida', 'renovada', 'no_renovada']);
        if (!pols?.length) return;
        // IDs que tienen una renovación (alguien las apunta); se ignora el self-reference.
        // Cuenta el MAPA (renovacion_de_poliza_id) además del ARRASTRE (poliza_anterior_id),
        // igual que el CRM y Renovaciones: una renovación sin arrastre de saldo también renueva.
        const { data: links } = await supabase.from('polizas')
          .select('id, poliza_anterior_id, renovacion_de_poliza_id')
          .or('poliza_anterior_id.not.is.null,renovacion_de_poliza_id.not.is.null');
        const renovadas = new Set();
        (links || []).forEach(l => {
          if (l.poliza_anterior_id && l.poliza_anterior_id !== l.id) renovadas.add(l.poliza_anterior_id);
          if (l.renovacion_de_poliza_id && l.renovacion_de_poliza_id !== l.id) renovadas.add(l.renovacion_de_poliza_id);
        });
        // "Cliente no renueva" solo hace falta mirarlo en las vencidas sin renovación.
        const yaVencidasSinRenov = pols.filter(p => p.fecha_vencimiento &&
          String(p.fecha_vencimiento).slice(0, 10) < hoyStr && !renovadas.has(p.id)).map(p => p.id);
        const noRenueva = await decisionesNoRenueva(yaVencidasSinRenov);
        const aVencida = [], aRenovada = [], aActiva = [], aNoRenovada = [];
        for (const p of pols) {
          if (!p.fecha_vencimiento) continue;
          const vencida = String(p.fecha_vencimiento).slice(0, 10) < hoyStr;
          const correcto = !vencida ? 'activa'
            : renovadas.has(p.id) ? 'renovada'
            : decidioNoRenovar(noRenueva, p.id, p.fecha_vencimiento) ? 'no_renovada'
            : 'vencida';
          if (correcto === p.estado) continue;
          if (correcto === 'vencida') aVencida.push(p.id);
          else if (correcto === 'renovada') aRenovada.push(p.id);
          else if (correcto === 'no_renovada') aNoRenovada.push(p.id);
          else aActiva.push(p.id);
        }
        if (aVencida.length)    await supabase.from('polizas').update({ estado: 'vencida' }).in('id', aVencida);
        if (aRenovada.length)   await supabase.from('polizas').update({ estado: 'renovada' }).in('id', aRenovada);
        if (aNoRenovada.length) await supabase.from('polizas').update({ estado: 'no_renovada' }).in('id', aNoRenovada);
        if (aActiva.length)     await supabase.from('polizas').update({ estado: 'activa' }).in('id', aActiva);
        if (aVencida.length || aRenovada.length || aActiva.length || aNoRenovada.length) load();
      } catch (e) { console.error('auto-actualización de estados', e); }
    })();
  }, []);  // eslint-disable-line

  const f   = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const cf  = (k, v) => setCliForm(p => ({ ...p, [k]: v }));
  const af  = (k, v) => setAsegForm(p => ({ ...p, [k]: v }));
  const avf = (k, v) => setAutoForm(p => ({ ...p, [k]: v }));

  // ── Cliente: auto-populate ejecutivo ────────────────────────────
  const handleClienteChange = (clienteId) => {
    f('cliente_id', clienteId);
    if (!clienteId) return;
    const cli = clientes.find(c => String(c.id) === String(clienteId));
    if (cli?.ejecutivo_id) {
      setEjecutivoBase(cli.ejecutivo_id);
      f('ejecutivo_id', cli.ejecutivo_id);
    } else {
      setEjecutivoBase(null);
    }
  };

  const ejecutivoCambiado = ejecutivoBase != null &&
    form.ejecutivo_id !== '' &&
    String(form.ejecutivo_id) !== String(ejecutivoBase);

  // ── Ramo: coberturas + impuesto + comisión ───────────────────────
  const handleRamoChange = async (ramoId, keepSubramo = false) => {
    f('ramo_id', ramoId);
    if (!keepSubramo) f('subramo_id', '');
    if (!ramoId) { setPolizaCoberturas([]); setCoberturasCatalogo([]); setComisionRamoBase(null); setIsAuto(false); setSubramos([]); f('es_fianza', false); return; }
    setSubramos(allSubramos.filter(s => String(s.ramo_id) === String(ramoId)));
    const [{ data: ramo }, { data: cobs }] = await Promise.all([
      supabase.from('ramos').select('*').eq('id', ramoId).single(),
      supabase.from('coberturas').select('*').eq('ramo_id', ramoId).eq('activa', true).order('orden').order('nombre'),
    ]);
    if (ramo) {
      const autoRamo = ramo.nombre?.toLowerCase().includes('auto');
      setIsAuto(autoRamo);
      // Un RAMO de fianzas activa el sub-modo fianza (todos sus subramos —Anticipo,
      // Cumplimiento, etc.— funcionan igual: comisión de garantía, pago único).
      f('es_fianza', !!ramo.es_fianza);
      f('impuesto', autoRamo ? '6' : '5');
      setComisionRamoBase(ramo.comision ?? null);
      let comisionFinal = ramo.comision ?? '';
      if (form.aseguradora_id) {
        const { data: link } = await supabase.from('aseguradora_ramos')
          .select('comision').eq('aseguradora_id', form.aseguradora_id).eq('ramo_id', ramoId).maybeSingle();
        if (link?.comision != null) comisionFinal = link.comision;
      }
      f('comision_ramo', comisionFinal !== '' ? String(comisionFinal) : '');
    }
    // El catálogo del ramo alimenta el selector "Agregar cobertura".
    // La lista de la póliza empieza vacía: la persona agrega solo las que apliquen.
    setCoberturasCatalogo(cobs || []);
    setPolizaCoberturas([]);
  };

  const handleSubramoChange = async (subramoId) => {
    if (!subramoId) { f('subramo_id', ''); f('es_declarativa', false); return; }
    const sub = allSubramos.find(s => String(s.id) === String(subramoId));
    if (sub && String(sub.ramo_id) !== String(form.ramo_id)) {
      await handleRamoChange(String(sub.ramo_id), true);
    }
    f('subramo_id', subramoId);
    // Un subramo declarativo activa automáticamente la lógica declarativa y deduce la
    // modalidad por el ramo. Los subramos NO declarativos se manejan normalmente.
    if (sub?.es_declarativa) {
      f('es_declarativa', true);
      const ramoNombre = (sub.meta || '').toLowerCase();
      const modalidad = ramoNombre.includes('accidentes') ? 'accidentes_personales'
                      : ramoNombre.includes('transporte') ? 'transporte'
                      : ramoNombre.includes('incendio')   ? 'incendio' : '';
      if (modalidad) f('modalidad_declarativa', modalidad);
    } else {
      f('es_declarativa', false);
    }
    // El modo FIANZA se activa por el RAMO (en handleRamoChange), no por el subramo:
    // todos los subramos del ramo de fianzas (Anticipo, Cumplimiento, etc.) son fianzas.
  };

  const handleAsegChange = async (asegId) => {
    f('aseguradora_id', asegId);
    if (!asegId || !form.ramo_id) return;
    const { data: link } = await supabase.from('aseguradora_ramos')
      .select('comision').eq('aseguradora_id', asegId).eq('ramo_id', form.ramo_id).maybeSingle();
    if (link?.comision != null) f('comision_ramo', String(link.comision));
  };

  const comisionRamoCambiada = comisionRamoBase != null &&
    form.comision_ramo !== '' &&
    parseFloat(form.comision_ramo) !== parseFloat(comisionRamoBase);

  // ── Modalidades condicionadas por catálogo ──
  // La sección "Modalidad Declarativa" solo aparece cuando el SUBRAMO es declarativo.
  // La sección "Fianza" solo aparece cuando el RAMO es de fianza.
  const subramoEsDeclarativa = !!allSubramos.find(s => String(s.id) === String(form.subramo_id))?.es_declarativa;
  const ramoEsFianza = !!ramos.find(r => String(r.id) === String(form.ramo_id))?.es_fianza;

  // ── Agentes ──────────────────────────────────────────────────────
  // Comisión RU total (lo que paga la aseguradora a RU, sobre prima sin impuesto)
  const comisionRUTotal = parseFloat(form.prima || 0) * (parseFloat(form.comision_ramo || 0) / 100);

  const handleAgenteAdd = async () => {
    if (!agenteSelector) return;
    if (polizaAgentes.find(a => String(a.agente_id) === String(agenteSelector))) {
      setAgenteSelector(''); return;
    }
    // Si la póliza ya tiene pagos aplicados, solo director o superior puede agregar agentes
    if (tienePagosAplicados && !esDirectorOSuperior) {
      alert('Esta póliza ya tiene pagos aplicados. Para agregar un agente en este punto debes escalar con un supervisor o director.');
      setAgenteSelector('');
      return;
    }
    const { data: agente } = await supabase.from('agentes').select('*').eq('id', agenteSelector).single();
    if (agente) {
      const pct = form.tipo === 'renovacion' ? agente.comision_renovacion_agente : agente.comision_nueva_agente;
      setPolizaAgentes(prev => [...prev, {
        agente_id: agenteSelector, nombre: agente.nombre,
        porcentaje: pct != null ? String(pct) : '',
        comision_negociada: pct,
        comision_manual: false,
      }]);
    }
    setAgenteSelector('');
  };

  // % de agentes sobre la comisión RU (no sobre la prima)
  const sumAgentePct = polizaAgentes.reduce((s, a) => s + (parseFloat(a.porcentaje) || 0), 0);
  const pctRU       = Math.max(0, 100 - sumAgentePct);
  const montoRU     = comisionRUTotal * pctRU / 100;
  const pctExcedido = sumAgentePct > 100;

  // ── Coberturas ───────────────────────────────────────────────────
  const updateCobertura = (idx, field, val) => {
    setPolizaCoberturas(prev => prev.map((c, i) => i === idx ? { ...c, [field]: val } : c));
  };

  const toggleCobExpanded = (idx) => {
    setPolizaCoberturas(prev => prev.map((c, i) => i === idx ? { ...c, expanded: !c.expanded } : c));
  };

  // Coberturas del catálogo del ramo que aún no están agregadas a la póliza.
  // Se deduplica por NOMBRE: si el catálogo trae varias filas con el mismo nombre
  // (p. ej. "Lesiones corporales a terceros (LC)" repetida), en el selector aparece
  // UNA sola; los límites se eligen después con el selector de nivel de la cobertura.
  const coberturasDisponibles = (() => {
    const vistos = new Set(polizaCoberturas.map(pc => (pc.nombre || '').trim().toLowerCase()));
    const out = [];
    for (const cat of coberturasCatalogo) {
      const key = (cat.nombre || '').trim().toLowerCase();
      if (!key || vistos.has(key)) continue;
      vistos.add(key);
      out.push(cat);
    }
    return out;
  })();

  const handleAddCobertura = () => {
    if (cobSelector === '__custom__') {
      if (!nuevaCobertura.trim()) return;
      setPolizaCoberturas(prev => [...prev, {
        cobertura_id: null, nombre: nuevaCobertura.trim(),
        tipo_limite: 'limite', suma_asegurada: '',
        incluida: true, es_personalizada: true,
        tiene_deducible: false, deducible_tipo: 'evento',
        ded_por_persona: '', ded_por_evento: '', ded_pct: '', ded_minimo: '', ded_personalizado: '',
        otros: '', expanded: true,
      }]);
    } else if (cobSelector) {
      const cat = coberturasCatalogo.find(c => String(c.id) === String(cobSelector));
      if (!cat) return;
      if (polizaCoberturas.some(pc => String(pc.cobertura_id) === String(cat.id))) return;
      setPolizaCoberturas(prev => [...prev, { ...newCobFromTemplate(cat), incluida: true, expanded: true }]);
    } else { return; }
    setNuevaCobertura(''); setCobSelector(''); setShowAddCob(false);
  };

  const handleRemoveCobertura = (idx) => {
    setPolizaCoberturas(prev => prev.filter((_, i) => i !== idx));
  };

  // Lee la carátula de la póliza con IA y AUTOCOMPLETA el formulario (número, fechas,
  // prima, partes, vehículo, coberturas...). El usuario siempre revisa antes de guardar
  // (y puede llenarlo manual). Aseguradora/ramo detectados se muestran solo como
  // referencia: esos se eligen a mano (mapearlos automático es frágil).
  const cargarPolizaIA = async (file) => {
    if (!file) return;
    setLeyendoPolizaIA(true); setIaPolizaInfo(null);
    try {
      const res = await analizarPolizaIA(file);
      if (!res.ok) { alert(res.error); return; }
      const d = res.datos || {};
      const set = (k, v) => { if (v != null && String(v).trim() !== '') f(k, String(v).trim()); };

      // ── Aseguradora / ramo / subramo: se emparejan contra los catálogos ────
      // PRIMERO (handleRamoChange limpia coberturas y setea catálogo/comisión);
      // después van los escalares y las coberturas de la IA.
      const ramoMatch = matchCatalogo([d.ramo, d.subramo].filter(Boolean).join(' '), ramos) || matchCatalogo(d.ramo, ramos);
      let cobsCat = [];
      if (ramoMatch) {
        await handleRamoChange(String(ramoMatch.id));
        const { data: cc } = await supabase.from('coberturas').select('*').eq('ramo_id', ramoMatch.id).eq('activa', true);
        cobsCat = cc || [];
        if (d.subramo) {
          const sub = matchCatalogo(d.subramo, allSubramos.filter(s => String(s.ramo_id) === String(ramoMatch.id)));
          if (sub) await handleSubramoChange(String(sub.id));
        }
      }
      const asegMatch = matchCatalogo(d.aseguradora, aseguradoras);
      if (asegMatch) {
        f('aseguradora_id', String(asegMatch.id));
        // Renovación colocada en OTRA aseguradora: renovación para nosotros, emisión NUEVA
        // para la compañía y sin arrastre de saldo (misma regla que convertir en Solicitudes).
        if (form.tipo === 'renovacion' && form.poliza_anterior_id) {
          const { data: ant } = await supabase.from('polizas').select('aseguradora_id')
            .eq('id', form.poliza_anterior_id).maybeSingle();
          if (ant?.aseguradora_id) {
            const otraCia = String(ant.aseguradora_id) !== String(asegMatch.id);
            f('tipo_emision', otraCia ? 'nueva' : 'renovada');
            f('arrastra_saldo', !otraCia);
          }
        }
        // Comisión del vínculo aseguradora-ramo (con los IDs recién emparejados,
        // sin depender del estado del form que aún no se actualizó).
        if (ramoMatch) {
          const { data: link } = await supabase.from('aseguradora_ramos')
            .select('comision').eq('aseguradora_id', asegMatch.id).eq('ramo_id', ramoMatch.id).maybeSingle();
          if (link?.comision != null) f('comision_ramo', String(link.comision));
        }
      }

      set('numero', d.numero_poliza);
      set('fecha_inicio', d.fecha_inicio);
      set('fecha_vencimiento', d.fecha_vencimiento);
      set('fecha_emision', d.fecha_emision);
      if (d.impuesto_pct != null) set('impuesto', d.impuesto_pct);
      // Prima neta (ya con descuentos), cuadrada contra el total con impuesto.
      // El % por defecto sale del ramo emparejado (el form aún no se actualizó).
      const impRamo = ramoMatch ? (ramoMatch.nombre?.toLowerCase().includes('auto') ? 6 : 5) : parseFloat(form.impuesto || 5);
      const pn = primaNetaIA(d, impRamo);
      if (pn.prima != null) set('prima', pn.prima);
      if (['mensual','bimensual','trimestral','semestral','anual'].includes(d.frecuencia_pago)) {
        f('frecuencia_pago', d.frecuencia_pago);
        if (d.num_cuotas != null) set('num_cuotas', d.num_cuotas);
      }
      set('descripcion_riesgo', d.descripcion_riesgo);
      set('asegurado_nombre', d.asegurado_nombre);
      set('asegurado_cedula', d.asegurado_cedula);
      set('beneficiario_nombre', d.beneficiario_nombre);
      set('tomador_nombre', d.contratante_nombre);
      set('monto_afianzado', d.monto_afianzado);
      set('tarifa_fianza', d.tarifa_fianza);
      // Vehículo (si la póliza es de auto): llena la primera unidad.
      if (d.vehiculo && (d.vehiculo.marca || d.vehiculo.no_motor)) {
        const v = d.vehiculo;
        const unidad = {
          ...EMPTY_AUTO,
          anio: v.anio != null ? String(v.anio) : '', marca: v.marca || '', modelo: v.modelo || '',
          color: v.color || '', no_motor: v.no_motor || '',
          chasis: v.chasis || '', chasis_igual_motor: !!(v.chasis && v.no_motor && v.chasis === v.no_motor),
          placa: v.placa || '', placa_por_reportar: !v.placa,
        };
        setAutoForm(unidad);
        setAutoList(prev => { const arr = [...prev]; arr[0] = { ...arr[0], ...unidad }; return arr; });
      }
      // Coberturas de la carátula: matchea el catálogo del ramo por nombre; si no, personalizada.
      if (Array.isArray(d.coberturas) && d.coberturas.length) {
        const catCobs = cobsCat.length ? cobsCat : coberturasCatalogo;
        const nuevas = d.coberturas.filter(c => c && c.nombre).map(c => {
          const cat = catCobs.find(x => x.nombre && x.nombre.toLowerCase() === c.nombre.toLowerCase());
          const base = cat ? { ...newCobFromTemplate(cat) } : {
            cobertura_id: null, nombre: c.nombre, tipo_limite: 'limite', suma_asegurada: '',
            incluida: true, es_personalizada: true, tiene_deducible: false, deducible_tipo: 'evento',
            ded_por_persona: '', ded_por_evento: '', ded_pct: '', ded_minimo: '', ded_personalizado: '', otros: '',
          };
          return {
            ...base, incluida: true, expanded: false,
            suma_asegurada: c.suma_asegurada != null ? String(c.suma_asegurada) : base.suma_asegurada,
            ...(c.deducible ? { tiene_deducible: true, deducible_tipo: 'personalizado', ded_personalizado: String(c.deducible) } : {}),
          };
        });
        setPolizaCoberturas(prev => {
          const yaHay = new Set(prev.map(p => (p.nombre || '').toLowerCase()));
          return [...prev, ...nuevas.filter(n => !yaHay.has((n.nombre || '').toLowerCase()))];
        });
      }
      setIaPolizaInfo({ aseguradora: d.aseguradora || null, ramo: d.ramo || null, avisoPrima: pn.aviso });
    } finally {
      setLeyendoPolizaIA(false);
      if (polizaIAFileRef.current) polizaIAFileRef.current.value = '';
    }
  };

  // Si una cobertura tiene límite "por persona / por accidente" (auto: LC/DPA/GM con nivel),
  // devuelve { persona, accidente }. Toma primero el nivel elegido; si no, interpreta el texto guardado.
  const nivelBreakdown = (c) => {
    if (c.nivel_limite_id) {
      const op = autoLimiteOpciones.find(o => String(o.id) === String(c.nivel_limite_id));
      if (op && op.limite_persona != null && op.limite_accidente != null)
        return { persona: op.limite_persona, accidente: op.limite_accidente };
    }
    return detectAutoTipo(c.nombre) ? parsePersonaAccidente(c.otros) : null;
  };

  // ── Crear cliente ────────────────────────────────────────────────
  const handleGuardarCliente = async () => {
    const nombre = buildNombre(cliForm);
    if (cliForm.tipo === 'natural' && (!cliForm.primer_nombre.trim() || !cliForm.primer_apellido.trim()))
      return alert('Primer nombre y primer apellido son requeridos.');
    if (cliForm.tipo === 'juridica' && !cliForm.nombre.trim())
      return alert('La razón social es requerida.');
    try {
      setSavingCli(true);
      const nuevo = await insertRow('clientes', { ...cliForm, nombre });
      await loadCatalogos();
      f('cliente_id', nuevo.id);
      setShowCrearCliente(false);
    } catch (e) { alert('Error: ' + (e.message || '')); } finally { setSavingCli(false); }
  };

  // ── Crear aseguradora ────────────────────────────────────────────
  const handleGuardarAseg = async () => {
    if (!asegForm.nombre.trim()) return alert('El nombre es requerido.');
    try {
      setSavingAseg(true);
      const nueva = await insertRow('aseguradoras', { ...asegForm, activa: true });
      await loadCatalogos();
      f('aseguradora_id', nueva.id);
      setShowCrearAseg(false); setAsegForm(EMPTY_ASEG);
    } catch (e) { alert('Error: ' + (e.message || '')); } finally { setSavingAseg(false); }
  };

  // ── Abrir modales ────────────────────────────────────────────────
  const openCreate = () => {
    setForm(EMPTY); setPolizaAgentes([]); setPolizaCoberturas([]); setCoberturasCatalogo([]);
    setCobSelector(''); setShowAddCob(false);
    setComisionRamoBase(null); setEjecutivoBase(null);
    setAgenteSelector(''); setIsAuto(false); setAutoForm(EMPTY_AUTO); setAutoList([{ ...EMPTY_AUTO }]); setSubramos([]);
    loadCatalogos(); setMotivoCambio(''); cobsBaseRef.current = ''; setModal('create');
  };

  const openEdit = async (r) => {
    // Candado: póliza bloqueada + usuario no-master → solo edición administrativa.
    if (r?.bloqueada_edicion && !user?.es_master) return openAdminEdit(r);
    setSelected(r);
    setForm({
      numero: r.numero || '', cliente_id: r.cliente_id || '',
      aseguradora_id: r.aseguradora_id || '', ramo_id: r.ramo_id || '',
      subramo_id: r.subramo_id || '',
      ejecutivo_id: r.ejecutivo_id || '',
      ejecutivo_cobro_id: r.ejecutivo_cobro_id || '',
      ejecutivo_reclamo_id: r.ejecutivo_reclamo_id || '',
      tipo: r.tipo || 'nueva', tipo_emision: r.tipo_emision || 'nueva',
      estado: r.estado || 'activa',
      prima: r.prima || '', fecha_inicio: r.fecha_inicio || '',
      fecha_vencimiento: r.fecha_vencimiento || '', fecha_emision: r.fecha_emision || '',
      notas: r.notas || '',
      impuesto: r.impuesto != null ? String(r.impuesto) : '5',
      comision_ramo: r.comision_ramo != null ? String(r.comision_ramo) : '',
      forma_pago: r.forma_pago || '',
      frecuencia_pago: r.frecuencia_pago || 'mensual',
      num_cuotas: r.num_cuotas ? String(r.num_cuotas) : '1',
      facturacion_modo: r.facturacion_modo || 'cuotas',
      periodo_frecuencia: r.periodo_frecuencia || 'mensual',
      declarativa_modo: r.declarativa_modo || '',
      gastos_expedicion: r.gastos_expedicion != null ? String(r.gastos_expedicion) : '',
      participacion: r.participacion != null ? String(r.participacion) : '',
      descripcion_riesgo: r.descripcion_riesgo || '',
      beneficiario_nombre: r.beneficiario_nombre || '',
      beneficiario_cedula: r.beneficiario_cedula || '',
      beneficiario_oneroso: r.beneficiario_oneroso || false,
      asegurado_nombre: r.asegurado_nombre || '',
      asegurado_cedula: r.asegurado_cedula || '',
      tomador_nombre: r.tomador_nombre || '',
      tomador_cedula: r.tomador_cedula || '',
      // El selector se pobla del MAPA (renovacion_de_poliza_id) o, si es viejo, de poliza_anterior_id.
      // arrastra_saldo = si había poliza_anterior_id (arrastraba) — para las "póliza nueva" queda desmarcado.
      poliza_anterior_id: (r.poliza_anterior_id || r.renovacion_de_poliza_id) ? String(r.poliza_anterior_id || r.renovacion_de_poliza_id) : '',
      arrastra_saldo: r.poliza_anterior_id != null || (r.renovacion_de_poliza_id == null),
      es_fee: r.es_fee || false,
      monto_fee: r.monto_fee != null ? String(r.monto_fee) : '',
      sobrecomision_tipo: r.sobrecomision_tipo || '',
      sobrecomision_valor: r.sobrecomision_valor != null ? String(r.sobrecomision_valor) : '',
      sobrecomision_reparto: r.sobrecomision_reparto || 'ru',
      es_declarativa: r.es_declarativa || false,
      modalidad_declarativa: r.modalidad_declarativa || '',
      arquitectura: r.arquitectura || '',
      tasa: r.tasa != null ? String(r.tasa) : '',
      tasa_unidad: r.tasa_unidad || 'por_mil',
      tasa_guerra: r.tasa_guerra != null ? String(r.tasa_guerra) : '',
      prima_deposito: r.prima_deposito != null ? String(r.prima_deposito) : '',
      prima_minima: r.prima_minima != null ? String(r.prima_minima) : '',
      deposito_es_ganado: r.deposito_es_ganado || false,
      suma_maxima: r.suma_maxima != null ? String(r.suma_maxima) : '',
      suma_total: r.suma_total != null ? String(r.suma_total) : '',
      periodicidad_declaracion: r.periodicidad_declaracion || 'mensual',
      base_valuacion: r.base_valuacion || '',
      factor_valuacion: r.factor_valuacion != null ? String(r.factor_valuacion) : '1.10',
      es_fianza: r.es_fianza || false,
      monto_afianzado: r.monto_afianzado != null ? String(r.monto_afianzado) : '',
      tarifa_fianza: r.tarifa_fianza != null ? String(r.tarifa_fianza) : '',
      beneficiario_fianza: r.beneficiario || '',
      referido_id: r.referido_id != null ? String(r.referido_id) : '',
      referido_comision_pct: r.referido_comision_pct != null ? String(r.referido_comision_pct) : '',
    });

    const autoRamo = r.ramos?.nombre?.toLowerCase().includes('auto') ||
      ramos.find(rm => rm.id === r.ramo_id)?.nombre?.toLowerCase().includes('auto');
    setIsAuto(!!autoRamo);

    if (r.ramo_id) {
      setSubramos(allSubramos.filter(s => String(s.ramo_id) === String(r.ramo_id)));
    }

    const [{ data: pAgentes }, { data: pCobs }, { data: ramo }, { data: autoData }, { data: pagosAplicados }] = await Promise.all([
      supabase.from('poliza_agentes').select('*, agentes(nombre, comision_nueva_agente, comision_renovacion_agente)').eq('poliza_id', r.id),
      supabase.from('poliza_coberturas').select('*').eq('poliza_id', r.id),
      r.ramo_id ? supabase.from('ramos').select('comision').eq('id', r.ramo_id).single() : Promise.resolve({ data: null }),
      supabase.from('poliza_autos').select('*').eq('poliza_id', r.id).maybeSingle(),
      supabase.from('pagos').select('id').eq('poliza_id', r.id).eq('estado', 'pagado').limit(1),
    ]);
    setTienePagosAplicados((pagosAplicados || []).length > 0);
    // ¿Flota? (más de un vehículo) → los vehículos se editan por endoso, no en este form.
    const { count: nVeh } = await supabase.from('poliza_autos')
      .select('id', { count: 'exact', head: true }).eq('poliza_id', r.id);
    setPolTieneFlota((nVeh || 0) > 1);
    const cobDescMap = await fetchCoberturaDescripciones((pCobs || []).map(c => c.cobertura_id));

    setComisionRamoBase(ramo?.data?.comision ?? null);
    if (r.cliente_id) {
      const cli = clientes.find(c => String(c.id) === String(r.cliente_id));
      setEjecutivoBase(cli?.ejecutivo_id ?? null);
    }

    setPolizaAgentes((pAgentes || []).map(a => {
      const isManual      = a.comision_manual || false;
      const tasaActual    = r.tipo === 'renovacion'
        ? a.agentes?.comision_renovacion_agente
        : a.agentes?.comision_nueva_agente;
      // Si es General → mostrar tasa actual del agente (no el valor congelado en DB)
      // Si es Manual → mostrar el valor guardado en DB
      const pctMostrar = isManual
        ? String(a.porcentaje)
        : (tasaActual != null ? String(tasaActual) : String(a.porcentaje));
      return {
        agente_id: a.agente_id, nombre: a.agentes?.nombre || '',
        porcentaje: pctMostrar,
        comision_negociada: tasaActual,
        comision_manual: isManual,
      };
    }));

    // Catálogo del ramo para el selector "Agregar cobertura"
    const { data: catalogoCobs } = r.ramo_id
      ? await supabase.from('coberturas').select('*').eq('ramo_id', r.ramo_id).eq('activa', true).order('orden').order('nombre')
      : { data: [] };
    setCoberturasCatalogo(catalogoCobs || []);
    setCobSelector(''); setShowAddCob(false);

    // La lista de la póliza muestra SOLO las coberturas a NIVEL de póliza (sin vehículo).
    // Las coberturas POR UNIDAD (poliza_auto_id) se gestionan por endoso, no aquí.
    const cobsPolizaEd = (pCobs || []).filter(c => !c.poliza_auto_id);
    cobsBaseRef.current = firmaCoberturas(cobsPolizaEd);
    if (cobsPolizaEd.length > 0) {
      setPolizaCoberturas(cobsPolizaEd.map(c => {
        // Reconstruir el nivel elegido (auto LC/DPA/GM) a partir de la etiqueta guardada,
        // para que el selector de nivel y el desglose persona/accidente se muestren.
        const tipoAuto = detectAutoTipo(c.nombre);
        const opNivel = tipoAuto
          ? autoLimiteOpciones.find(o => o.tipo === tipoAuto && (o.etiqueta || '') === (c.otros || ''))
          : null;
        // Parse stored deducible text back to structure (best effort)
        return {
          cobertura_id: c.cobertura_id,
          nombre: c.nombre,
          descripcion: cobDescMap[c.cobertura_id] || '',
          tipo_limite: c.tipo_limite || 'limite',
          suma_asegurada: c.suma_asegurada != null ? String(c.suma_asegurada) : '',
          nivel_limite_id: opNivel ? String(opNivel.id) : undefined,
          incluida: true, es_personalizada: !c.cobertura_id,
          tiene_deducible: !!c.deducible,
          deducible_tipo: 'personalizado',
          ded_por_persona: '', ded_por_evento: '', ded_pct: '', ded_minimo: '',
          ded_personalizado: c.deducible || '',
          otros: c.otros || '', expanded: false,
        };
      }));
    } else { setPolizaCoberturas([]); }

    if (autoData) {
      setAutoForm({
        anio: autoData.anio ? String(autoData.anio) : '',
        marca: autoData.marca || '', modelo: autoData.modelo || '',
        color: autoData.color || '', tipo_vehiculo: autoData.tipo_vehiculo || '',
        pasajeros: autoData.pasajeros ? String(autoData.pasajeros) : '',
        no_motor: autoData.no_motor || '',
        chasis: autoData.chasis || '', chasis_igual_motor: autoData.chasis_igual_motor ?? true,
        placa: autoData.placa || '', placa_por_reportar: autoData.placa_por_reportar ?? false,
        dueno_nombre: autoData.dueno_nombre || '', dueno_cedula: autoData.dueno_cedula || '',
        dueno_igual: !(autoData.dueno_nombre || autoData.dueno_cedula),
      });
    } else { setAutoForm(EMPTY_AUTO); }

    setAgenteSelector(''); loadCatalogos(); setMotivoCambio(''); setModal('edit');
  };

  const openRenovar = async (r) => {
    const addYear = (dateStr) => {
      if (!dateStr) return '';
      const d = new Date(dateStr + 'T12:00:00');
      d.setFullYear(d.getFullYear() + 1);
      return d.toISOString().slice(0, 10);
    };

    setForm({
      numero: r.numero || '',
      cliente_id: r.cliente_id || '',
      aseguradora_id: r.aseguradora_id || '',
      ramo_id: r.ramo_id || '',
      subramo_id: r.subramo_id || '',
      ejecutivo_id: r.ejecutivo_id || '',
      ejecutivo_cobro_id: r.ejecutivo_cobro_id || '',
      ejecutivo_reclamo_id: r.ejecutivo_reclamo_id || '',
      tipo: 'renovacion',
      tipo_emision: 'renovada',
      estado: 'activa',
      prima: r.prima || '',
      fecha_inicio: addYear(r.fecha_inicio),
      fecha_vencimiento: addYear(r.fecha_vencimiento),
      fecha_emision: '',
      notas: '',
      impuesto: r.impuesto != null ? String(r.impuesto) : '5',
      comision_ramo: r.comision_ramo != null ? String(r.comision_ramo) : '',
      forma_pago: r.forma_pago || '',
      frecuencia_pago: r.frecuencia_pago || 'mensual',
      num_cuotas: r.num_cuotas ? String(r.num_cuotas) : '1',
      facturacion_modo: r.facturacion_modo || 'cuotas',
      periodo_frecuencia: r.periodo_frecuencia || 'mensual',
      declarativa_modo: r.declarativa_modo || '',
      gastos_expedicion: r.gastos_expedicion != null ? String(r.gastos_expedicion) : '',
      participacion: r.participacion != null ? String(r.participacion) : '',
      descripcion_riesgo: r.descripcion_riesgo || '',
      beneficiario_nombre: r.beneficiario_nombre || '',
      beneficiario_cedula: r.beneficiario_cedula || '',
      beneficiario_oneroso: r.beneficiario_oneroso || false,
      asegurado_nombre: r.asegurado_nombre || '',
      asegurado_cedula: r.asegurado_cedula || '',
      tomador_nombre: r.tomador_nombre || '',
      tomador_cedula: r.tomador_cedula || '',
      poliza_anterior_id: String(r.id),
      es_fee: r.es_fee || false,
      monto_fee: r.monto_fee != null ? String(r.monto_fee) : '',
      sobrecomision_tipo: r.sobrecomision_tipo || '',
      sobrecomision_valor: r.sobrecomision_valor != null ? String(r.sobrecomision_valor) : '',
      sobrecomision_reparto: r.sobrecomision_reparto || 'ru',
      es_declarativa: r.es_declarativa || false,
      modalidad_declarativa: r.modalidad_declarativa || '',
      arquitectura: r.arquitectura || '',
      tasa: r.tasa != null ? String(r.tasa) : '',
      tasa_unidad: r.tasa_unidad || 'por_mil',
      tasa_guerra: r.tasa_guerra != null ? String(r.tasa_guerra) : '',
      prima_deposito: r.prima_deposito != null ? String(r.prima_deposito) : '',
      prima_minima: r.prima_minima != null ? String(r.prima_minima) : '',
      deposito_es_ganado: r.deposito_es_ganado || false,
      suma_maxima: r.suma_maxima != null ? String(r.suma_maxima) : '',
      suma_total: r.suma_total != null ? String(r.suma_total) : '',
      periodicidad_declaracion: r.periodicidad_declaracion || 'mensual',
      base_valuacion: r.base_valuacion || '',
      factor_valuacion: r.factor_valuacion != null ? String(r.factor_valuacion) : '1.10',
      es_fianza: r.es_fianza || false,
      monto_afianzado: r.monto_afianzado != null ? String(r.monto_afianzado) : '',
      tarifa_fianza: r.tarifa_fianza != null ? String(r.tarifa_fianza) : '',
      beneficiario_fianza: r.beneficiario || '',
      referido_id: r.referido_id != null ? String(r.referido_id) : '',
      referido_comision_pct: r.referido_comision_pct != null ? String(r.referido_comision_pct) : '',
    });

    const autoRamo = r.ramos?.nombre?.toLowerCase().includes('auto') ||
      ramos.find(rm => rm.id === r.ramo_id)?.nombre?.toLowerCase().includes('auto');
    setIsAuto(!!autoRamo);

    if (r.ramo_id) {
      setSubramos(allSubramos.filter(s => String(s.ramo_id) === String(r.ramo_id)));
    }

    const [{ data: pAgentes }, { data: pCobs }, { data: ramoData }, { data: autoData }] = await Promise.all([
      supabase.from('poliza_agentes').select('*, agentes(nombre, comision_nueva_agente, comision_renovacion_agente)').eq('poliza_id', r.id),
      supabase.from('poliza_coberturas').select('*').eq('poliza_id', r.id),
      r.ramo_id ? supabase.from('ramos').select('comision').eq('id', r.ramo_id).single() : Promise.resolve({ data: null }),
      supabase.from('poliza_autos').select('*').eq('poliza_id', r.id).order('id'),
    ]);
    const cobDescMap = await fetchCoberturaDescripciones((pCobs || []).map(c => c.cobertura_id));

    setComisionRamoBase(ramoData?.data?.comision ?? null);
    if (r.cliente_id) {
      const cli = clientes.find(c => String(c.id) === String(r.cliente_id));
      setEjecutivoBase(cli?.ejecutivo_id ?? null);
    }

    setPolizaAgentes((pAgentes || []).map(a => {
      const isManual = a.comision_manual || false;
      const tasaRenovacion = a.agentes?.comision_renovacion_agente;
      const pctMostrar = isManual
        ? String(a.porcentaje)
        : (tasaRenovacion != null ? String(tasaRenovacion) : String(a.porcentaje));
      return {
        agente_id: a.agente_id, nombre: a.agentes?.nombre || '',
        porcentaje: pctMostrar,
        comision_negociada: tasaRenovacion,
        comision_manual: isManual,
      };
    }));

    // Catálogo del ramo para el selector "Agregar cobertura"
    const { data: catalogoCobs } = r.ramo_id
      ? await supabase.from('coberturas').select('*').eq('ramo_id', r.ramo_id).eq('activa', true).order('orden').order('nombre')
      : { data: [] };
    setCoberturasCatalogo(catalogoCobs || []);
    setCobSelector(''); setShowAddCob(false);

    // Coberturas a NIVEL de póliza (sin vehículo). Las por unidad se copian al vehículo abajo.
    const cobsPoliza = (pCobs || []).filter(c => !c.poliza_auto_id);
    if (cobsPoliza.length > 0) {
      setPolizaCoberturas(cobsPoliza.map(c => {
        const tipoAuto = detectAutoTipo(c.nombre);
        const opNivel = tipoAuto
          ? autoLimiteOpciones.find(o => o.tipo === tipoAuto && (o.etiqueta || '') === (c.otros || ''))
          : null;
        return {
          cobertura_id: c.cobertura_id,
          nombre: c.nombre,
          descripcion: cobDescMap[c.cobertura_id] || '',
          tipo_limite: c.tipo_limite || 'limite',
          suma_asegurada: c.suma_asegurada != null ? String(c.suma_asegurada) : '',
          nivel_limite_id: opNivel ? String(opNivel.id) : undefined,
          incluida: true, es_personalizada: !c.cobertura_id,
          tiene_deducible: !!c.deducible,
          deducible_tipo: 'personalizado',
          ded_por_persona: '', ded_por_evento: '', ded_pct: '', ded_minimo: '',
          ded_personalizado: c.deducible || '',
          otros: c.otros || '', expanded: false,
        };
      }));
    } else { setPolizaCoberturas([]); }

    // Renovación: se copian TODAS las unidades de la vigencia anterior (flota) con sus
    // coberturas por unidad.
    const cobsPorAutoRen = {};
    (pCobs || []).filter(c => c.poliza_auto_id).forEach(c => { (cobsPorAutoRen[c.poliza_auto_id] = cobsPorAutoRen[c.poliza_auto_id] || []).push(c); });
    const autosArr = (autoData || []).map(a => ({
      anio: a.anio ? String(a.anio) : '',
      marca: a.marca || '', modelo: a.modelo || '',
      color: a.color || '', tipo_vehiculo: a.tipo_vehiculo || '',
      pasajeros: a.pasajeros ? String(a.pasajeros) : '',
      no_motor: a.no_motor || '',
      chasis: a.chasis || '', chasis_igual_motor: a.chasis_igual_motor ?? true,
      placa: a.placa_por_reportar ? '' : (a.placa || ''), placa_por_reportar: a.placa_por_reportar ?? false,
      dueno_nombre: a.dueno_nombre || '', dueno_cedula: a.dueno_cedula || '',
      dueno_igual: !(a.dueno_nombre || a.dueno_cedula),
      coberturas: (cobsPorAutoRen[a.id] || []).map(c => ({
        nombre: c.nombre || '', tipo_limite: c.tipo_limite || 'limite',
        suma_asegurada: c.suma_asegurada != null ? String(c.suma_asegurada) : '', deducible: c.deducible || '',
      })),
    }));
    setAutoList(autosArr.length ? autosArr : [{ ...EMPTY_AUTO }]);
    setAutoForm(EMPTY_AUTO);

    setSelected(null);
    setTienePagosAplicados(false);
    setAgenteSelector('');
    loadCatalogos();
    setModal('create');
  };

  // Carga los endosos de una póliza y les adjunta los documentos de su solicitud
  // (solicitud_archivos), para mostrarlos en la pestaña Endosos.
  const loadEndososPoliza = async (polizaId) => {
    const { data: endosos } = await supabase.from('poliza_endosos')
      .select('*').eq('poliza_id', polizaId).order('fecha', { ascending: false });
    const list = endosos || [];
    const solIds = [...new Set(list.map(e => e.solicitud_id).filter(Boolean))];
    const archMap = {};
    if (solIds.length) {
      const { data: archs } = await supabase.from('solicitud_archivos').select('*').in('solicitud_id', solIds);
      for (const a of (archs || [])) { (archMap[a.solicitud_id] = archMap[a.solicitud_id] || []).push(a); }
    }
    return list.map(e => ({ ...e, sol_archivos: e.solicitud_id ? (archMap[e.solicitud_id] || []) : [] }));
  };

  const openView = async (r) => {
    setSelected(r);
    setViewTab('info');
    setViewSolicitud(null);
    // Cadena de vigencias: las gestiones (cobro/renovación) pertenecen a la póliza
    // a través de TODAS sus vigencias (anterior + renovaciones), no solo a este registro.
    const { data: polSelf } = await supabase.from('polizas').select('id, poliza_anterior_id, renovacion_de_poliza_id').eq('id', r.id).maybeSingle();
    const anteriorId = polSelf?.poliza_anterior_id || null;
    // MAPA de renovación (renovacion_de_poliza_id) para MOSTRAR "renovó de X": se pone
    // siempre, incluso cuando la aseguradora emitió póliza nueva y NO se arrastra saldo
    // (poliza_anterior_id NULL). Fallback a poliza_anterior_id por compatibilidad con datos viejos.
    const mapaId = polSelf?.renovacion_de_poliza_id || anteriorId || null;
    if (mapaId) {
      const { data: prevPol } = await supabase.from('polizas').select('numero').eq('id', mapaId).maybeSingle();
      setViewPolizaAnterior(prevPol?.numero || null);
    } else { setViewPolizaAnterior(null); }
    // La CADENA de vigencias (gestiones/saco) sigue por poliza_anterior_id: una renovación
    // "póliza nueva" (sin arrastre) NO comparte cadena con la anterior.
    const chainIds = new Set([r.id]);
    if (anteriorId) chainIds.add(anteriorId);
    const orParts = [`poliza_anterior_id.eq.${r.id}`];
    if (anteriorId) orParts.push(`poliza_anterior_id.eq.${anteriorId}`);
    const { data: vigKids } = await supabase.from('polizas').select('id').or(orParts.join(','));
    (vigKids || []).forEach(k => chainIds.add(k.id));
    const chainArr = [...chainIds];
    // Para los endosos, además de la cadena de vigencias, incluir TODOS los registros que
    // comparten el mismo número de póliza (renovaciones con mismo número / duplicados no
    // enlazados por poliza_anterior_id). Así la solicitud de endoso aparece igual.
    const { data: sameNum } = r.numero
      ? await supabase.from('polizas').select('id').eq('numero', r.numero)
      : { data: [] };
    const endosoPolIds = [...new Set([...chainArr, ...((sameNum || []).map(p => p.id))])];
    const [agRes, cobRes, autoRes, pagRes, endosos, endSolRes] = await Promise.all([
      supabase.from('poliza_agentes').select('*, agentes(nombre)').eq('poliza_id', r.id),
      supabase.from('poliza_coberturas').select('*').eq('poliza_id', r.id).order('id'),
      supabase.from('poliza_autos').select('*').eq('poliza_id', r.id).order('id'),
      supabase.from('pagos').select('*').eq('poliza_id', r.id).order('fecha_vencimiento').order('cuota_num'),
      loadEndososPoliza(r.id),
      supabase.from('solicitudes').select('*')
        .eq('tipo', 'endoso').in('poliza_endoso_id', endosoPolIds)
        .not('estado', 'in', '(convertida,cancelada)').order('creado_en', { ascending: false }),
    ]);
    // "enviado_cliente" normalmente = ciclo cerrado (endoso ya registrado) → se oculta.
    // PERO si aún tiene cambios SIN facturar (se avanzó el ciclo sin registrar), se
    // muestra igual para poder rescatarla y registrar el endoso.
    setViewEndosoSolicitudes((endSolRes.data || []).filter(s => {
      if (s.estado !== 'enviado_cliente') return true;
      const cj = s.cambios_json;
      const lista = Array.isArray(cj) ? cj : (cj && typeof cj === 'object' ? [cj] : []);
      return lista.some(ch => ch && ch.estado !== 'facturado');
    }));
    // Solicitudes de endoso ELIMINADAS/CANCELADAS (con su motivo) — se muestran en la pestaña.
    const { data: endCancel } = await supabase.from('solicitudes')
      .select('id, tipo_endoso_id, notas, motivo_cancelacion, actualizado_en, creado_en')
      .eq('tipo', 'endoso').in('poliza_endoso_id', endosoPolIds).eq('estado', 'cancelada')
      .order('actualizado_en', { ascending: false });
    setViewEndosoCancelados(endCancel || []);
    // Gestiones de la póliza (toda la cadena de vigencias): se leen del log de tareas
    // del CRM (crm_historial), que es donde realmente queda registrada la gestión.
    // Dos pasos para evitar embeds frágiles: tareas de la cadena → su historial.
    const { data: gests } = await supabase.from('crm_gestiones').select('id, tipo').in('poliza_id', chainArr);
    const gTipo = {}; (gests || []).forEach(g => { gTipo[g.id] = g.tipo; });
    const gIds = (gests || []).map(g => g.id);
    let histRows = [];
    if (gIds.length) {
      const { data: h } = await supabase.from('crm_historial')
        .select('id, accion, detalle, creado_en, gestion_id, usuarios(nombre)')
        .in('gestion_id', gIds).order('creado_en', { ascending: false });
      histRows = (h || []).map(x => ({ ...x, _tipo: gTipo[x.gestion_id] }));
    }
    setViewBitacoraCobros(histRows.filter(g => g._tipo === 'cobro'));
    setViewBitacoraPolizas(histRows.filter(g => g._tipo !== 'cobro'));
    setViewAgentes(agRes.data || []);
    const cobRows = cobRes.data || [];
    const viewDescMap = await fetchCoberturaDescripciones(cobRows.map(c => c.cobertura_id));
    const cobEnriched = cobRows.map(c => ({ ...c, _descripcion: viewDescMap[c.cobertura_id] || '' }));
    // Coberturas a nivel de póliza (sin vehículo) vs por unidad (con poliza_auto_id).
    setViewCoberturas(cobEnriched.filter(c => !c.poliza_auto_id));
    const cobsPorAuto = {};
    cobEnriched.filter(c => c.poliza_auto_id).forEach(c => { (cobsPorAuto[c.poliza_auto_id] = cobsPorAuto[c.poliza_auto_id] || []).push(c); });
    const autosArr = (autoRes.data || []).map(a => ({ ...a, _coberturas: cobsPorAuto[a.id] || [] }));
    setViewAutos(autosArr);
    setViewPagos(pagRes.data || []);
    setViewEndosos(endosos || []);
    // Reclamos de toda la cadena de vigencias (anterior + renovaciones), no solo este registro.
    const { data: recl } = await supabase.from('reclamos')
      .select('id, numero, numero_aseguradora, estado, motivo_cierre, descripcion, fecha_siniestro, monto_reclamado, monto_aprobado, poliza_id')
      .in('poliza_id', chainArr).order('fecha_siniestro', { ascending: false });
    setViewReclamos(recl || []);
    // Períodos de facturación (solo modo periódico) + documentos de respaldo ligados a
    // cada período (factura de la aseguradora, etc.) y los tipos de documento de póliza.
    if (r.facturacion_modo === 'periodica') {
      const [{ data: pers }, { data: pdocs }, { data: tdocs }] = await Promise.all([
        supabase.from('poliza_periodos').select('*').eq('poliza_id', r.id).order('periodo_inicio', { ascending: false }),
        supabase.from('documentos').select('id, nombre_archivo, storage_path, periodo_id, tipos_documento(nombre)')
          .eq('poliza_id', r.id).not('periodo_id', 'is', null).eq('activo', true),
        supabase.from('tipos_documento').select('id, nombre, codigo').eq('categoria', 'poliza').eq('activo', true).order('orden'),
      ]);
      setViewPeriodos(pers || []);
      setViewPeriodoDocs(pdocs || []);
      setTiposDocPoliza(tdocs || []);
    } else { setViewPeriodos([]); setViewPeriodoDocs([]); setTiposDocPoliza([]); }
    // Unidades genéricas (ubicación / equipo / asegurado) de la póliza.
    const { data: unids } = await supabase.from('poliza_unidades')
      .select('*').eq('poliza_id', r.id).order('id');
    setViewUnidades(unids || []);
    if (r.solicitud_id) {
      const { data: sol } = await supabase.from('solicitudes')
        .select('*, clientes(nombre), ramos(nombre), aseguradoras(nombre)').eq('id', r.solicitud_id).single();
      setViewSolicitud(sol || null);
      const { data: arch } = await supabase.from('solicitud_archivos')
        .select('*').eq('solicitud_id', r.solicitud_id).order('creado_en');
      setViewArchivosSol(arch || []);
    }
    setModal('view');
  };

  // ── Endosos desde la póliza: reusan el flujo probado de Solicitudes ──
  // Crear solicitud de endoso → abre Solicitudes con el formulario de endoso prellenado.
  const irACrearEndoso = (poliza) => {
    sessionStorage.setItem('nuevoEndosoPolizaId', String(poliza.id));
    sessionStorage.setItem('backFrom', 'polizas');
    closeModal();
    navigate('/solicitudes');
  };
  // Facturar una solicitud de endoso recibida → abre esa solicitud en Solicitudes (modal Registrar Endoso).
  const irAFacturarEndoso = (solicitudId) => {
    sessionStorage.setItem('openSolicitudId', String(solicitudId));
    sessionStorage.setItem('backFrom', 'polizas');
    closeModal();
    navigate('/solicitudes');
  };

  // ── Edición administrativa de una póliza BLOQUEADA (usuario no-master) ──
  // Solo campos que NO son de riesgo: ejecutivos, referido y notas. Todo lo demás
  // (prima, vigencia, coberturas, vehículo, forma de pago…) se cambia por endoso.
  const openAdminEdit = (r) => {
    setSelected(r);
    setAdminForm({
      ejecutivo_id: r.ejecutivo_id || '',
      ejecutivo_cobro_id: r.ejecutivo_cobro_id || '',
      ejecutivo_reclamo_id: r.ejecutivo_reclamo_id || '',
      referido_id: r.referido_id != null ? String(r.referido_id) : '',
      referido_comision_pct: r.referido_comision_pct != null ? String(r.referido_comision_pct) : '',
      notas: r.notas || '',
    });
    loadCatalogos();
    setAdminModal(r);
  };
  const afk = (k, v) => setAdminForm(p => ({ ...p, [k]: v }));
  const closeAdminModal = () => { setAdminModal(null); setAdminForm(null); setSelected(null); };
  const handleSaveAdmin = async () => {
    if (savingAdmin || !adminModal) return;
    setSavingAdmin(true);
    try {
      // Rastro también aquí: son datos administrativos (no mueven prima ni cobertura, por
      // eso no piden motivo), pero cambiar a quién se le acredita un referido o quién es el
      // ejecutivo de cuenta sí tiene consecuencias. Antes no quedaba registrado.
      const difsAdmin = cambiosDePoliza(adminForm, adminModal);
      await updateRow('polizas', adminModal.id, {
        ejecutivo_id: adminForm.ejecutivo_id ? parseInt(adminForm.ejecutivo_id) : null,
        ejecutivo_cobro_id: adminForm.ejecutivo_cobro_id ? parseInt(adminForm.ejecutivo_cobro_id) : null,
        ejecutivo_reclamo_id: adminForm.ejecutivo_reclamo_id ? parseInt(adminForm.ejecutivo_reclamo_id) : null,
        referido_id: adminForm.referido_id ? parseInt(adminForm.referido_id) : null,
        // El % del referido NO se edita aquí: mueve dinero, así que lleva el mismo
        // candado que comision_ramo (solo el master, por edición directa). Solo se
        // limpia si se quita el referido, para no dejar un % sin a quién pagarle.
        ...(adminForm.referido_id ? {} : { referido_comision_pct: null }),
        notas: adminForm.notas || null,
        actualizado_en: new Date().toISOString(),
      });
      if (difsAdmin.length) {
        try {
          await insertRow('bitacora_polizas', {
            poliza_id: adminModal.id, usuario_id: user?.id, tipo: 'edicion_directa',
            nota: `✏️ Edición de datos administrativos — ${detalleCambios(difsAdmin)}`,
          });
        } catch { /* la bitácora no debe bloquear el guardado */ }
      }
      closeAdminModal();
      await load();
    } catch (e) { alert('Error al guardar: ' + (e.message || e)); }
    finally { setSavingAdmin(false); }
  };

  // ── Endoso INTERNO: cambio interno de la póliza (la aseguradora NO envía documento) ──
  // Fuera del ciclo normal (no va al CRM ni al cliente). Se registra y se aplica directo,
  // con snapshot para reversar. Puede mover prima con la misma mecánica del endoso normal.
  const openEndosoInterno = (poliza) => {
    setEiForm({
      descripcion: '', delta_prima: '',
      fecha: new Date().toISOString().slice(0, 10), numero_endoso: '', cambiosList: [],
    });
    loadCatalogos();
    setEiModal(poliza);
  };
  const eif = (k, v) => setEiForm(p => ({ ...p, [k]: v }));
  const closeEndosoInterno = () => { setEiModal(null); setEiForm(null); };
  const handleGuardarEndosoInterno = async () => {
    if (savingEI || !eiForm || !eiModal) return;
    const cambiosList = (eiForm.cambiosList || []).filter(ch => ch.tipo_endoso_id);
    if (!cambiosList.length) { alert('Agrega al menos un cambio (elige el tipo).'); return; }
    if (!eiForm.descripcion.trim()) { alert('Describe el cambio interno.'); return; }
    const delta = parseFloat(eiForm.delta_prima) || 0;
    setSavingEI(true);
    try {
      const polizaId = eiModal.id;
      // 1) Registrar el endoso interno (tipo del primer cambio, para tracking)
      const endoso = await insertRow('poliza_endosos', {
        poliza_id: polizaId,
        fecha: eiForm.fecha || new Date().toISOString().slice(0, 10),
        descripcion: eiForm.descripcion.trim(),
        numero_endoso: eiForm.numero_endoso || null,
        delta_prima: delta,
        es_interno: true,
        ...(cambiosList[0]?.tipo_endoso_id ? { tipo_endoso_id: parseInt(cambiosList[0].tipo_endoso_id) } : {}),
        estado: 'activo',
      });
      // 2) Aplicar TODOS los cambios estructurales + snapshots (lista) para reversar
      if (endoso?.id) {
        const snapshots = [];
        for (const ch of cambiosList) {
          const tCat = endosoTiposLista.find(t => String(t.id) === String(ch.tipo_endoso_id));
          const target = tCat?.target;
          if (target && targetAplica(target)) {
            snapshots.push(await aplicarCambioEndoso(polizaId, target, ch.cambios || {}));
          }
        }
        await updateRow('poliza_endosos', endoso.id, { cambios_json: cambiosList, cambios_snapshot: snapshots });
      }
      // 3) Prima (opcional) — misma mecánica que el endoso normal
      if (delta !== 0 && endoso?.id) {
        const imp = eiModal.impuesto == null ? 5 : eiModal.impuesto;
        await aplicarPrimaEndoso(polizaId, endoso.id, delta, { impuesto: imp, fechaDesde: eiForm.fecha, formaPago: eiModal.forma_pago, recurrenteMensual: !!eiForm.prima_recurrente_mensual });
      }
      // 4) Refrescar la vista si es la póliza abierta
      if (selected?.id === polizaId) {
        const [endosos, { data: pag }] = await Promise.all([
          loadEndososPoliza(polizaId),
          supabase.from('pagos').select('*').eq('poliza_id', polizaId).order('fecha_vencimiento').order('cuota_num'),
        ]);
        setViewEndosos(endosos || []);
        setViewPagos(pag || []);
      }
      closeEndosoInterno();
      await load();
      alert('✓ Endoso interno registrado y aplicado a la póliza.');
    } catch (e) {
      alert('Error al registrar el endoso interno: ' + (e.message || e));
    } finally {
      setSavingEI(false);
    }
  };

  // ── Cambio de prima mensual (salud): actualiza las cuotas PENDIENTES con vencimiento
  //    desde la fecha indicada al nuevo monto (lo que paga el cliente, con impuesto).
  //    Las pagadas no se tocan. Requiere adjuntar la notificación de la aseguradora (PDF).
  //    Queda registrado como endoso. El saco y las comisiones ya manejan cuotas de montos distintos.
  const guardarCambioPrima = async () => {
    const cp = cpModal;
    const monto = parseFloat(cp?.monto);
    if (!monto || monto <= 0) return alert('Ingresa la nueva mensualidad (lo que paga el cliente).');
    if (!cp.fecha) return alert('Indica desde qué fecha aplica el nuevo monto.');
    if (!cp.file)  return alert('Adjunta la notificación de la aseguradora (PDF) que indica el cambio.');
    setCpModal(p => ({ ...p, guardando: true }));
    try {
      // 1) Subir la notificación de la aseguradora
      const ext = cp.file.name.split('.').pop();
      const path = `polizas/${selected.id}/cambio_prima_${Date.now()}.${ext}`;
      const { error: upErr } = await supabase.storage.from('solicitud-archivos').upload(path, cp.file, { upsert: true });
      if (upErr) throw upErr;
      const { data: { publicUrl } } = supabase.storage.from('solicitud-archivos').getPublicUrl(path);
      // 2) Cuotas pendientes con vencimiento >= fecha efectiva (las pagadas/parciales no se tocan)
      const { data: cuotas } = await supabase.from('pagos')
        .select('id').eq('poliza_id', selected.id).eq('estado', 'pendiente').gte('fecha_vencimiento', cp.fecha);
      const ids = (cuotas || []).map(c => c.id);
      // 3) Registrar el endoso con la notificación adjunta (auditable)
      await insertRow('poliza_endosos', {
        poliza_id: selected.id,
        fecha: cp.fecha,
        descripcion: `Cambio de prima mensual a ${fmt$(monto)} desde ${cp.fecha} — ${ids.length} cuota(s) pendiente(s) actualizada(s). Notificación de la aseguradora adjunta.`,
        delta_prima: monto,
        url_documento: publicUrl,
        nombre_documento: cp.file.name,
        estado: 'activo',
      });
      // 4) Actualizar las cuotas pendientes futuras al nuevo monto
      if (ids.length) await supabase.from('pagos').update({ monto }).in('id', ids);
      // 5) Reaplicar el saco
      await reaplicarSacoPoliza(selected.id);
      // 6) Recargar plan de cobros + endosos de la vista
      const [{ data: pgs }, ends] = await Promise.all([
        supabase.from('pagos').select('*').eq('poliza_id', selected.id).order('fecha_vencimiento').order('cuota_num'),
        loadEndososPoliza(selected.id),
      ]);
      setViewPagos(pgs || []);
      setViewEndosos(ends || []);
      setCpModal(null);
      alert(`Listo: ${ids.length} cuota(s) actualizada(s) a ${fmt$(monto)} desde ${cp.fecha}.`);
    } catch (e) {
      alert('Error: ' + (e.message || e));
      setCpModal(p => ({ ...p, guardando: false }));
    }
  };

  // ── Registrar pago inline (pestaña Plan de Cobros) ──
  // Mismo motor que Cobros: inserta cobro_recibido, aplica saco a la cuota más antigua,
  // genera la comisión y redistribuye el saco. NO mapea por cuota_num — solo por saco.
  const handleRegistrarPago = async () => {
    if (savingPago || !selected) return;
    const monto = parseFloat(pagoForm.monto_recibido);
    if (!monto || monto <= 0) { alert('Ingresa un monto mayor a 0.'); return; }
    if (!pagoForm.fecha_pago_aseg) { alert('Ingresa la fecha del pago.'); return; }
    // Aviso (no bloqueante) si el recibo ya existe en esta póliza
    // (solo pagos en la aseguradora — en oficina el recibo lo genera el sistema)
    if (pagoForm.donde_pago !== 'RU' && pagoForm.num_recibo_aseg) {
      const { data: dup } = await supabase.from('cobros_recibidos')
        .select('id').eq('poliza_id', selected.id).eq('num_recibo_aseg', pagoForm.num_recibo_aseg)
        .or('anulado.is.null,anulado.eq.false').limit(1);
      if (dup && dup.length && !window.confirm('Ya existe un cobro con ese número de recibo en esta póliza. ¿Registrar de todas formas?')) return;
    }
    setSavingPago(true);
    try {
      // N° de recibo: pago en OFICINA → secuencia automática del sistema (RU-AAAA-NNNNN)
      // generada al confirmar; pago en la aseguradora → solo el recibo de la aseguradora.
      const pagoEnOficina = pagoForm.donde_pago === 'RU';
      let numReciboRU = null;
      if (pagoEnOficina) {
        const { data: numSec, error: errSec } = await supabase.rpc('next_recibo_ru');
        if (errSec || !numSec) throw new Error('No se pudo generar el número de recibo de oficina. ' + (errSec?.message || ''));
        numReciboRU = numSec;
      }
      const cobro = await insertRow('cobros_recibidos', {
        poliza_id: selected.id,
        monto,
        fecha: pagoForm.fecha_pago_aseg,
        donde_pago: pagoForm.donde_pago,
        forma_pago: pagoForm.forma_pago_real || null,
        num_recibo_aseg: pagoEnOficina ? null : (pagoForm.num_recibo_aseg || null),
        num_recibo_ru: numReciboRU,
        notas: pagoForm.notas_cobro || null,
      });
      // El saco primero: reparte el cobro entre las cuotas (puede cruzar a la vigencia
      // anterior). La comisión se calcula después, sobre ese reparto real.
      await reaplicarSacoPoliza(selected.id);
      try { await generarComisionesDelCobro(cobro.id, selected.id, monto); } catch (e) { console.error("comisión", e); }
      // Recargar el plan de cobros de la vista
      const { data: pag } = await supabase.from('pagos').select('*')
        .eq('poliza_id', selected.id).order('fecha_vencimiento').order('cuota_num');
      setViewPagos(pag || []);
      setShowPagoModal(false);
      // Pago en oficina: ofrecer imprimir el recibo del cliente con el N° asignado
      if (pagoEnOficina) {
        setReciboExito({
          numRecibo: numReciboRU,
          fecha: pagoForm.fecha_pago_aseg,
          monto,
          formaPago: pagoForm.forma_pago_real || null,
          cliente: selected.cliente,
          polizaNum: selected.numero,
          aseguradora: selected.aseguradora,
          ramo: selected.ramo,
          notas: pagoForm.notas_cobro || null,
          registradoPor: user?.nombre || user?.email || null,
        });
      }
      setPagoForm({ monto_recibido:'', donde_pago:'Aseguradora', fecha_pago_aseg:'', forma_pago_real:'', num_recibo_aseg:'', notas_cobro:'' });
    } catch (err) {
      alert('Error al registrar el pago: ' + (err.message || err));
    } finally {
      setSavingPago(false);
    }
  };

  // Registrar la factura de un período (modo periódico): crea la letra en el saco
  // y cierra la tarea del CRM del período. Ver src/db/periodos.js.
  const guardarFacturaPeriodo = async () => {
    if (!periodoFactura) return;
    const monto = parseFloat(periodoFactura.monto);
    if (!(monto >= 0)) { alert('Ingresa el monto de la factura del período.'); return; }
    setGuardandoPeriodo(true);
    try {
      await registrarFacturaPeriodo(periodoFactura.periodo, {
        monto,
        fechaFactura: periodoFactura.fecha_factura || undefined,
        fechaEnvioCliente: periodoFactura.fecha_envio_cliente || undefined,
        notas: periodoFactura.notas || undefined,
      });
      const { data: pers } = await supabase.from('poliza_periodos')
        .select('*').eq('poliza_id', periodoFactura.periodo.poliza_id).order('periodo_inicio', { ascending: false });
      setViewPeriodos(pers || []);
      setPeriodoFactura(null);
    } catch (e) { alert('Error: ' + (e.message || '')); }
    finally { setGuardandoPeriodo(false); }
  };

  // Recarga períodos + letras + endosos + documentos de respaldo de la póliza abierta.
  const refrescarDeclaraciones = async (polizaId) => {
    const [{ data: pers }, { data: pag }, endosos, { data: pdocs }] = await Promise.all([
      supabase.from('poliza_periodos').select('*').eq('poliza_id', polizaId).order('periodo_inicio', { ascending: false }),
      supabase.from('pagos').select('*').eq('poliza_id', polizaId).order('fecha_vencimiento').order('cuota_num'),
      loadEndososPoliza(polizaId),
      supabase.from('documentos').select('id, nombre_archivo, storage_path, periodo_id, tipos_documento(nombre)')
        .eq('poliza_id', polizaId).not('periodo_id', 'is', null).eq('activo', true),
    ]);
    setViewPeriodos(pers || []);
    setViewPagos(pag || []);
    setViewEndosos(endosos || []);
    setViewPeriodoDocs(pdocs || []);
  };

  // Sube un documento de respaldo (factura, etc.) al storage y lo enlaza a la póliza +
  // período (tabla documentos). Reutiliza el bucket/patrón de DocManager.
  const subirDocPeriodo = async (polizaId, periodoId, file, tipoDocId) => {
    const ext = file.name.split('.').pop();
    const path = `documentos/poliza/${polizaId}/${Date.now()}_${Math.random().toString(36).slice(2, 7)}.${ext}`;
    const { error } = await supabase.storage.from('solicitud-archivos').upload(path, file, { upsert: false });
    if (error) throw error;
    await insertRow('documentos', {
      tipo_documento_id: tipoDocId ? parseInt(tipoDocId) : null,
      nombre_archivo: file.name, storage_path: path, activo: true,
      poliza_id: polizaId, periodo_id: periodoId,
    });
  };

  // Registrar una DECLARACIÓN directo desde la pestaña (crea el endoso + su letra) y
  // adjuntar la factura/respaldos de la aseguradora, ligados a ese mes.
  const guardarDeclaracion = async () => {
    if (!declForm || !selected) return;
    const monto = parseFloat(declForm.monto);
    if (!declForm.fecha) { alert('Indica la fecha de la declaración (el mes que se declara).'); return; }
    if (!(monto > 0)) { alert('El monto declarado debe ser mayor a 0.'); return; }
    setSavingDecl(true);
    try {
      const { periodoId } = await registrarDeclaracion(selected, {
        fecha: declForm.fecha, monto,
        descripcion: declForm.descripcion, numeroEndoso: declForm.numero_endoso,
      });
      // Adjuntar los documentos de respaldo (si se agregaron) ligados al período.
      for (const file of (declForm.files || [])) {
        try { await subirDocPeriodo(selected.id, periodoId, file, declForm.tipoDocId); }
        catch (e) { alert('La declaración se registró, pero un documento no se pudo subir: ' + (e.message || '')); }
      }
      await refrescarDeclaraciones(selected.id);
      setDeclForm(null);
      alert('✓ Declaración registrada como endoso, con su letra en el saco.');
    } catch (e) { alert('Error: ' + (e.message || '')); }
    finally { setSavingDecl(false); }
  };

  // Adjuntar un documento a un período YA declarado (después del registro).
  const adjuntarFacturaPeriodo = async (periodo, file, tipoDocId) => {
    if (!file || !selected) return;
    try {
      await subirDocPeriodo(selected.id, periodo.id, file, tipoDocId);
      await refrescarDeclaraciones(selected.id);
    } catch (e) { alert('Error al subir el documento: ' + (e.message || '')); }
  };

  const closeModal = () => {
    setModal(null); setSelected(null); setMotivoCambio('');
    setShowCrearCliente(false); setShowCrearAseg(false); setShowAddCob(false);
    setViewAgentes([]); setViewCoberturas([]); setViewAutos([]); setViewPagos([]); setViewEndosos([]);
    setViewReclamos([]); setViewPeriodos([]); setViewUnidades([]);
    setViewPeriodoDocs([]); setDeclForm(null); setPeriodoFactura(null);
    setViewArchivosSol([]);
    setViewSolicitud(null);
    setViewPolizaAnterior(null);
    setCpModal(null);
    setViewEndosoSolicitudes([]);
    setViewEndosoCancelados([]);
    setViewBitacoraCobros([]);
    setViewBitacoraPolizas([]);
    setShowPagoModal(false);
    setTienePagosAplicados(false);
    setPolTieneFlota(false);
    setAutoList([{ ...EMPTY_AUTO }]);
  };

  // Anula un endoso ya facturado: revierte la dilución (resta a cada cuota lo que el
  // endoso le sumó), elimina letras sueltas que haya generado, marca el endoso como
  // 'anulado' con su motivo (se conserva en el listado) y redistribuye el saco.
  const confirmAnularEndoso = async () => {
    const e = anularEndosoTarget;
    if (!e) return;
    if (!motivoAnularEndoso.trim()) { alert('Indica el motivo de la anulación.'); return; }
    setAnulandoEndoso(true);
    try {
      // 0) Revertir los CAMBIOS ESTRUCTURALES (vehículo, cobertura, suma, forma de pago…)
      //    usando el/los snapshot(s) del "antes". Formato nuevo = lista; viejo = uno solo.
      if (e.cambios_snapshot) {
        const snaps = Array.isArray(e.cambios_snapshot) ? [...e.cambios_snapshot].reverse() : [e.cambios_snapshot];
        for (const snap of snaps) {
          try { await reversarCambioEndoso(selected.id, snap); }
          catch (err) { console.error('Reversa del cambio del endoso:', err); }
        }
      }
      // 1) Revertir la dilución: restar a cada cuota lo que este endoso le sumó
      const { data: ajustes } = await supabase.from('poliza_endoso_ajustes')
        .select('id, pago_id, monto').eq('endoso_id', e.id);
      for (const aj of (ajustes || [])) {
        const { data: pg } = await supabase.from('pagos').select('monto').eq('id', aj.pago_id).maybeSingle();
        if (pg) {
          const nuevo = Math.round(((parseFloat(pg.monto) || 0) - (parseFloat(aj.monto) || 0)) * 100) / 100;
          await updateRow('pagos', aj.pago_id, { monto: nuevo });
        }
      }
      if (ajustes && ajustes.length) await supabase.from('poliza_endoso_ajustes').delete().eq('endoso_id', e.id);

      // 2) Eliminar letras sueltas que el endoso haya creado (caso sin cuotas en rango)
      const { data: pagosEnd } = await supabase.from('pagos').select('id').eq('endoso_id', e.id);
      const ids = (pagosEnd || []).map(p => p.id);
      if (ids.length) {
        await supabase.from('cobro_cuotas').delete().in('pago_id', ids);
        await supabase.from('comisiones').delete().in('pago_id', ids);
        await supabase.from('pagos').delete().in('id', ids);
      }

      // 3) Marcar el endoso como anulado con su motivo (se conserva en el listado)
      await updateRow('poliza_endosos', e.id, { estado: 'anulado', motivo_anulacion: motivoAnularEndoso.trim() });

      // 3b) Si era un endoso de CANCELACIÓN, reactivar la póliza (vuelve a Cobros/Morosidad)
      if (e.tipo === 'cancelacion') {
        await updateRow('polizas', selected.id, { estado: 'activa' });
      }

      // 4) Redistribuir el saco y refrescar la vista
      await reaplicarSacoPoliza(selected.id);
      const [endosos, { data: pag }] = await Promise.all([
        loadEndososPoliza(selected.id),
        supabase.from('pagos').select('*').eq('poliza_id', selected.id).order('fecha_vencimiento').order('cuota_num'),
      ]);
      setViewEndosos(endosos || []);
      setViewPagos(pag || []);
      setAnularEndosoTarget(null);
      setMotivoAnularEndoso('');
    } catch (err) {
      alert('Error al anular el endoso: ' + (err.message || err));
    } finally {
      setAnulandoEndoso(false);
    }
  };

  // ── Guardar con ajuste de comisión ──────────────────────────────
  const doGuardar = async (esBorrador, ajusteData) => {
    await handleSave(esBorrador, ajusteData);
  };

  // ── Guardar ──────────────────────────────────────────────────────
  // Qué cambió en la edición que está en pantalla: campos de la póliza + coberturas.
  // La usan el aviso del formulario y la validación al guardar, para que el usuario vea
  // exactamente lo mismo que se le va a exigir (y lo mismo que va a la bitácora).
  const difsEdicionActual = () => {
    if (modal !== 'edit' || !selected) return [];
    const difs = cambiosDePoliza(form, selected);
    // Las coberturas se comparan aparte: al guardar se borran y reinsertan siempre, así
    // que sin firma no se distingue "las cambió" de "guardó sin tocarlas". Las de flota
    // (por unidad) no entran: esas van por endoso y este guardado no las toca.
    const firmaAhora = firmaCoberturas(
      polizaCoberturas.filter(c => c.incluida).map(c => ({
        nombre: c.nombre, tipo_limite: c.tipo_limite,
        suma_asegurada: c.suma_asegurada, deducible: formatDeducible(c), otros: c.otros,
      }))
    );
    if (firmaAhora !== cobsBaseRef.current) {
      difs.push({ k:'coberturas', label:'Coberturas', riesgo:true,
        antes:'lista anterior', despues:'lista modificada' });
    }
    return difs;
  };

  const handleSave = async (esBorrador = false, ajusteData = null) => {
    if (esBorrador && !form.cliente_id && !form.numero) {
      alert('Ingresa al menos el número o el cliente para guardar borrador.'); return;
    }
    // Editar una póliza ya emitida y tocarle datos de riesgo exige decir POR QUÉ.
    // (En borradores no: todavía se está armando la póliza, no hay nada que auditar.)
    const difsEdicion = difsEdicionActual();
    const editaRiesgo = difsEdicion.some(d => d.riesgo);
    if (editaRiesgo && !esBorrador && selected?.estado !== 'borrador' && !motivoCambio.trim()) {
      alert(
        'Escribe el motivo del cambio.\n\nEstás modificando datos de riesgo:\n· ' +
        difsEdicion.filter(d => d.riesgo).map(d => d.label).join('\n· ') +
        '\n\nQueda registrado en la bitácora de la póliza.'
      );
      return;
    }
    // Validación consolidada: UN solo mensaje con todo lo que falta.
    // En declarativas la prima NO se exige (nace de las declaraciones mensuales).
    if (!esBorrador) {
      const faltan = [];
      if (!form.numero)        faltan.push('Número de póliza');
      if (!form.cliente_id)    faltan.push('Cliente');
      if (!form.aseguradora_id) faltan.push('Aseguradora');
      if (!form.ramo_id)       faltan.push('Ramo');
      // La prima no es obligatoria en declarativas ni en facturación periódica
      // (colectivos): ahí el monto nace de cada período/declaración, no de la prima.
      if (!form.prima && !form.es_declarativa && form.facturacion_modo !== 'periodica') faltan.push('Prima');
      if (form.es_declarativa && !form.modalidad_declarativa) faltan.push('Modalidad declarativa');
      if (form.es_fianza && !form.monto_afianzado) faltan.push('Monto afianzado');
      if (form.es_fianza && !form.tarifa_fianza)   faltan.push('Tarifa de la fianza (% anual)');
      if (!form.es_fee && !form.comision_ramo) faltan.push('% Comisión del ramo (o marcar la póliza como Fee)');
      if (form.es_fee && !form.monto_fee) faltan.push('Monto del Fee');
      // Auto: al emitir/crear por primera vez, los datos del vehículo son obligatorios.
      // (La placa es la única excepción: puede quedar "Por reportar" y abre su tarea CRM.)
      if (isAuto && modal === 'create') {
        // Al emitir se pueden cargar VARIAS unidades (flota): se validan todas.
        faltan.push(...validarVehiculos(autoList));
      }
      if (faltan.length) {
        alert('Faltan estos campos para guardar la póliza:\n\n• ' + faltan.join('\n• '));
        return;
      }
    }

    try {
      let placaSinRUV = false; // Vía A: se puso placa real pero falta el RUV para cerrar la tarea
      // ── Guard: número duplicado en la MISMA vigencia ───────────────
      // Permite renovaciones con el mismo número (vigencia distinta = otra
      // fecha de inicio) pero bloquea crear/guardar dos registros de la MISMA
      // vigencia (mismo número + misma fecha de inicio), que es lo que se vería
      // como "se sobrescribió/duplicó la póliza". No aplica a borradores.
      if (!esBorrador && form.numero && form.fecha_inicio) {
        let qDup = supabase.from('polizas')
          .select('id, numero, fecha_inicio, fecha_vencimiento, estado')
          .eq('numero', form.numero.trim());
        if (modal === 'edit' && selected) qDup = qDup.neq('id', selected.id);
        const { data: mismoNumero } = await qDup;
        const choque = (mismoNumero || []).find(p =>
          p.estado !== 'cancelada' && p.fecha_inicio === form.fecha_inicio);
        if (choque) {
          alert(
            `Ya existe la póliza ${form.numero} con la misma fecha de inicio (${form.fecha_inicio}).\n\n` +
            `Si esto es una RENOVACIÓN, cambia la fecha de inicio/vencimiento a la nueva vigencia ` +
            `antes de guardar.\n\n` +
            `No se guardó para evitar duplicar la misma vigencia.`
          );
          return;
        }
      }

      // ── Detectar ajuste por cambio de % comisión del ramo o del agente sobre pagadas ──
      if (!ajusteData && modal === 'edit' && esDirectorOSuperior && !esBorrador && !form.es_fee) {
        const pctRamoViejo = parseFloat(selected?.comision_ramo);
        const pctRamoNuevo = parseFloat(form.comision_ramo);
        const ramo_cambio  = !isNaN(pctRamoViejo) && !isNaN(pctRamoNuevo) && pctRamoViejo !== pctRamoNuevo;

        // Cambio en % de agente: solo si está en modo Manual Y el % cambió respecto a poliza_agentes
        const { data: agentesGuardados } = await supabase
          .from('poliza_agentes').select('agente_id, porcentaje, comision_manual').eq('poliza_id', selected.id);
        const agente_cambio = polizaAgentes.some(nuevo => {
          if (!nuevo.comision_manual) return false;
          const bd = (agentesGuardados || []).find(a => String(a.agente_id) === String(nuevo.agente_id));
          return bd && Math.abs(parseFloat(nuevo.porcentaje) - parseFloat(bd.porcentaje)) > 0.001;
        });

        if (ramo_cambio || agente_cambio) {
          const { data: comsPagadas } = await supabase
            .from('comisiones').select('*')
            .eq('poliza_id', selected.id).eq('estado', 'pagado');
          if (comsPagadas?.length > 0) {
            const byAgente = {};
            for (const com of comsPagadas) {
              const key = String(com.agente_id ?? 'ru');
              if (!byAgente[key]) byAgente[key] = {
                agente_id: com.agente_id,
                delta_agente: 0, delta_ru: 0,
                prima_base_total: 0,
              };
              const montoAgenteViejo = parseFloat(com.monto_agente) || 0;
              const montoRUViejo     = parseFloat(com.monto_ru)     || 0;

              if (ramo_cambio && pctRamoViejo !== 0) {
                // Escalar los montos guardados proporcionalmente al nuevo %
                byAgente[key].delta_agente += Math.round((montoAgenteViejo * pctRamoNuevo / pctRamoViejo - montoAgenteViejo) * 100) / 100;
                byAgente[key].delta_ru     += Math.round((montoRUViejo     * pctRamoNuevo / pctRamoViejo - montoRUViejo)     * 100) / 100;
              }

              if (agente_cambio) {
                // Cambio de % agente: recalcular desde prima_base o monto total de comisión
                const agBD       = (agentesGuardados || []).find(a => String(a.agente_id) === String(com.agente_id));
                const pctAgViejo = parseFloat(agBD?.porcentaje ?? com.porcentaje_agente) || 0;
                const agForm     = polizaAgentes.find(a => String(a.agente_id) === String(com.agente_id));
                const pctAgNuevo = parseFloat(agForm?.porcentaje ?? pctAgViejo) || 0;
                if (pctAgViejo !== 0 && Math.abs(pctAgNuevo - pctAgViejo) > 0.001) {
                  byAgente[key].delta_agente += Math.round((montoAgenteViejo * pctAgNuevo / pctAgViejo - montoAgenteViejo) * 100) / 100;
                }
              }

              byAgente[key].prima_base_total += parseFloat(com.prima_base) || parseFloat(com.prima) || 0;
            }
            // Armar descripción con detalles por agente
            const agenteCambios = polizaAgentes
              .filter(nuevo => {
                if (!nuevo.comision_manual) return false;
                const bd = (agentesGuardados || []).find(a => String(a.agente_id) === String(nuevo.agente_id));
                return bd && Math.abs(parseFloat(nuevo.porcentaje) - parseFloat(bd.porcentaje)) > 0.001;
              })
              .map(nuevo => {
                const bd = (agentesGuardados || []).find(a => String(a.agente_id) === String(nuevo.agente_id));
                return {
                  nombre: nuevo.nombre,
                  pctViejo: parseFloat(bd.porcentaje),
                  pctNuevo: parseFloat(nuevo.porcentaje),
                };
              });
            const descripcion = [
              ramo_cambio   ? `% ramo ${pctRamoViejo}% → ${pctRamoNuevo}%` : '',
              agente_cambio ? agenteCambios.map(a => `${a.nombre}: ${a.pctViejo}% → ${a.pctNuevo}%`).join(', ') : '',
            ].filter(Boolean).join(' | ');
            setPendingAjuste({ descripcion, byAgente, comsPagadas, agenteCambios, ramo_cambio, pctRamoViejo, pctRamoNuevo });
            setShowAjusteConfirm(true);
            return;
          }
        }
      }

      const payload = {
        numero: form.numero || null, cliente_id: form.cliente_id ? parseInt(form.cliente_id) : null,
        agente_id: polizaAgentes.length > 0 ? parseInt(polizaAgentes[0].agente_id) : null,
        aseguradora_id: form.aseguradora_id ? parseInt(form.aseguradora_id) : null,
        ramo_id: form.ramo_id ? parseInt(form.ramo_id) : null,
        subramo_id: form.subramo_id ? parseInt(form.subramo_id) : null,
        ejecutivo_id: form.ejecutivo_id ? parseInt(form.ejecutivo_id) : null,
        ejecutivo_cobro_id: form.ejecutivo_cobro_id ? parseInt(form.ejecutivo_cobro_id) : null,
        ejecutivo_reclamo_id: form.ejecutivo_reclamo_id ? parseInt(form.ejecutivo_reclamo_id) : null,
        tipo: form.tipo, tipo_emision: form.tipo_emision || 'nueva',
        estado: esBorrador ? 'borrador' : form.estado,
        prima: form.prima ? parseFloat(form.prima) : (form.es_declarativa ? 0 : null),
        // ── Campos declarativos ──
        es_declarativa: form.es_declarativa || false,
        modalidad_declarativa: form.es_declarativa ? (form.modalidad_declarativa || null) : null,
        arquitectura: form.es_declarativa ? (form.arquitectura || null) : null,
        tasa: form.es_declarativa && form.tasa ? parseFloat(form.tasa) : null,
        tasa_unidad: form.es_declarativa ? (form.tasa_unidad || 'por_mil') : null,
        tasa_guerra: form.es_declarativa && form.tasa_guerra ? parseFloat(form.tasa_guerra) : null,
        prima_deposito: form.es_declarativa && form.prima_deposito ? parseFloat(form.prima_deposito) : (form.es_declarativa ? 0 : null),
        prima_minima: form.es_declarativa && form.prima_minima ? parseFloat(form.prima_minima) : null,
        deposito_es_ganado: form.es_declarativa ? (form.deposito_es_ganado || false) : false,
        suma_maxima: form.es_declarativa && form.suma_maxima ? parseFloat(form.suma_maxima) : null,
        suma_total: form.es_declarativa && form.suma_total ? parseFloat(form.suma_total) : null,
        saldo_disponible: form.es_declarativa && form.arquitectura === 'flotante' && form.suma_total
          ? (modal === 'create' ? parseFloat(form.suma_total) : undefined)
          : null,
        periodicidad_declaracion: form.es_declarativa ? (form.periodicidad_declaracion || 'mensual') : null,
        base_valuacion: form.es_declarativa ? (form.base_valuacion || null) : null,
        factor_valuacion: form.es_declarativa && form.factor_valuacion ? parseFloat(form.factor_valuacion) : null,
        // ── Campos de FIANZA (sub-modo) ──
        // Solo se incluyen cuando la póliza es fianza: así un guardado normal NO referencia
        // columnas nuevas y no se rompe si el SQL aditivo aún no se aplicó en este entorno.
        ...(form.es_fianza ? {
          es_fianza: true,
          monto_afianzado: form.monto_afianzado ? parseFloat(form.monto_afianzado) : null,
          tarifa_fianza: form.tarifa_fianza ? parseFloat(form.tarifa_fianza) : null,
          beneficiario: form.beneficiario_fianza || null,
        } : {}),
        fecha_inicio: form.fecha_inicio || null, fecha_vencimiento: form.fecha_vencimiento || null,
        fecha_emision: form.fecha_emision || null, notas: form.notas || null,
        impuesto: form.impuesto ? parseFloat(form.impuesto) : null,
        comision_ramo: form.es_fee ? 0 : (form.comision_ramo ? parseFloat(form.comision_ramo) : null),
        es_fee: form.es_fee || false,
        monto_fee: form.es_fee && form.monto_fee ? parseFloat(form.monto_fee) : null,
        sobrecomision_tipo:    form.sobrecomision_tipo || null,
        sobrecomision_valor:   form.sobrecomision_tipo && form.sobrecomision_valor ? parseFloat(form.sobrecomision_valor) : null,
        sobrecomision_reparto: form.sobrecomision_tipo ? (form.sobrecomision_reparto || 'ru') : null,
        forma_pago: form.forma_pago || null,
        // Fianza = pago único (vigencia ligada al contrato, no 12 cuotas).
        frecuencia_pago: form.es_fianza ? 'anual' : (form.frecuencia_pago || 'mensual'),
        num_cuotas: form.es_fianza ? 1 : (form.num_cuotas ? parseInt(form.num_cuotas) : 1),
        // Facturación periódica (colectivos / declarativas).
        facturacion_modo: form.facturacion_modo || 'cuotas',
        periodo_frecuencia: form.facturacion_modo === 'periodica' ? (form.periodo_frecuencia || 'mensual') : null,
        declarativa_modo: (form.facturacion_modo === 'periodica' && form.es_declarativa) ? (form.declarativa_modo || 'mensual') : null,
        gastos_expedicion: form.gastos_expedicion ? parseFloat(form.gastos_expedicion) : null,
        participacion: form.participacion ? parseFloat(form.participacion) : null,
        descripcion_riesgo: form.descripcion_riesgo || null,
        beneficiario_nombre: form.beneficiario_nombre || null,
        beneficiario_cedula: form.beneficiario_cedula || null,
        beneficiario_oneroso: form.beneficiario_oneroso || false,
        // Sella la fecha de última actualización del beneficiario cuando se agrega o
        // cambia (dato visible para todos; el detalle es confidencial — solo master
        // o rol con permiso `ver_beneficiarios`). No la pisa si el beneficiario no cambió.
        ...(() => {
          const actual = `${form.beneficiario_nombre || ''}|${form.beneficiario_cedula || ''}`;
          const previo = modal === 'edit' && selected
            ? `${selected.beneficiario_nombre || ''}|${selected.beneficiario_cedula || ''}` : '';
          const cambio = modal === 'create' ? !!form.beneficiario_nombre : actual !== previo;
          return cambio ? { beneficiarios_actualizado_el: new Date().toISOString().slice(0, 10) } : {};
        })(),
        asegurado_nombre: form.asegurado_nombre || null,
        asegurado_cedula: form.asegurado_cedula || null,
        tomador_nombre: form.tomador_nombre || null,
        tomador_cedula: form.tomador_cedula || null,
        suma_asegurada: null, deducible: null,
        // ── Referido (referidor) — opcional ──
        referido_id: form.referido_id ? parseInt(form.referido_id) : null,
        referido_comision_pct: form.referido_id && form.referido_comision_pct !== ''
          ? parseFloat(form.referido_comision_pct) : null,
        // Renovación (2 columnas con roles distintos, ver Solicitudes/openView):
        // · renovacion_de_poliza_id = MAPA → siempre que se vincule una anterior.
        // · poliza_anterior_id = ARRASTRE de saco → solo si la aseguradora arrastra el saldo.
        // Ninguna debe apuntar a sí misma (self-reference = error).
        renovacion_de_poliza_id: (() => {
          const pa = form.poliza_anterior_id ? parseInt(form.poliza_anterior_id) : null;
          if (pa && modal === 'edit' && selected && pa === selected.id) return null;
          return pa;
        })(),
        poliza_anterior_id: (() => {
          const pa = form.poliza_anterior_id ? parseInt(form.poliza_anterior_id) : null;
          if (pa && modal === 'edit' && selected && pa === selected.id) return null;
          return form.arrastra_saldo !== false ? pa : null;
        })(),
        // Candado de edición: las pólizas nuevas/renovaciones nacen BLOQUEADAS (los
        // cambios de riesgo van por endoso). Un borrador queda libre hasta finalizarse;
        // al pasar de borrador a definitiva se bloquea. Las pólizas viejas ya existentes
        // NO se tocan aquí (se respeta el flag que tengan): "de aquí en adelante".
        ...(modal === 'create'
          ? { bloqueada_edicion: !esBorrador }
          : (!esBorrador && selected?.estado === 'borrador' && !selected?.bloqueada_edicion
              ? { bloqueada_edicion: true } : {})),
      };

      let polId;
      if (modal === 'create') {
        const pol = await insertRow('polizas', payload);
        polId = pol.id;
        // Renovación DIRECTA (sin pasar por Solicitudes): la vigencia anterior acaba de
        // quedar renovada → se cierra su tarea de renovación del CRM en el acto, sin
        // esperar a la auditoría. Se mira el MAPA (renovacion_de_poliza_id) y, por
        // compatibilidad con datos viejos, el arrastre (poliza_anterior_id).
        const anteriorRenovada = payload.renovacion_de_poliza_id || payload.poliza_anterior_id || null;
        if (anteriorRenovada && !esBorrador) {
          try {
            await supabase.from('crm_gestiones')
              .update({ estado: 'cerrado', actualizado_en: new Date().toISOString() })
              .eq('poliza_id', anteriorRenovada).eq('tipo', 'renovacion')
              .in('estado', ['abierto', 'en_proceso']);
          } catch (e) { console.error('cerrar tarea renovación', e); }
        }
      } else {
        await updateRow('polizas', selected.id, { ...payload, actualizado_en: new Date().toISOString() });
        polId = selected.id;
        // Auditoría de TODA edición directa, esté o no bloqueada la póliza. Antes solo se
        // registraba al master sobre pólizas bloqueadas: las pólizas viejas (sin candado)
        // se podían cambiar sin dejar ninguna huella, y así se perdió una vigencia entera
        // al "renovar" una póliza editándole las fechas. Se guarda qué cambió y por qué.
        if (difsEdicion.length) {
          try {
            await insertRow('bitacora_polizas', {
              poliza_id: polId, usuario_id: user?.id, tipo: 'edicion_directa',
              nota: [
                editaRiesgo ? '✏️ Edición directa de datos de riesgo' : '✏️ Edición de la póliza',
                selected?.bloqueada_edicion ? '(póliza bloqueada — cambio hecho sin endoso)' : null,
                detalleCambios(difsEdicion),
                motivoCambio.trim() ? `Motivo: ${motivoCambio.trim()}` : null,
              ].filter(Boolean).join(' — '),
            });
          } catch { /* la bitácora no debe bloquear el guardado */ }
        }
        // Borra SOLO las coberturas a nivel de póliza; las POR UNIDAD (poliza_auto_id)
        // no se tocan aquí (se gestionan por endoso), para no perder las de la flota.
        await supabase.from('poliza_coberturas').delete().eq('poliza_id', polId).is('poliza_auto_id', null);
        await supabase.from('poliza_agentes').delete().eq('poliza_id', polId);
        if (!esBorrador) await supabase.from('comisiones').delete().eq('poliza_id', polId).eq('estado', 'pendiente');
      }

      // Coberturas
      for (const c of polizaCoberturas.filter(c => c.incluida)) {
        let cobId = c.cobertura_id;
        if (c.es_personalizada && !cobId && form.ramo_id) {
          const newCob = await insertRow('coberturas', { ramo_id: parseInt(form.ramo_id), nombre: c.nombre, activa: true, orden: 99 });
          cobId = newCob.id;
        }
        await insertRow('poliza_coberturas', {
          poliza_id: polId, cobertura_id: cobId || null, nombre: c.nombre,
          tipo_limite: c.tipo_limite || 'limite',
          suma_asegurada: c.suma_asegurada ? parseFloat(c.suma_asegurada) : null,
          deducible: formatDeducible(c),
          otros: c.otros || null,
        });
      }

      // Auto datos
      if (isAuto) {
        const vehToPayload = (veh) => ({
          poliza_id: polId,
          anio: veh.anio ? parseInt(veh.anio) : null,
          marca: veh.marca || null, modelo: veh.modelo || null,
          color: veh.color || null, tipo_vehiculo: veh.tipo_vehiculo || null,
          pasajeros: veh.pasajeros ? parseInt(veh.pasajeros) : null,
          no_motor: veh.no_motor || null,
          chasis_igual_motor: veh.chasis_igual_motor,
          chasis: veh.chasis_igual_motor ? veh.no_motor : (veh.chasis || null),
          placa: veh.placa_por_reportar ? 'Por reportar' : (veh.placa || null),
          placa_por_reportar: veh.placa_por_reportar,
          // Propietario según RUV: null si el dueño es el contratante de la póliza.
          dueno_nombre: veh.dueno_igual ? null : (veh.dueno_nombre || null),
          dueno_cedula: veh.dueno_igual ? null : (veh.dueno_cedula || null),
        });
        if (modal === 'create') {
          // EMISIÓN: se insertan TODAS las unidades (flota) con sus coberturas por unidad.
          // Después se cambian por endoso.
          const unidades = autoList.length ? autoList : [autoForm];
          for (const veh of unidades) {
            const av = await insertRow('poliza_autos', vehToPayload(veh));
            for (const c of (veh.coberturas || [])) {
              if (!c.nombre) continue;
              await insertRow('poliza_coberturas', {
                poliza_id: polId, poliza_auto_id: av?.id || null,
                nombre: c.nombre, tipo_limite: c.tipo_limite || 'limite',
                suma_asegurada: c.suma_asegurada !== '' && c.suma_asegurada != null ? parseFloat(c.suma_asegurada) : null,
                deducible: c.deducible || null,
              });
            }
          }
        } else {
          // EDICIÓN: un solo vehículo, con blindaje de FLOTA (no pisar los demás).
          // Si la póliza ya tiene más de un vehículo, no se tocan aquí (van por endoso).
          const { count: nAutos } = await supabase.from('poliza_autos')
            .select('id', { count: 'exact', head: true }).eq('poliza_id', polId);
          if ((nAutos || 0) <= 1) {
            await supabase.from('poliza_autos').delete().eq('poliza_id', polId);
            await insertRow('poliza_autos', vehToPayload(autoForm));
          }
        }

        if (!esBorrador) {
          // ¿Alguna unidad quedó con placa "Por reportar"? (en creación se revisan todas)
          const unidades = modal === 'create' ? (autoList.length ? autoList : [autoForm]) : [autoForm];
          const algunaPorReportar = unidades.some(v => v.placa_por_reportar);
          const placaReal = modal === 'edit' && !autoForm.placa_por_reportar && (autoForm.placa || '').trim();
          // Tareas de placa ya abiertas para esta póliza (evita duplicar y permite cerrarlas)
          const { data: placaTasks } = await supabase.from('crm_gestiones')
            .select('id')
            .eq('poliza_id', polId)
            .in('estado', ['abierto', 'en_proceso'])
            .ilike('titulo', 'Actualizar placa%');
          const tareasPlaca = placaTasks || [];

          if (algunaPorReportar) {
            // Placa "Por reportar": crear la tarea SOLO si no hay ya una abierta
            // (antes se creaba una nueva en cada guardado → tareas duplicadas).
            if (tareasPlaca.length === 0) {
              const venc = new Date(); venc.setDate(venc.getDate() + 30);
              const vencStr = venc.toISOString().slice(0, 10);
              await insertRow('crm_gestiones', {
                tipo: 'seguimiento', prioridad: 'alta',
                titulo: `Actualizar placa — Póliza ${form.numero || polId}`,
                descripcion: `La póliza ${form.numero || polId} tiene una o más unidades con placa "Por reportar". Contactar al cliente para que envíe el registro vehicular con el número de placa antes del ${vencStr}.`,
                poliza_id: polId, cliente_id: form.cliente_id ? parseInt(form.cliente_id) : null,
                estado: 'abierto', fecha_vencimiento: vencStr,
              });
            }
          } else if (placaReal && tareasPlaca.length > 0) {
            // Vía A: se puso la placa real en la póliza. La tarea de placa se cierra
            // SOLO si el registro vehicular (RUV) ya está adjunto en los documentos
            // de la póliza — el RUV es lo que valida el cierre.
            const ruvTipoId = await ensureTipoDocRUV();
            let tieneRUV = false;
            if (ruvTipoId) {
              const { data: ruvDocs } = await supabase.from('documentos')
                .select('id').eq('poliza_id', polId).eq('tipo_documento_id', ruvTipoId)
                .eq('activo', true).limit(1);
              tieneRUV = (ruvDocs || []).length > 0;
            }
            if (tieneRUV) {
              const placaVal = placaReal.toUpperCase();
              for (const t of tareasPlaca) {
                await updateRow('crm_gestiones', t.id, { estado: 'cerrado', actualizado_en: new Date().toISOString() });
                await insertRow('crm_historial', {
                  gestion_id: t.id, usuario_id: user?.id, accion: 'cerrar',
                  detalle: `Placa registrada (${placaVal}) con registro vehicular adjunto. Tarea cerrada desde la póliza.`,
                });
              }
              await insertRow('bitacora_polizas', {
                poliza_id: polId, usuario_id: user?.id, tipo: 'seguimiento',
                nota: `Placa actualizada a ${placaVal} con registro vehicular (RUV) adjunto — tarea de placa cerrada.`,
              });
            } else {
              placaSinRUV = true; // se avisa al cerrar el guardado
            }
          }
        }
      }

      // Agentes y comisiones
      // Agentes
      for (let i = 0; i < polizaAgentes.length; i++) {
        const ag    = polizaAgentes[i];
        const pctAg = parseFloat(ag.porcentaje) || 0;
        await insertRow('poliza_agentes', {
          poliza_id: polId, agente_id: parseInt(ag.agente_id),
          porcentaje: pctAg,
          comision_manual: ag.comision_manual || false,
        });
      }

      // Si es edición con agentes nuevos y hay pagos ya aplicados → regenerar comisiones.
      // IMPORTANTE: se regenera UNA comisión por COBRO (monto del pago recibido), NO
      // una por cuota. Antes recorría las cuotas pagadas y fragmentaba la comisión
      // (ej. un cobro de $146.40 que cubre 4 cuotas generaba 3-4 comisiones de $38.24,
      // ignoraba parciales y no enlazaba el cobro). generarComisionCobro es idempotente
      // (no duplica por cobro+agente).
      if (modal === 'edit' && polizaAgentes.length > 0 && tienePagosAplicados && !payload.es_fee && payload.comision_ramo) {
        await supabase.from('comisiones').delete().eq('poliza_id', polId).eq('estado', 'pendiente_aseg');
        const { data: cobrosPol } = await supabase.from('cobros_recibidos')
          .select('id, monto, anulado').eq('poliza_id', polId);
        for (const cob of (cobrosPol || [])) {
          if (cob.anulado) continue;
          await generarComisionesDelCobro(cob.id, polId, cob.monto);
        }
      }

      // Corrección del % de comisión con comisiones YA LIQUIDADAS.
      // Arriba se regeneraron las que seguían en 'pendiente_aseg' (toman el % nuevo),
      // pero las 'aprobado'/'pagado' no se pueden reescribir: ese dinero ya se liquidó.
      // Se registra la DIFERENCIA como fila aparte, que entra a la próxima liquidación.
      if (modal === 'edit' && selected) {
        try {
          await ajustarComisionesPorCambioDePct(polId, {
            ramoAntes:   selected.comision_ramo,
            ramoDespues: payload.comision_ramo,
            refAntes:    selected.referido_comision_pct,
            refDespues:  payload.referido_comision_pct,
          });
        } catch (e) { console.error('ajuste de comisiones por cambio de %', e); }
      }

      // Generar / regenerar plan de cuotas automáticamente (crear y editar, nunca en borrador)
      //
      // REGLA: el plan NO se regenera en cada guardado. Solo se (re)genera si:
      //   - es una póliza nueva, o
      //   - todavía no tiene plan de cuotas, o
      //   - cambió alguno de los parámetros que definen el plan (prima, impuesto,
      //     frecuencia, número de cuotas o fecha de inicio).
      // Si editas otros datos (asegurado, agentes, coberturas, etc.) las cuotas
      // existentes se respetan tal cual. Esto evita que guardar duplique el plan.
      // Las pólizas declarativas NO usan plan de cuotas fijas: sus saldos nacen de cada
      // declaración/endoso (ver módulo de Declaraciones). Por eso nunca se autogenera plan.
      let debeRegenerarPlan = false;
      // Periódica (colectivos/declarativas) NO usa plan de cuotas fijo: la facturación
      // nace de cada período (poliza_periodos), ver src/db/periodos.js.
      if (!esBorrador && !form.es_declarativa && form.facturacion_modo !== 'periodica' && form.prima && form.fecha_inicio) {
        if (modal === 'create' || !selected) {
          debeRegenerarPlan = true;
        } else {
          const { count: nCuotas } = await supabase.from('pagos')
            .select('id', { count: 'exact', head: true }).eq('poliza_id', polId);
          const planExiste = (nCuotas || 0) > 0;
          const norm = (v) => (v === null || v === undefined ? '' : String(v).trim());
          const paramsCambiaron =
            norm(selected.prima)          !== norm(form.prima)          ||
            norm(selected.impuesto)       !== norm(form.impuesto)       ||
            norm(selected.frecuencia_pago)!== norm(form.frecuencia_pago)||
            norm(selected.num_cuotas)     !== norm(form.num_cuotas)     ||
            norm(selected.fecha_inicio)   !== norm(form.fecha_inicio);
          debeRegenerarPlan = !planExiste || paramsCambiaron;
        }
      }

      if (debeRegenerarPlan) {
        // Obtener cuotas ya pagadas o parciales (con id y monto_pagado para poder actualizarlas)
        const { data: cuotasPagadas } = await supabase.from('pagos')
          .select('id, cuota_num, monto, monto_pagado, estado').eq('poliza_id', polId).in('estado', ['pagado', 'parcial']);
        const numsPagados = new Set((cuotasPagadas || []).map(c => c.cuota_num));
        const cuotasPagadasMap = {};
        for (const c of (cuotasPagadas || [])) cuotasPagadasMap[c.cuota_num] = c;

        // Borrar las cuotas pendientes (las pagadas/parciales se respetan).
        // IMPORTANTE: primero sus vínculos en cobro_cuotas. Si una cuota pendiente tiene
        // un cobro aplicado (ej. excedente del saco), el FK aborta el DELETE silenciosamente
        // y el plan se regenera DUPLICADO (este era el bug que creaba cuotas repetidas).
        const { data: pendientesActuales } = await supabase.from('pagos')
          .select('id').eq('poliza_id', polId).eq('estado', 'pendiente');
        const pendIds = (pendientesActuales || []).map(p => p.id);
        if (pendIds.length) {
          // Limpiar TODAS las referencias FK antes de borrar las cuotas pendientes.
          // Si queda cualquier referencia, Postgres aborta el DELETE completo en
          // silencio y el plan se regenera duplicado.
          await supabase.from('cobro_cuotas').delete().in('pago_id', pendIds);
          await supabase.from('comisiones').delete().in('pago_id', pendIds);
          await supabase.from('pagos').delete().in('id', pendIds);
        }

        // Calcular el plan completo. Fianza = pago único (1 cuota anual).
        const frecEff   = form.es_fianza ? 'anual' : form.frecuencia_pago;
        const cuotasEff = form.es_fianza ? '1' : form.num_cuotas;
        const { cuotas } = calcularCuotas(form.prima, form.impuesto, frecEff, cuotasEff, form.fecha_inicio);
        for (const c of cuotas) {
          if (numsPagados.has(c.num)) {
            // Cuota ya pagada/parcial: actualizar solo el monto al nuevo valor del plan
            const existing = cuotasPagadasMap[c.num];
            if (existing && Math.abs((parseFloat(existing.monto) || 0) - c.monto) > 0.01) {
              await updateRow('pagos', existing.id, { monto: c.monto });
            }
          } else {
            await insertRow('pagos', {
              poliza_id: polId,
              monto: c.monto,
              estado: 'pendiente',
              fecha_vencimiento: c.fecha,
              metodo: form.forma_pago || null,
              cuota_num: c.num,
            });
          }
        }

        // Reaplicar el saco: re-vincula los cobros existentes a las cuotas y recalcula estados
        await reaplicarSacoPoliza(polId);
      }

      // ── Pólizas DECLARATIVAS: NO se pregenera plan de cuotas ──────
      // Modelo "una letra por declaración": cada declaración (endoso) nace como su PROPIA
      // letra, con vencimiento en la fecha de vigencia del endoso (el mes que se declara).
      // Varias declaraciones pueden caer en el mismo mes (varias personas), cada una su
      // letra. Por eso NO se crean cuotas mensuales en $0 al emitir. Ver src/db/endosos y
      // el registro del endoso declarativo en Solicitudes.jsx.

      // ── Insertar registros de ajuste si aplica ──────────────────
      if (ajusteData) {
        const { byAgente } = ajusteData;
        const periodo = new Date().toISOString().slice(0, 7);
        const nota = `Ajuste por corrección de comisión — póliza ${form.numero || polId}, ${ajusteData.descripcion}`;
        for (const ag of Object.values(byAgente)) {
          if (Math.abs(ag.delta_agente) < 0.001 && Math.abs(ag.delta_ru) < 0.001) continue;
          await insertRow('comisiones', {
            poliza_id: polId,
            agente_id: ag.agente_id || null,
            tipo: 'ajuste',
            prima: 0,
            prima_base: Math.round(ag.prima_base_total * 100) / 100,
            porcentaje_agente: 0,
            porcentaje_ru: 0,
            monto_agente: Math.round(ag.delta_agente * 100) / 100,
            monto_ru:     Math.round(ag.delta_ru     * 100) / 100,
            periodo,
            estado: 'pendiente_aseg',
            notas: nota,
          });
        }
        setShowAjusteConfirm(false);
        setPendingAjuste(null);
      }

      await load();
      if (placaSinRUV) {
        alert('Placa guardada en la póliza.\n\nPara CERRAR la tarea de placa del CRM, adjunta el Registro Vehicular (RUV) en la pestaña Documentos de esta póliza y vuelve a guardar — o resuélvela desde el CRM (placa + RUV en un solo paso).');
      }
      // Tras CREAR una póliza directa, abrir su vista en la pestaña Documentos para
      // adjuntar la póliza y las condiciones particulares (son parte de la póliza).
      if (modal === 'create' && polId) {
        const { data: nueva } = await supabase.from('polizas')
          .select('*, clientes(nombre), aseguradoras(nombre), ramos(nombre), ejecutivos!polizas_ejecutivo_id_fkey(nombre)')
          .eq('id', polId).single();
        if (nueva) {
          await openView({ ...nueva, cliente: nueva.clientes?.nombre, aseguradora: nueva.aseguradoras?.nombre, ramo: nueva.ramos?.nombre, ejecutivo: nueva.ejecutivos?.nombre });
          setViewTab('docs');
          return;
        }
      }
      closeModal();
    } catch (e) { alert('Error: ' + (e.message || '')); }
  };

  const handleDelete = async (r) => {
    if (!window.confirm(`¿Eliminar póliza ${r.numero}?`)) return;
    try { await deleteRow('polizas', r.id); await load(); }
    catch { alert('No se puede eliminar — la póliza tiene registros asociados.'); }
  };

  const handleSort = (col) => {
    if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir('asc'); }
  };

  const sortIcon = (col) => {
    if (sortCol !== col) return <span style={{opacity:0.3,marginLeft:4}}>↕</span>;
    return <span style={{marginLeft:4,color:'var(--sky-light)'}}>{sortDir==='asc'?'↑':'↓'}</span>;
  };

  const rowsFiltrados = (() => {
    let arr = [...rows];
    // Filtros por selección (PolizaSelect/ClienteSelect): la lista solo se filtra al seleccionar.
    // Póliza: un mismo NÚMERO puede tener varias vigencias (renovación conservando el
    // número). Al elegir una en el buscador se muestran TODAS las vigencias de ese
    // número — el orden lo da la columna de sort (por defecto, vencimiento).
    if (filterPoliza) {
      const sel = rows.find(r => String(r.id) === String(filterPoliza));
      arr = sel && sel.numero
        ? arr.filter(r => r.numero === sel.numero)
        : arr.filter(r => String(r.id) === String(filterPoliza));
    }
    if (filterCliente)     arr = arr.filter(r => String(r.cliente_id) === String(filterCliente));
    if (filterAseguradora) arr = arr.filter(r => String(r.aseguradora_id) === filterAseguradora);
    if (filterRamo)        arr = arr.filter(r => String(r.ramo_id) === filterRamo);
    const campoFecha = filterFechaTipo === 'vig_inicial' ? 'fecha_inicio'
      : filterFechaTipo === 'vig_final' ? 'fecha_vencimiento'
      : filterFechaTipo === 'creacion' ? 'created_at' : null;
    if (campoFecha && filterFechaDesde) {
      arr = arr.filter(r => r[campoFecha] && r[campoFecha].slice(0,10) >= filterFechaDesde);
    }
    if (campoFecha && filterFechaHasta) {
      arr = arr.filter(r => r[campoFecha] && r[campoFecha].slice(0,10) <= filterFechaHasta);
    }
    arr.sort((a, b) => {
      let va = a[sortCol] ?? '';
      let vb = b[sortCol] ?? '';
      if (typeof va === 'string') va = va.toLowerCase();
      if (typeof vb === 'string') vb = vb.toLowerCase();
      if (va < vb) return sortDir === 'asc' ? -1 : 1;
      if (va > vb) return sortDir === 'asc' ?  1 : -1;
      return 0;
    });
    return arr;
  })();

  // Búsqueda primero: la tabla no muestra pólizas hasta aplicar un filtro.
  const hayFiltro = !!(filterPoliza || filterEstado || filterCliente || filterAseguradora
    || filterRamo || filterFechaTipo);

  // Descripción de los filtros activos (para encabezado del export)
  const resumenFiltro = (() => {
    const partes = [];
    if (filterPoliza) partes.push(`Póliza: ${rows.find(r=>String(r.id)===String(filterPoliza))?.numero || filterPoliza}`);
    if (filterEstado) partes.push(`Estado: ${filterEstado}`);
    if (filterCliente) partes.push(`Cliente: ${clientes.find(c=>String(c.id)===String(filterCliente))?.nombre || filterCliente}`);
    if (filterAseguradora) partes.push(`Aseguradora: ${aseguradoras.find(a=>String(a.id)===filterAseguradora)?.nombre || filterAseguradora}`);
    if (filterRamo) partes.push(`Ramo: ${ramos.find(r=>String(r.id)===filterRamo)?.nombre || filterRamo}`);
    if (filterFechaTipo) {
      const etq = filterFechaTipo === 'vig_inicial' ? 'Vig. inicial' : filterFechaTipo === 'vig_final' ? 'Vig. final' : 'Creación';
      const rango = [filterFechaDesde && `desde ${fmtFecha(filterFechaDesde)}`, filterFechaHasta && `hasta ${fmtFecha(filterFechaHasta)}`].filter(Boolean).join(' ');
      partes.push(`${etq}${rango ? ' ' + rango : ''}`);
    }
    return partes.length ? partes.join('  ·  ') : 'Todas las pólizas';
  })();

  const diasParaVencer = (fecha) => Math.ceil((new Date(fecha) - new Date()) / 86400000);
  const agentesDisponibles = agentes.filter(a => !polizaAgentes.find(p => String(p.agente_id) === String(a.id)));

  // ── Render: bloque deducible por cobertura ───────────────────────
  const renderDeducibleFields = (c, idx) => (
    <div style={{ marginTop:10, paddingTop:10, borderTop:'1px solid rgba(var(--silver-rgb),0.15)' }}>
      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
        <input type="checkbox" id={`ded-${idx}`} checked={c.tiene_deducible}
          onChange={e=>updateCobertura(idx, 'tiene_deducible', e.target.checked)}
          style={{ accentColor:'var(--sky)', width:14, height:14, cursor:'pointer' }} />
        <label htmlFor={`ded-${idx}`} style={{ fontSize:12, color:'var(--silver)', cursor:'pointer' }}>¿Lleva deducible?</label>
      </div>
      {c.tiene_deducible && (
        <div style={{ paddingLeft:22 }}>
          <div style={{ marginBottom:8 }}>
            <select style={{ width:'100%', padding:'5px 8px', fontSize:12, borderRadius:6,
              background:'rgba(var(--steel-rgb),0.5)', border:'1px solid rgba(var(--silver-rgb),0.2)', color:'var(--text)',
              fontFamily:'var(--font)' }}
              value={c.deducible_tipo}
              onChange={e=>updateCobertura(idx, 'deducible_tipo', e.target.value)}>
              <option value="evento">Monto fijo por evento</option>
              <option value="persona_evento">Por persona y por evento</option>
              <option value="pct_minimo">% de la SA con mínimo</option>
              <option value="pct">% de la SA</option>
              <option value="personalizado">Estructura personalizada</option>
            </select>
          </div>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
            {c.deducible_tipo === 'evento' && (
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <span style={{ fontSize:11, color:'var(--silver)' }}>Por evento $</span>
                <input type="number" value={c.ded_por_evento} onChange={e=>updateCobertura(idx,'ded_por_evento',e.target.value)}
                  style={inputSm} placeholder="0" />
              </div>
            )}
            {c.deducible_tipo === 'persona_evento' && (<>
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <span style={{ fontSize:11, color:'var(--silver)' }}>Por persona $</span>
                <input type="number" value={c.ded_por_persona} onChange={e=>updateCobertura(idx,'ded_por_persona',e.target.value)} style={inputSm} placeholder="0" />
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <span style={{ fontSize:11, color:'var(--silver)' }}>Por evento $</span>
                <input type="number" value={c.ded_por_evento} onChange={e=>updateCobertura(idx,'ded_por_evento',e.target.value)} style={inputSm} placeholder="0" />
              </div>
            </>)}
            {(c.deducible_tipo === 'pct' || c.deducible_tipo === 'pct_minimo') && (
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <span style={{ fontSize:11, color:'var(--silver)' }}>%</span>
                <input type="number" value={c.ded_pct} onChange={e=>updateCobertura(idx,'ded_pct',e.target.value)} style={inputSm} placeholder="0" />
              </div>
            )}
            {c.deducible_tipo === 'pct_minimo' && (
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <span style={{ fontSize:11, color:'var(--silver)' }}>Mínimo $</span>
                <input type="number" value={c.ded_minimo} onChange={e=>updateCobertura(idx,'ded_minimo',e.target.value)} style={inputSm} placeholder="0" />
              </div>
            )}
            {c.deducible_tipo === 'personalizado' && (
              <input type="text" value={c.ded_personalizado} onChange={e=>updateCobertura(idx,'ded_personalizado',e.target.value)}
                placeholder="Ej: 10% del valor del siniestro" style={{ ...inputSm, width:260 }} />
            )}
          </div>
          {formatDeducible(c) && (
            <div style={{ marginTop:6, fontSize:11, color:'var(--sky-light)', fontStyle:'italic' }}>
              → {formatDeducible(c)}
            </div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div>
      <div className="page-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div>
          <div className="page-title">Pólizas</div>
          <div className="page-subtitle">{vista === 'renovaciones' ? 'Avance de renovaciones del período' : hayFiltro ? `${rowsFiltrados.length} de ${rows.length} registros` : 'Aplica un filtro para ver pólizas'}</div>
        </div>
        {vista === 'lista' && canEdit('polizas') && (
          <button className="btn btn-primary" onClick={openCreate}>
            <Plus size={16} /> Nueva Póliza
          </button>
        )}
      </div>

      {/* Toggle: lista de pólizas | avance de renovaciones del período */}
      <div style={{ display:'flex', borderRadius:8, overflow:'hidden', border:'1px solid rgba(var(--silver-rgb),0.2)', width:'fit-content', marginBottom:14 }}>
        {[['lista','Lista de pólizas'],['renovaciones','Renovaciones']].map(([v,l]) => (
          <button key={v} onClick={()=>setVista(v)} style={{
            padding:'7px 16px', fontSize:13, border:'none', cursor:'pointer', fontFamily:'var(--font)',
            background: vista===v ? 'var(--sky)' : 'transparent',
            color: vista===v ? '#fff' : 'var(--silver)',
          }}>{l}</button>
        ))}
      </div>

      {vista === 'renovaciones' && (
        <RenovacionesView aseguradoras={aseguradoras} ramos={ramos} ejecutivos={ejecutivos} agentes={agentes}
          onVerPoliza={(id)=>{ setVista('lista'); setFilterPoliza(String(id)); }} />
      )}

      {vista === 'lista' && (<>
      <div className="toolbar" style={{flexWrap:'wrap',gap:8,alignItems:'flex-end'}}>
        <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
          <span style={filterLabel}>N° de póliza</span>
          <PolizaSelect value={filterPoliza} onChange={setFilterPoliza} width={220} />
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
          <span style={filterLabel}>Cliente</span>
          <ClienteSelect options={clientes} value={filterCliente} onChange={setFilterCliente} placeholder="Filtrar por cliente..." width={200} />
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
          <span style={filterLabel}>Estado</span>
          <select className="form-select" style={{ width:160 }} value={filterEstado} onChange={e=>setFilterEstado(e.target.value)}>
            <option value="">Todos los estados</option>
            <option value="borrador">Borrador</option>
            <option value="activa">Activa</option>
            <option value="vencida">Vencida</option>
            <option value="no_renovada">No renovada</option>
            <option value="renovada">Renovada</option>
            <option value="en_renovacion">En Renovación</option>
            <option value="cancelada">Cancelada</option>
          </select>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
          <span style={filterLabel}>Aseguradora</span>
          <select className="form-select" style={{ width:160 }} value={filterAseguradora} onChange={e=>setFilterAseguradora(e.target.value)}>
            <option value="">Todas las aseguradoras</option>
            {aseguradoras.map(a=><option key={a.id} value={a.id}>{a.nombre}</option>)}
          </select>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
          <span style={filterLabel}>Ramo</span>
          <select className="form-select" style={{ width:140 }} value={filterRamo} onChange={e=>setFilterRamo(e.target.value)}>
            <option value="">Todos los ramos</option>
            {ramos.map(r=><option key={r.id} value={r.id}>{r.nombre}</option>)}
          </select>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
          <span style={filterLabel}>Fecha</span>
          <select className="form-select" style={{ width:180 }} value={filterFechaTipo} onChange={e=>{ setFilterFechaTipo(e.target.value); setFilterFechaDesde(''); setFilterFechaHasta(''); }} title="Por cuál fecha filtrar">
            <option value="">Sin filtro de fecha</option>
            <option value="vig_inicial">Fecha vig. inicial</option>
            <option value="vig_final">Fecha vig. final (venc.)</option>
            <option value="creacion">Fecha de creación</option>
          </select>
        </div>
        {filterFechaTipo && (<>
          <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
            <span style={filterLabel}>Desde</span>
            <input className="form-input" type="date" style={{width:140}} value={filterFechaDesde} onChange={e=>setFilterFechaDesde(e.target.value)} title="Desde" />
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
            <span style={filterLabel}>Hasta</span>
            <input className="form-input" type="date" style={{width:140}} value={filterFechaHasta} onChange={e=>setFilterFechaHasta(e.target.value)} title="Hasta" />
          </div>
        </>)}
        {(filterEstado||filterPoliza||filterCliente||filterAseguradora||filterRamo||filterFechaTipo) && (
          <button className="btn btn-secondary btn-sm" onClick={()=>{ setFilterEstado(''); setFilterPoliza(''); setFilterCliente(''); setFilterAseguradora(''); setFilterRamo(''); setFilterFechaTipo(''); setFilterFechaDesde(''); setFilterFechaHasta(''); }}>
            ✕ Limpiar
          </button>
        )}
        <div style={{ display:'flex', gap:6, marginLeft:'auto' }}>
          <button className="btn btn-secondary btn-sm" title="Exportar la lista filtrada a Excel"
            onClick={()=>exportarPolizasExcel(rowsFiltrados, sid=>allSubramos.find(s=>s.id===sid)?.nombre, resumenFiltro)}
            disabled={rowsFiltrados.length===0}>
            <FileText size={13}/> Excel
          </button>
          <button className="btn btn-secondary btn-sm" title="Imprimir / PDF de la lista filtrada"
            onClick={()=>exportarPolizasPDF(rowsFiltrados, sid=>allSubramos.find(s=>s.id===sid)?.nombre, resumenFiltro)}
            disabled={rowsFiltrados.length===0}>
            <FileText size={13}/> PDF
          </button>
        </div>
      </div>

      <div style={{fontSize:12,color:'var(--silver)',marginBottom:6,paddingLeft:2}}>
        {rowsFiltrados.length} póliza{rowsFiltrados.length !== 1 ? 's' : ''}{rows.length !== rowsFiltrados.length ? ` (de ${rows.length})` : ''}
      </div>
      <div className="table-wrapper">
        <table>
          <thead><tr>
            {[['numero','Número'],['cliente','Cliente'],['ramo','Ramo'],['aseguradora','Aseguradora'],
              ['prima','Prima'],['ejecutivo','Ejecutivo'],['fecha_vencimiento','Vencimiento'],['estado','Estado']
            ].map(([col,label])=>(
              <th key={col} onClick={()=>handleSort(col)} style={{cursor:'pointer',userSelect:'none',whiteSpace:'nowrap'}}>
                {label}{sortIcon(col)}
              </th>
            ))}
            <th>Acciones</th>
          </tr></thead>
          <tbody>
            {!hayFiltro ? (
              <tr><td colSpan={9}><div className="empty-state"><div className="empty-state-icon"><Search size={48} /></div><div className="empty-state-title">Busca una póliza para verla</div><div>Filtra por póliza, cliente, estado, aseguradora, ramo o fecha. La lista no muestra todas las pólizas de una vez.</div></div></td></tr>
            ) : rowsFiltrados.length === 0 ? (
              <tr><td colSpan={9}><div className="empty-state"><div className="empty-state-icon"><FileText size={48} /></div><div className="empty-state-title">Sin resultados</div></div></td></tr>
            ) : rowsFiltrados.map(r => {
              const dias = r.fecha_vencimiento ? diasParaVencer(r.fecha_vencimiento) : null;
              const alerta = dias != null && dias >= 0 && dias <= 60;
              return (
                <tr key={r.id} style={alerta ? { background:'rgba(245, 158, 11, 0.04)' } : {}}>
                  <td style={{ fontWeight:700 }}>
                    {r.numero
                      ? <span onClick={()=>openView(r)} title="Ver póliza"
                          style={{ color:'var(--sky-light)', cursor:'pointer' }}>{r.numero}</span>
                      : <span className="text-silver">—</span>}
                  </td>
                  <td style={{ fontWeight:600 }}>{r.cliente}</td>
                  <td>{r.ramo}</td>
                  <td className="text-silver">{r.aseguradora}</td>
                  <td className="text-success font-bold">{r.prima ? fmt$(r.prima) : '—'}</td>
                  <td className="text-silver">{r.ejecutivo || '—'}</td>
                  <td>
                    <div style={{ display:'flex', flexDirection:'column', gap:2 }}>
                      <span>{fmtFecha(r.fecha_vencimiento) || '—'}</span>
                      {dias != null && dias >= 0 && dias <= 60 && <span className="badge badge-warning" style={{ fontSize:10 }}>Vence en {dias}d</span>}
                      {dias != null && dias < 0 && r.estado === 'activa' && <span className="badge badge-danger" style={{ fontSize:10 }}>Vencida</span>}
                    </div>
                  </td>
                  <td><span className={`badge ${ESTADO_BADGE[r.estado] || 'badge-neutral'}`}>{etiquetaEstadoPoliza(r.estado)}</span></td>
                  <td>
                    <div style={{ display:'flex', gap:6 }}>
                      <button className="btn btn-icon btn-secondary btn-sm" onClick={()=>openView(r)} title="Ver póliza"><Eye size={14} /></button>
                      {canEdit('polizas') && <>
                        <button className="btn btn-icon btn-secondary btn-sm" onClick={()=>openEdit(r)} title="Editar póliza"><Edit2 size={14} /></button>
                        <button className="btn btn-icon btn-secondary btn-sm" onClick={()=>openRenovar(r)} title="Renovar póliza"><RotateCw size={14} /></button>
                        <button className="btn btn-icon btn-danger btn-sm" onClick={()=>handleDelete(r)} title="Eliminar póliza"><Trash2 size={14} /></button>
                      </>}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      </>)}

      {/* ── Modal: Endoso interno (cambio directo, la aseguradora no envía documento) ── */}
      {eiModal && eiForm && (
        <div className="modal-overlay" style={{ zIndex:1600 }} onClick={closeEndosoInterno}>
          <div className="modal modal-lg" style={{ maxWidth:720, maxHeight:'92vh', display:'flex', flexDirection:'column', overflow:'hidden' }} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">Endoso interno — {eiModal.numero || ''}</div>
              <button className="btn btn-icon btn-secondary btn-sm" onClick={closeEndosoInterno}><X size={16}/></button>
            </div>
            <div className="modal-body" style={{ flex:1, minHeight:0, overflowY:'auto' }}>
              <div style={{ display:'flex', alignItems:'flex-start', gap:9, padding:'10px 13px', marginBottom:16,
                background:'rgba(var(--sky-rgb),0.08)', border:'1px solid rgba(var(--sky-rgb),0.25)', borderRadius:8, fontSize:12, color:'var(--sky-light)' }}>
                <Lock size={15} style={{ flexShrink:0, marginTop:1 }} />
                <span>Cambio <strong>interno</strong>: la aseguradora no envía endoso y no se envía al cliente. Se <strong>registra y aplica directo</strong> a la póliza (queda en el historial de endosos, marcado como interno).</span>
              </div>
              <div className="form-group" style={{ maxWidth:220 }}>
                <label className="form-label">Fecha *</label>
                <input className="form-input" type="date" value={eiForm.fecha} onChange={e=>eif('fecha', e.target.value)} />
              </div>
              <div style={{ marginTop:14, paddingTop:14, borderTop:'1px dashed rgba(var(--sky-rgb),0.3)' }}>
                <label className="form-label" style={{ color:'var(--sky-light)' }}>Cambios (puedes agregar varios)</label>
                <EndosoCambiosMulti tipos={endosoTiposLista} ramoId={eiModal.ramo_id} polizaId={eiModal.id}
                  value={eiForm.cambiosList} onChange={list => eif('cambiosList', list)} />
              </div>
              <div className="form-group" style={{ marginTop:14 }}>
                <label className="form-label">Descripción / motivo interno *</label>
                <textarea className="form-textarea" rows={2} value={eiForm.descripcion} onChange={e=>eif('descripcion', e.target.value)}
                  placeholder="¿Qué se corrige y por qué? (queda en el historial de endosos)" />
              </div>
              <div className="form-grid form-grid-2">
                <div className="form-group">
                  <label className="form-label">Cambio de prima (sin imp.) — opcional</label>
                  <input className="form-input" type="number" step="0.01" value={eiForm.delta_prima} onChange={e=>eif('delta_prima', e.target.value)}
                    placeholder="Ej: 40 (aumento) o -20 (reducción)" />
                  <div style={{ fontSize:11, color:'var(--silver)', marginTop:4 }}>Déjalo vacío o 0 si no mueve prima. Si mueve, se diluye en las cuotas igual que un endoso normal.</div>
                </div>
                <div className="form-group">
                  <label className="form-label">N° de endoso (opcional)</label>
                  <input className="form-input" value={eiForm.numero_endoso} onChange={e=>eif('numero_endoso', e.target.value)} placeholder="Referencia interna" />
                </div>
                {parseFloat(eiForm.delta_prima || 0) !== 0 && (
                  <div className="form-group" style={{ gridColumn:'span 2', background:'rgba(var(--sky-rgb),0.08)', border:'1px solid rgba(var(--sky-rgb),0.25)', borderRadius:8, padding:'10px 12px' }}>
                    <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:12.5, fontWeight:600 }}>
                      <input type="checkbox" checked={!!eiForm.prima_recurrente_mensual} onChange={e=>eif('prima_recurrente_mensual', e.target.checked)} style={{ accentColor:'var(--sky)', width:15, height:15 }} />
                      El cambio de prima es <span style={{ color:'var(--sky-light)' }}>mensual recurrente</span> (se suma a cada letra futura)
                    </label>
                    <div style={{ fontSize:11, color:'var(--silver)', marginTop:4 }}>Para cambios que suben/bajan la <strong>cuota mensual</strong> (ej. dependiente en Vida/Salud individual): el monto se suma a <strong>cada letra futura</strong> en vez de diluirse una vez.</div>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeEndosoInterno}>Cancelar</button>
              <button className="btn btn-primary" onClick={handleGuardarEndosoInterno} disabled={savingEI}>{savingEI ? 'Guardando…' : 'Registrar y aplicar'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ Modal Crear / Editar ══════════════════════════════════════ */}
      {/* ── Modal compacto: edición administrativa de una póliza bloqueada (no-master) ── */}
      {adminModal && adminForm && (
        <div className="modal-overlay" onClick={closeAdminModal}>
          <div className="modal" style={{ maxWidth:580 }} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">Editar datos administrativos</div>
              <button className="btn btn-icon btn-secondary btn-sm" onClick={closeAdminModal}><X size={16} /></button>
            </div>
            <div className="modal-body">
              <div style={{ display:'flex', alignItems:'flex-start', gap:10, padding:'12px 14px', marginBottom:18,
                background:'rgba(245, 158, 11, 0.1)', border:'1px solid rgba(245, 158, 11, 0.35)', borderRadius:8, fontSize:12.5, color:'var(--text-warning)' }}>
                <Lock size={16} style={{ flexShrink:0, marginTop:1 }} />
                <div style={{ flex:1 }}>
                  Póliza <strong>{adminModal.numero || ''}</strong> bloqueada. Los cambios de riesgo (prima, vigencia, coberturas, vehículo, forma de pago…) se hacen por <strong>endoso</strong>. Aquí solo editas datos administrativos.
                  <div style={{ marginTop:8 }}>
                    <button className="btn btn-primary btn-sm" onClick={()=>irACrearEndoso(adminModal)}><FileText size={13} /> Crear endoso</button>
                  </div>
                </div>
              </div>

              <SectionTitle>EJECUTIVOS</SectionTitle>
              <div className="form-grid form-grid-3">
                {(() => {
                  const conActual = (lista, val) => {
                    const arr = lista.slice();
                    if (val && !arr.find(x => String(x.id) === String(val))) {
                      const cur = ejecutivos.find(x => String(x.id) === String(val));
                      if (cur) arr.unshift(cur);
                    }
                    return arr;
                  };
                  const slots = [
                    ['Ejecutivo de Cuenta',  'ejecutivo_id',         ejecutivos.filter(e => e.func?.cuenta)],
                    ['Ejecutivo de Cobro',   'ejecutivo_cobro_id',   ejecutivos.filter(e => e.func?.cobro)],
                    ['Ejecutivo de Reclamo', 'ejecutivo_reclamo_id', ejecutivos.filter(e => e.func?.reclamo)],
                  ];
                  return slots.map(([lbl, key, lista]) => (
                    <div className="form-group" key={key}>
                      <label className="form-label">{lbl}</label>
                      <select className="form-select" value={adminForm[key] || ''} onChange={e => afk(key, e.target.value)}>
                        <option value="">Sin asignar</option>
                        {conActual(lista, adminForm[key]).map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
                      </select>
                    </div>
                  ));
                })()}
              </div>

              <div style={{ marginTop:20 }}>
                <SectionTitle>REFERIDO</SectionTitle>
                <div className="form-grid form-grid-3">
                  <div className="form-group" style={{ gridColumn:'span 2' }}>
                    <label className="form-label">Referido por</label>
                    <SearchSelect options={[{ id:'', nombre:'— Sin referido —' }, ...referidos]} value={adminForm.referido_id}
                      onChange={val => afk('referido_id', val)} placeholder="Buscar referidor..." />
                  </div>
                  <div className="form-group">
                    <label className="form-label">% Comisión referido</label>
                    <input className="form-input" type="number" step="0.01"
                      value={adminForm.referido_comision_pct} placeholder="0.00" disabled readOnly
                      title="El % del referido mueve dinero: lleva el mismo candado que el % de comisión" />
                    <div className="text-silver" style={{ fontSize:10, marginTop:4 }}>Solo lo cambia el master</div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop:20 }}>
                <SectionTitle>NOTAS</SectionTitle>
                <textarea className="form-textarea" rows={3} value={adminForm.notas} onChange={e => afk('notas', e.target.value)} placeholder="Notas administrativas..." />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeAdminModal}>Cancelar</button>
              <button className="btn btn-primary" onClick={handleSaveAdmin} disabled={savingAdmin}>{savingAdmin ? 'Guardando…' : 'Guardar'}</button>
            </div>
          </div>
        </div>
      )}

      {(modal === 'create' || modal === 'edit') && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal modal-lg" style={{ maxWidth:860, maxHeight:'92vh', display:'flex', flexDirection:'column', overflow:'hidden' }} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">{modal === 'create' ? 'Nueva Póliza' : 'Editar Póliza'}</div>
              <button className="btn btn-icon btn-secondary btn-sm" onClick={closeModal}><X size={16} /></button>
            </div>
            <div className="modal-body" style={{ flex:1, minHeight:0, overflowY:'auto' }}>

              {/* Cargar la póliza con IA (opcional): lee el PDF/imagen de la carátula y
                  autocompleta el formulario para evitar errores de digitación. */}
              {modal === 'create' && (
                <div style={{ padding:'12px 14px', marginBottom:16, background:'rgba(var(--sky-rgb),0.08)', border:'1px solid rgba(var(--sky-rgb),0.3)', borderRadius:8 }}>
                  <input ref={polizaIAFileRef} type="file" accept=".pdf,image/*" style={{ display:'none' }}
                    onChange={e=>cargarPolizaIA(e.target.files?.[0]||null)} />
                  <div style={{ display:'flex', alignItems:'center', gap:12, flexWrap:'wrap' }}>
                    <div style={{ flex:1, minWidth:220 }}>
                      <div style={{ fontSize:13, fontWeight:700, color:'var(--sky-light)' }}>✨ Cargar póliza con IA (opcional)</div>
                      <div style={{ fontSize:11.5, color:'var(--silver)' }}>Sube la carátula (PDF o foto) y se llenan los datos solos: número, vigencia, prima, partes, vehículo y coberturas. Revisa todo antes de guardar — o llénalo manual.</div>
                    </div>
                    <button type="button" className="btn btn-primary btn-sm" disabled={leyendoPolizaIA}
                      onClick={()=>polizaIAFileRef.current?.click()}>
                      {leyendoPolizaIA ? 'Leyendo…' : 'Subir y leer con IA'}
                    </button>
                  </div>
                  {iaPolizaInfo && (iaPolizaInfo.aseguradora || iaPolizaInfo.ramo) && (
                    <div style={{ fontSize:12, color:'var(--text-success)', marginTop:8 }}>
                      ✓ Datos cargados. Detectado: {[iaPolizaInfo.aseguradora, iaPolizaInfo.ramo].filter(Boolean).join(' · ')} — revisa lo autocompletado (aseguradora/ramo se emparejan solos si están en el catálogo) y elige el cliente.
                    </div>
                  )}
                  {iaPolizaInfo?.avisoPrima && (
                    <div style={{ fontSize:12, color:'var(--text-warning)', marginTop:6 }}>
                      ⚠️ {iaPolizaInfo.avisoPrima} Confírmala contra la carátula.
                    </div>
                  )}
                </div>
              )}

              {modal === 'edit' && selected?.bloqueada_edicion && (
                <div style={{ display:'flex', alignItems:'flex-start', gap:10, padding:'10px 14px', marginBottom:16,
                  background:'rgba(245, 158, 11, 0.1)', border:'1px solid rgba(245, 158, 11, 0.35)', borderRadius:8, fontSize:12.5, color:'var(--text-warning)' }}>
                  <Lock size={15} style={{ flexShrink:0, marginTop:1 }} />
                  <span>Póliza <strong>bloqueada</strong>. Estás editando en <strong>modo directo (master)</strong> — quedará registrado en bitácora. El flujo normal para cambios de riesgo es por <strong>endoso</strong>.</span>
                </div>
              )}

              {/* Motivo del cambio: aparece SOLO cuando de verdad se tocó algo de riesgo,
                  con la lista de lo que cambió. Un campo que sale siempre se llena en
                  automático y deja de significar algo. */}
              {modal === 'edit' && selected?.estado !== 'borrador' && (() => {
                const riesgo = difsEdicionActual().filter(d => d.riesgo);
                if (!riesgo.length) return null;
                return (
                  <div style={{ padding:'12px 14px', marginBottom:16, borderRadius:8,
                    background:'rgba(245, 158, 11, 0.08)', border:'1px solid rgba(245, 158, 11, 0.35)' }}>
                    <div style={{ fontSize:12, fontWeight:700, color:'var(--text-warning)', marginBottom:6 }}>
                      Estás cambiando datos de riesgo
                    </div>
                    <div style={{ fontSize:12, color:'var(--silver)', marginBottom:10 }}>
                      {riesgo.map(d => `${d.label}: ${d.antes || '—'} → ${d.despues || '—'}`).join(' · ')}
                    </div>
                    <label className="form-label">Motivo del cambio *</label>
                    <input className="form-input" value={motivoCambio}
                      onChange={e => setMotivoCambio(e.target.value)}
                      placeholder="Ej.: corrección de la fecha que vino mal en la carátula" />
                    <div style={{ fontSize:11, color:'var(--silver)', marginTop:4 }}>
                      Queda en la bitácora de la póliza con tu nombre. Si es un cambio real de la
                      cobertura o de la vigencia, el camino correcto es un <strong>endoso</strong>.
                    </div>
                  </div>
                );
              })()}

              {/* ── 1. Identificación de la póliza ── */}
              <SectionTitle>IDENTIFICACIÓN DE LA PÓLIZA</SectionTitle>
              <div className="form-grid form-grid-3">
                <div className="form-group">
                  <label className="form-label">Número de Póliza</label>
                  <input className="form-input" value={form.numero} onChange={e=>f('numero', e.target.value)} placeholder="POL-2026-001" />
                </div>
                <div className="form-group">
                  <label className="form-label">Tipo</label>
                  <select className="form-select" value={form.tipo} onChange={e=>f('tipo', e.target.value)}>
                    <option value="nueva">Nueva</option>
                    <option value="renovacion">Renovación</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Estado</label>
                  <select className="form-select" value={form.estado} onChange={e=>f('estado', e.target.value)}>
                    <option value="borrador">Borrador</option>
                    <option value="activa">Activa</option>
                    <option value="vencida">Vencida</option>
                    <option value="no_renovada">No renovada</option>
                    <option value="renovada">Renovada</option>
                    <option value="en_renovacion">En Renovación</option>
                    <option value="cancelada">Cancelada</option>
                  </select>
                </div>

                {form.tipo === 'renovacion' && (
                  <div className="form-group" style={{ gridColumn:'span 2' }}>
                    <label className="form-label">Póliza anterior (vigencia a renovar)</label>
                    {/* Buscador, NO un desplegable con toda la cartera: se escribe el número
                        de póliza y se elige. Con cientos de pólizas la lista suelta era
                        inusable, y cuando vincular cuesta la gente no vincula — ahí es donde
                        se pierde la cadena de renovación. */}
                    <PolizaSelect
                      value={form.poliza_anterior_id}
                      onChange={v => f('poliza_anterior_id', v ? String(v) : '')}
                      excludeId={selected?.id}
                      placeholder="Escribe el número de póliza o el cliente..."
                    />
                    <div style={{ fontSize:11, color:'var(--silver)', marginTop:4 }}>Vincula la póliza anterior (queda mapeada como renovación)</div>
                    {form.poliza_anterior_id && (
                      <>
                        <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:12.5, fontWeight:600, marginTop:10 }}>
                          <input type="checkbox" checked={form.arrastra_saldo !== false}
                            onChange={e=>f('arrastra_saldo', e.target.checked)} style={{ accentColor:'var(--sky)', width:15, height:15 }}/>
                          La aseguradora <span style={{ color:'var(--sky-light)' }}>arrastra el saldo pendiente</span> de la anterior
                        </label>
                        <div style={{ fontSize:11, color:'var(--silver)', marginTop:2 }}>Desmárcalo si es <strong>póliza nueva</strong> de la aseguradora: mapea igual, pero el cobro arranca independiente (sin arrastrar saldo).</div>
                      </>
                    )}
                  </div>
                )}
              </div>

              {/* ── 2. Cliente ── */}
              <div style={{ marginTop:24 }}>
                <SectionTitle>CLIENTE</SectionTitle>
                <div className="form-grid form-grid-3">
                  <div className="form-group" style={{ gridColumn:'span 2' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4 }}>
                      <label className="form-label" style={{ margin:0 }}>Cliente *</label>
                      <button className="btn btn-sm btn-secondary" style={{ fontSize:11, padding:'2px 8px' }}
                        onClick={()=>{ setCliForm(EMPTY_CLI); setShowCrearCliente(true); }} type="button">
                        <UserPlus size={12} /> Nuevo cliente
                      </button>
                    </div>
                    <ClienteSelect options={clientes} value={form.cliente_id} onChange={handleClienteChange} />
                  </div>

                  {(() => {
                    // Cada selector muestra solo los ejecutivos cuyo usuario tiene esa función;
                    // se garantiza que el valor ya guardado aparezca aunque no cumpla el filtro.
                    const conActual = (lista, val) => {
                      const arr = lista.slice();
                      if (val && !arr.find(x => String(x.id) === String(val))) {
                        const cur = ejecutivos.find(x => String(x.id) === String(val));
                        if (cur) arr.unshift(cur);
                      }
                      return arr;
                    };
                    const slots = [
                      ['Ejecutivo de Cuenta',  'ejecutivo_id',          ejecutivos.filter(e => e.func?.cuenta)],
                      ['Ejecutivo de Cobro',   'ejecutivo_cobro_id',    ejecutivos.filter(e => e.func?.cobro)],
                      ['Ejecutivo de Reclamo', 'ejecutivo_reclamo_id',  ejecutivos.filter(e => e.func?.reclamo)],
                    ];
                    return slots.map(([lbl, key, lista]) => (
                      <div className="form-group" key={key}>
                        <label className="form-label">{lbl}</label>
                        <select className="form-select" value={form[key] || ''} onChange={e => f(key, e.target.value)}>
                          <option value="">Sin asignar</option>
                          {conActual(lista, form[key]).map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
                        </select>
                        {key === 'ejecutivo_id' && ejecutivoCambiado && (
                          <div style={{ display:'flex', alignItems:'center', gap:5, marginTop:5, fontSize:11, color:'var(--text-warning)' }}>
                            <AlertTriangle size={12} /> Estás cambiando el ejecutivo asignado al cliente
                          </div>
                        )}
                      </div>
                    ));
                  })()}
                </div>
              </div>

              {/* ── 3. Prima, forma de pago y comisiones ── */}
              <div style={{ marginTop:24 }}>
                <SectionTitle>PRIMA</SectionTitle>
                <div className="form-grid form-grid-3">
                  <div className="form-group">
                    <label className="form-label">Prima *</label>
                    <input className="form-input" type="number" step="0.01" value={form.prima} onChange={e=>f('prima', e.target.value)} placeholder="0.00" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">% Impuesto</label>
                    <input className="form-input" type="number" step="0.01" value={form.impuesto} onChange={e=>f('impuesto', e.target.value)} />
                  </div>
                  <div className="form-group" style={{ display:'flex', alignItems:'flex-end' }}>
                    <div style={{ fontSize:13, color:'var(--silver)', paddingBottom:8 }}>
                      Total c/impuesto: <strong style={{ color:'var(--sky-light)' }}>{fmt$(parseFloat(form.prima||0)*(1+parseFloat(form.impuesto||0)/100))}</strong>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── Plan de Pago ── */}
              {!form.es_fianza && (
              <div style={{ marginTop:24 }}>
                <SectionTitle>FACTURACIÓN</SectionTitle>
                <div className="form-grid form-grid-3">
                  <div className="form-group">
                    <label className="form-label">Modo de facturación</label>
                    <select className="form-select" value={form.facturacion_modo}
                      onChange={e=>f('facturacion_modo', e.target.value)}>
                      <option value="cuotas">Cuotas fijas (plan al emitir)</option>
                      <option value="periodica">Periódica / por declaración</option>
                    </select>
                  </div>
                  {form.facturacion_modo === 'periodica' && (
                    <div className="form-group">
                      <label className="form-label">Frecuencia del período</label>
                      <select className="form-select" value={form.periodo_frecuencia}
                        onChange={e=>f('periodo_frecuencia', e.target.value)}>
                        <option value="mensual">Mensual</option>
                        <option value="trimestral">Trimestral</option>
                      </select>
                    </div>
                  )}
                  {form.facturacion_modo === 'periodica' && form.es_declarativa && (
                    <div className="form-group">
                      <label className="form-label">Modo declarativa</label>
                      <select className="form-select" value={form.declarativa_modo}
                        onChange={e=>f('declarativa_modo', e.target.value)}>
                        <option value="mensual">Mensual (paga cada declaración)</option>
                        <option value="acumulativo">Acumulativo (ajuste anual)</option>
                      </select>
                    </div>
                  )}
                </div>
                {form.facturacion_modo === 'periodica' && (
                  <div style={{ fontSize:12, color:'var(--silver)', marginTop:6 }}>
                    No se genera plan de cuotas fijo. Cada período, la aseguradora factura y el ejecutivo registra la factura (tarea automática en el CRM); entra al saco y se envía al cliente.
                  </div>
                )}
              </div>
              )}

              {!form.es_declarativa && !form.es_fianza && form.facturacion_modo !== 'periodica' && (
              <div style={{ marginTop:24 }}>
                <SectionTitle>FORMA DE PAGO</SectionTitle>
                <div className="form-grid form-grid-3">
                  <div className="form-group">
                    <label className="form-label">Forma de Pago</label>
                    <select className="form-select" value={form.forma_pago} onChange={e=>f('forma_pago', e.target.value)}>
                      <option value="">Seleccionar...</option>
                      <option value="ACH">ACH</option>
                      <option value="TC">Tarjeta de Crédito</option>
                      <option value="Yappy a Aseguradora">Yappy a Aseguradora</option>
                      <option value="Aseguradora">Aseguradora (directo)</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Frecuencia</label>
                    <select className="form-select" value={form.frecuencia_pago}
                      onChange={e=>{
                        const frec = e.target.value;
                        f('frecuencia_pago', frec);
                        // Sugiere el N° de cuotas de un año completo según la frecuencia
                        // (mensual=12, bimensual=6, trimestral=4, semestral=2, anual=1),
                        // pero queda EDITABLE: el usuario puede poner otro número.
                        const meses = (FRECUENCIAS.find(fr=>fr.value===frec)||{}).meses || 1;
                        f('num_cuotas', String(Math.max(1, Math.round(12 / meses))));
                      }}>
                      {FRECUENCIAS.map(fr=><option key={fr.value} value={fr.value}>{fr.label}</option>)}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Número de Cuotas</label>
                    <input className="form-input" type="number" min="1"
                      value={form.num_cuotas}
                      onChange={e=>f('num_cuotas', e.target.value)}
                      placeholder="1" />
                  </div>
                </div>
                {/* Preview del plan */}
                {form.prima && form.fecha_inicio && (() => {
                  const { total, cuotas, mesesTotal } = calcularCuotas(form.prima, form.impuesto, form.frecuencia_pago, form.num_cuotas, form.fecha_inicio);
                  const ultima = cuotas[cuotas.length - 1];
                  const primera = cuotas[0];
                  const venc = form.fecha_vencimiento;
                  const excedePol = venc && ultima?.fecha && ultima.fecha > venc;
                  const excede12 = mesesTotal > 12;
                  return (
                    <div style={{ marginTop:10, padding:'10px 14px', background:'rgba(var(--sky-rgb),0.08)',
                      borderRadius:8, border:'1px solid rgba(var(--sky-rgb),0.2)', fontSize:12 }}>
                      <div style={{ color:'var(--sky-light)', fontWeight:600, marginBottom:4 }}>
                        {cuotas.length} cuota{cuotas.length > 1 ? 's' : ''} de {fmt$(cuotas[0]?.monto)}
                        {cuotas.length > 1 && Math.abs(ultima.monto - cuotas[0].monto) > 0.01 && ` (última: ${fmt$(ultima.monto)})`}
                        {' · '}Total: {fmt$(total)}
                      </div>
                      <div style={{ color:'var(--silver)' }}>
                        Primera: {fmtFecha(primera?.fecha) || '—'} · Última: {fmtFecha(ultima?.fecha) || '—'}
                      </div>
                      {(excedePol || excede12) && (
                        <div style={{ marginTop:6, display:'flex', alignItems:'center', gap:5, color:'var(--text-warning)' }}>
                          <AlertTriangle size={12} />
                          {excede12 ? 'El plan supera 12 meses. ' : ''}
                          {excedePol ? 'La última cuota excede la fecha de vencimiento de la póliza.' : ''}
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
              )}

              {/* ── Comisión del ramo ── */}
              <div style={{ marginTop:24 }}>
                <SectionTitle>COMISIÓN Y FEE</SectionTitle>
                {/* Toggle Fee */}
                <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:14,padding:'10px 14px',background:'rgba(var(--navy-rgb),0.4)',borderRadius:8,border:'1px solid rgba(var(--silver-rgb),0.12)',width:'fit-content'}}>
                  <input type="checkbox" id="pol-es-fee" checked={form.es_fee}
                    onChange={e=>{ f('es_fee',e.target.checked); if(e.target.checked) f('comision_ramo',''); }}
                    style={{accentColor:'var(--sky)',width:15,height:15,cursor:'pointer'}}/>
                  <label htmlFor="pol-es-fee" style={{fontSize:13,fontWeight:600,cursor:'pointer'}}>
                    Esta póliza es por <span style={{color:'var(--sky-light)'}}>Fee</span> (no lleva comisión)
                  </label>
                </div>
                {form.es_fee ? (
                  <div style={{display:'flex',alignItems:'center',gap:12}}>
                    <div className="form-group" style={{margin:0,width:220}}>
                      <label className="form-label">Monto del Fee * <span style={{color:'var(--silver)',fontWeight:400}}>(en $)</span></label>
                      <input className="form-input" type="number" step="0.01" value={form.monto_fee}
                        onChange={e=>f('monto_fee',e.target.value)} placeholder="0.00"/>
                    </div>
                    <div style={{marginTop:20,fontSize:12,color:'var(--sky-light)',padding:'8px 12px',background:'rgba(var(--sky-rgb),0.08)',borderRadius:8,border:'1px solid rgba(var(--sky-rgb),0.2)'}}>
                      La comisión se registra como Fee — no genera % sobre la prima.
                    </div>
                  </div>
                ) : (
                  <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                    <div className="form-group" style={{ margin:0, width:200 }}>
                      <label className="form-label">% Comisión del Ramo *</label>
                      <input className="form-input" type="number" step="0.01" value={form.comision_ramo}
                        onChange={e=>f('comision_ramo', e.target.value)} placeholder="0.00"
                        style={{borderColor: !form.comision_ramo ? 'rgba(239, 68, 68, 0.4)' : ''}}/>
                    </div>
                    {comisionRamoCambiada && (
                      <div style={{ marginTop:20, display:'flex', alignItems:'center', gap:6, padding:'8px 12px',
                        background:'rgba(245, 158, 11, 0.1)', borderRadius:8, border:'1px solid rgba(245, 158, 11, 0.3)',
                        fontSize:12, color:'var(--text-warning)' }}>
                        <AlertTriangle size={14} /> Estás cambiando la comisión estándar del ramo ({comisionRamoBase}%)
                      </div>
                    )}
                  </div>
                )}

                {/* ── Sobrecomisión: override que la aseguradora paga APARTE de la comisión normal ── */}
                {!form.es_declarativa && (
                  <div style={{ marginTop:18, paddingTop:14, borderTop:'1px solid rgba(var(--silver-rgb),0.12)' }}>
                    <div style={{ fontSize:13, fontWeight:700, marginBottom:8 }}>
                      Sobrecomisión <span style={{ color:'var(--silver)', fontWeight:400, fontSize:12 }}>(la aseguradora la paga aparte; se identifica por separado en sus reportes de comisión)</span>
                    </div>
                    <div style={{ display:'flex', alignItems:'flex-end', gap:12, flexWrap:'wrap' }}>
                      <div className="form-group" style={{ margin:0, width:190 }}>
                        <label className="form-label">Tipo</label>
                        <select className="form-select" value={form.sobrecomision_tipo}
                          onChange={e=>f('sobrecomision_tipo', e.target.value)}>
                          <option value="">Sin sobrecomisión</option>
                          <option value="porcentaje">Porcentaje (%)</option>
                          <option value="monto">Monto fijo ($)</option>
                        </select>
                      </div>
                      {form.sobrecomision_tipo && (
                        <>
                          <div className="form-group" style={{ margin:0, width:160 }}>
                            <label className="form-label">{form.sobrecomision_tipo === 'porcentaje' ? '% Sobrecomisión' : 'Monto ($)'}</label>
                            <input className="form-input" type="number" step="0.01" value={form.sobrecomision_valor}
                              onChange={e=>f('sobrecomision_valor', e.target.value)} placeholder="0.00" />
                          </div>
                          <div className="form-group" style={{ margin:0, width:220 }}>
                            <label className="form-label">¿Para quién?</label>
                            <select className="form-select" value={form.sobrecomision_reparto}
                              onChange={e=>f('sobrecomision_reparto', e.target.value)}>
                              <option value="ru">100% {getMarca().nombre}</option>
                              <option value="agente">Repartir con el agente</option>
                            </select>
                          </div>
                          <div style={{ marginBottom:8, fontSize:11, color:'var(--silver)', maxWidth:240 }}>
                            {form.sobrecomision_tipo === 'monto'
                              ? 'El monto fijo se registra una sola vez por póliza.'
                              : 'El % se aplica sobre la prima cobrada, en cada cobro.'}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* ── Modalidad Declarativa — solo aparece si el SUBRAMO es declarativo ── */}
              {subramoEsDeclarativa && (
              <div style={{ marginTop:24 }}>
                <SectionTitle>MODALIDAD DECLARATIVA</SectionTitle>
                <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:14,padding:'10px 14px',background:'rgba(var(--navy-rgb),0.4)',borderRadius:8,border:'1px solid rgba(var(--silver-rgb),0.12)',width:'fit-content'}}>
                  <input type="checkbox" id="pol-es-declarativa" checked={form.es_declarativa}
                    onChange={e=>f('es_declarativa', e.target.checked)}
                    style={{accentColor:'var(--sky)',width:15,height:15,cursor:'pointer'}}/>
                  <label htmlFor="pol-es-declarativa" style={{fontSize:13,fontWeight:600,cursor:'pointer'}}>
                    Esta póliza es <span style={{color:'var(--sky-light)'}}>declarativa</span> (prima variable por declaraciones)
                  </label>
                </div>
                {form.es_declarativa && (
                  <>
                    <div style={{fontSize:12,color:'var(--silver)',marginBottom:12,padding:'8px 12px',background:'rgba(var(--sky-rgb),0.07)',borderRadius:8,border:'1px solid rgba(var(--sky-rgb),0.18)'}}>
                      La prima no es fija: arranca con la prima depósito (puede ser 0) y se factura un endoso por cada declaración.
                      No se genera plan de cuotas — los saldos nacen en el módulo de Declaraciones de la póliza.
                    </div>
                    <div className="form-grid form-grid-3">
                      <div className="form-group">
                        <label className="form-label">Modalidad *</label>
                        <select className="form-select" value={form.modalidad_declarativa}
                          onChange={e=>{ f('modalidad_declarativa', e.target.value); if(e.target.value!=='transporte') f('arquitectura',''); }}>
                          <option value="">Seleccionar...</option>
                          <option value="incendio">Incendio (existencias)</option>
                          <option value="transporte">Transporte (embarques)</option>
                          <option value="accidentes_personales">Accidentes Personales (asegurados)</option>
                        </select>
                      </div>
                      {form.modalidad_declarativa==='transporte' && (
                        <div className="form-group">
                          <label className="form-label">Arquitectura</label>
                          <select className="form-select" value={form.arquitectura} onChange={e=>f('arquitectura', e.target.value)}>
                            <option value="">Seleccionar...</option>
                            <option value="abierta">Abierta / por declaración (sin tope)</option>
                            <option value="flotante">Flotante (suma que se consume)</option>
                          </select>
                        </div>
                      )}
                      <div className="form-group">
                        <label className="form-label">Periodicidad</label>
                        <select className="form-select" value={form.periodicidad_declaracion} onChange={e=>f('periodicidad_declaracion', e.target.value)}>
                          <option value="mensual">Mensual</option>
                          <option value="por_embarque">Por embarque</option>
                          <option value="trimestral">Trimestral</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Tasa</label>
                        <div style={{display:'flex',gap:6}}>
                          <input className="form-input" type="number" step="0.0001" value={form.tasa}
                            onChange={e=>f('tasa', e.target.value)} placeholder="0.00" style={{flex:1}}/>
                          <select className="form-select" value={form.tasa_unidad} onChange={e=>f('tasa_unidad', e.target.value)} style={{width:110}}>
                            <option value="por_mil">‰ (por mil)</option>
                            <option value="porcentaje">% </option>
                          </select>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Prima Depósito</label>
                        <input className="form-input" type="number" step="0.01" value={form.prima_deposito}
                          onChange={e=>f('prima_deposito', e.target.value)} placeholder="0.00 (puede ser 0)"/>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Prima Mínima (MD&amp;P)</label>
                        <input className="form-input" type="number" step="0.01" value={form.prima_minima}
                          onChange={e=>f('prima_minima', e.target.value)} placeholder="opcional"/>
                      </div>
                      <div className="form-group">
                        <label className="form-label">{form.modalidad_declarativa==='transporte' ? 'Límite por embarque' : 'Suma máxima (límite)'}</label>
                        <input className="form-input" type="number" step="0.01" value={form.suma_maxima}
                          onChange={e=>f('suma_maxima', e.target.value)} placeholder="0.00"/>
                      </div>
                      {form.arquitectura==='flotante' && (
                        <div className="form-group">
                          <label className="form-label">Suma total depositada</label>
                          <input className="form-input" type="number" step="0.01" value={form.suma_total}
                            onChange={e=>f('suma_total', e.target.value)} placeholder="0.00"/>
                        </div>
                      )}
                      {form.modalidad_declarativa==='transporte' && (
                        <>
                          <div className="form-group">
                            <label className="form-label">Factor de valuación</label>
                            <input className="form-input" type="number" step="0.01" value={form.factor_valuacion}
                              onChange={e=>f('factor_valuacion', e.target.value)} placeholder="1.10"/>
                          </div>
                          <div className="form-group">
                            <label className="form-label">Tasa guerra</label>
                            <input className="form-input" type="number" step="0.0001" value={form.tasa_guerra}
                              onChange={e=>f('tasa_guerra', e.target.value)} placeholder="opcional"/>
                          </div>
                        </>
                      )}
                      <div className="form-group" style={{display:'flex',alignItems:'center',gap:8,marginTop:22}}>
                        <input type="checkbox" id="pol-deposito-ganado" checked={form.deposito_es_ganado}
                          onChange={e=>f('deposito_es_ganado', e.target.checked)}
                          style={{accentColor:'var(--sky)',width:15,height:15,cursor:'pointer'}}/>
                        <label htmlFor="pol-deposito-ganado" style={{fontSize:12,cursor:'pointer'}}>Depósito no reembolsable</label>
                      </div>
                    </div>
                  </>
                )}
              </div>
              )}

              {/* ── Sub-modo FIANZA — solo aparece si el RAMO es de fianza ── */}
              {ramoEsFianza && (
              <div style={{ marginTop:24 }}>
                <SectionTitle>FIANZA</SectionTitle>
                <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:14,padding:'10px 14px',background:'rgba(var(--navy-rgb),0.4)',borderRadius:8,border:'1px solid rgba(var(--silver-rgb),0.12)',width:'fit-content'}}>
                  <input type="checkbox" id="pol-es-fianza" checked={form.es_fianza}
                    onChange={e=>f('es_fianza', e.target.checked)}
                    style={{accentColor:'var(--sky)',width:15,height:15,cursor:'pointer'}}/>
                  <label htmlFor="pol-es-fianza" style={{fontSize:13,fontWeight:600,cursor:'pointer'}}>
                    Esta póliza es una <span style={{color:'var(--sky-light)'}}>fianza</span> (comisión de garantía sobre un monto afianzado, pago único)
                  </label>
                </div>
                {form.es_fianza && (() => {
                  const monto = parseFloat(form.monto_afianzado) || 0;
                  const tarifa = parseFloat(form.tarifa_fianza) || 0;
                  let anios = 1;
                  if (form.fecha_inicio && form.fecha_vencimiento) {
                    const ms = new Date(form.fecha_vencimiento+'T12:00:00') - new Date(form.fecha_inicio+'T12:00:00');
                    if (ms > 0) anios = ms / (365.25 * 24 * 3600 * 1000);
                  }
                  const primaSugerida = Math.round(monto * tarifa / 100 * anios * 100) / 100;
                  return (
                    <>
                      <div style={{fontSize:12,color:'var(--silver)',marginBottom:12,padding:'8px 12px',background:'rgba(var(--sky-rgb),0.07)',borderRadius:8,border:'1px solid rgba(var(--sky-rgb),0.18)'}}>
                        La fianza no es prima de riesgo sino una comisión de garantía = monto afianzado × tarifa × años. Se cobra normalmente en
                        pago único y la vigencia sigue al contrato (no 12 meses). El endoso estrella es la prórroga de vigencia.
                      </div>
                      <div className="form-grid form-grid-3">
                        <div className="form-group">
                          <label className="form-label">Monto afianzado *</label>
                          <input className="form-input" type="number" step="0.01" value={form.monto_afianzado}
                            onChange={e=>f('monto_afianzado', e.target.value)} placeholder="0.00"/>
                        </div>
                        <div className="form-group">
                          <label className="form-label">Tarifa (% anual) *</label>
                          <input className="form-input" type="number" step="0.01" value={form.tarifa_fianza}
                            onChange={e=>f('tarifa_fianza', e.target.value)} placeholder="Ej: 3"/>
                        </div>
                        <div className="form-group">
                          <label className="form-label">Beneficiario</label>
                          <input className="form-input" value={form.beneficiario_fianza}
                            onChange={e=>f('beneficiario_fianza', e.target.value)} placeholder="A favor de (entidad/estado)"/>
                        </div>
                        <div className="form-group" style={{gridColumn:'span 3'}}>
                          <div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',fontSize:12,color:'var(--silver)'}}>
                            <span>Comisión de garantía sugerida ({anios.toFixed(2)} año(s)):</span>
                            <strong style={{color:'var(--sky-light)',fontSize:14}}>{fmt$(primaSugerida)}</strong>
                            <button type="button" className="btn btn-secondary btn-sm" onClick={()=>f('prima', String(primaSugerida))}>
                              Usar como prima
                            </button>
                            <span>Prima actual: <strong style={{color:'var(--text)'}}>{fmt$(parseFloat(form.prima)||0)}</strong></span>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })()}
              </div>
              )}

              {/* ── Agentes (distribución de comisión) ── */}
              <div style={{ marginTop:24 }}>
                <SectionTitle>DISTRIBUCIÓN DE COMISIÓN — AGENTES</SectionTitle>
                <div style={{ display:'flex', gap:8, marginBottom:12 }}>
                  <div style={{ flex:1 }}>
                    <SearchSelect options={agentesDisponibles} value={agenteSelector} onChange={setAgenteSelector} placeholder="Seleccionar agente..." />
                  </div>
                  <button className="btn btn-secondary btn-sm" onClick={handleAgenteAdd} disabled={!agenteSelector} style={{ whiteSpace:'nowrap' }}>
                    <Plus size={13} /> Agregar
                  </button>
                </div>
                {/* Info comisión RU */}
                {comisionRUTotal > 0 && (
                  <div style={{ marginBottom:10, padding:'8px 12px', background:'rgba(var(--sky-rgb),0.08)', borderRadius:8, fontSize:12, color:'var(--silver)' }}>
                    Comisión {abrev} total: <strong style={{ color:'var(--sky-light)' }}>{fmt$(comisionRUTotal)}</strong>
                    <span style={{ margin:'0 6px' }}>·</span>
                    Prima {fmt$(parseFloat(form.prima||0))} × {form.comision_ramo || 0}% (sin impuesto)
                    <span style={{ marginLeft:8, fontSize:11, color:'var(--silver)' }}>— Los % de agentes se calculan sobre este monto</span>
                  </div>
                )}
                {polizaAgentes.length > 0 && (
                  <div style={{ background:'rgba(var(--navy-rgb),0.4)', borderRadius:8, overflow:'hidden' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse' }}>
                      <thead>
                        <tr style={{ borderBottom:'1px solid rgba(var(--silver-rgb),0.1)' }}>
                          <th style={thSm}>Agente</th>
                          <th style={{ ...thSm, textAlign:'center' }}>Tipo</th>
                          <th style={{ ...thSm, textAlign:'center' }}>% comisión {abrev}</th>
                          <th style={{ ...thSm, textAlign:'center' }}>Monto ($)</th>
                          <th style={{ ...thSm, textAlign:'center' }}>Negociado</th>
                          <th style={{ width:40 }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {polizaAgentes.map((ag, idx) => {
                          const pctAg   = parseFloat(ag.porcentaje) || 0;
                          const montoAg = comisionRUTotal * pctAg / 100;
                          const difiere = ag.comision_negociada != null && ag.porcentaje !== '' &&
                            parseFloat(ag.porcentaje) !== parseFloat(ag.comision_negociada);
                          const toggleManual = () => setPolizaAgentes(prev => prev.map((a,i) => {
                            if (i !== idx) return a;
                            const activandoManual = !a.comision_manual;
                            // Al volver a General, restaura el % negociado del agente
                            const pctRestaurado = !activandoManual && a.comision_negociada != null
                              ? String(a.comision_negociada) : a.porcentaje;
                            return { ...a, comision_manual: activandoManual, porcentaje: pctRestaurado };
                          }));
                          const updatePct = (val) => setPolizaAgentes(prev => prev.map((a,i) =>
                            i === idx ? { ...a, porcentaje: val } : a
                          ));
                          const updateMonto = (val) => {
                            if (!comisionRUTotal) return;
                            const pct = (parseFloat(val) / comisionRUTotal * 100).toFixed(4);
                            setPolizaAgentes(prev => prev.map((a,i) =>
                              i === idx ? { ...a, porcentaje: pct } : a
                            ));
                          };
                          return (
                            <tr key={idx} style={{ borderBottom:'1px solid rgba(var(--silver-rgb),0.05)' }}>
                              <td style={{ padding:'8px 12px', fontSize:13, fontWeight:600 }}>
                                {ag.nombre}
                              </td>
                              {/* Toggle manual */}
                              <td style={{ padding:'8px 12px', textAlign:'center' }}>
                                <button
                                  onClick={toggleManual}
                                  style={{
                                    padding:'3px 10px', fontSize:11, border:'none', borderRadius:6,
                                    cursor:'pointer', fontFamily:'var(--font)', fontWeight:600,
                                    background: ag.comision_manual ? 'rgba(245, 158, 11, 0.2)' : 'rgba(var(--silver-rgb),0.15)',
                                    color: ag.comision_manual ? '#f59e0b' : 'var(--silver)',
                                  }}>
                                  {ag.comision_manual ? '🔒 Manual' : 'General'}
                                </button>
                              </td>
                              <td style={{ padding:'8px 12px', textAlign:'center' }}>
                                <input type="number" step="0.01" value={ag.porcentaje}
                                  onChange={e => updatePct(e.target.value)}
                                  disabled={!ag.comision_manual}
                                  style={{ width:72, textAlign:'center', ...inputSm,
                                    opacity: ag.comision_manual ? 1 : 0.45,
                                    cursor: ag.comision_manual ? 'text' : 'not-allowed' }} />
                                <span style={{ fontSize:11, color:'var(--silver)', marginLeft:3 }}>%</span>
                              </td>
                              <td style={{ padding:'8px 12px', textAlign:'center' }}>
                                <span style={{ fontSize:11, color:'var(--silver)', marginRight:3 }}>$</span>
                                <input type="number" step="0.01"
                                  value={comisionRUTotal ? montoAg.toFixed(2) : ''}
                                  onChange={e => updateMonto(e.target.value)}
                                  disabled={!ag.comision_manual || !comisionRUTotal}
                                  style={{ width:80, textAlign:'center', ...inputSm,
                                    opacity: (ag.comision_manual && comisionRUTotal) ? 1 : 0.45,
                                    cursor: (ag.comision_manual && comisionRUTotal) ? 'text' : 'not-allowed' }} />
                              </td>
                              <td style={{ padding:'8px 12px', textAlign:'center', fontSize:12, color:'var(--silver)' }}>
                                {ag.comision_negociada != null ? `${ag.comision_negociada}%` : '—'}
                                {difiere && ag.comision_manual && <span title="Distinto al negociado" style={{ marginLeft:6, color:'var(--text-warning)' }}><AlertTriangle size={12} /></span>}
                              </td>
                              <td style={{ padding:'8px 12px' }}>
                                <button className="btn btn-icon btn-danger btn-sm" onClick={()=>setPolizaAgentes(prev=>prev.filter((_,i)=>i!==idx))}><X size={12} /></button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {/* Resumen */}
                    <div style={{ padding:'10px 14px', borderTop:'1px solid rgba(var(--silver-rgb),0.1)', display:'flex', gap:20, fontSize:12, flexWrap:'wrap' }}>
                      <span style={{ color:'var(--silver)' }}>
                        Agentes: <strong style={{ color:'var(--text)' }}>{sumAgentePct.toFixed(2)}%</strong>
                        {comisionRUTotal > 0 && <span style={{ color:'var(--sky-light)', marginLeft:4 }}>({fmt$(comisionRUTotal * sumAgentePct / 100)})</span>}
                      </span>
                      <span style={{ color:'var(--silver)' }}>
                        {abrev} retiene: <strong style={{ color: pctExcedido ? '#ef4444' : '#22c55e' }}>{pctRU.toFixed(2)}%</strong>
                        {comisionRUTotal > 0 && <span style={{ color: pctExcedido ? '#ef4444' : '#22c55e', marginLeft:4 }}>({fmt$(montoRU)})</span>}
                      </span>
                      {pctExcedido && (
                        <span style={{ display:'flex', alignItems:'center', gap:4, color:'var(--text-danger)' }}>
                          <AlertTriangle size={12} /> Los agentes superan el 100% de la comisión
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* ── Referido (opcional) ── */}
              <div style={{ marginTop:24 }}>
                <SectionTitle>REFERIDO (opcional)</SectionTitle>
                <div style={{ display:'flex', gap:8, alignItems:'flex-end', flexWrap:'wrap' }}>
                  <div style={{ flex:'2 1 240px' }}>
                    <label className="form-label">Referidor</label>
                    <SearchSelect
                      options={[{ id:'', nombre:'— Sin referido —' }, ...referidos]}
                      value={form.referido_id}
                      onChange={(val) => {
                        if (!val) { f('referido_id', ''); f('referido_comision_pct', ''); return; }
                        f('referido_id', val);
                        const ref = referidos.find(r => String(r.id) === String(val));
                        if (ref) {
                          const pct = form.tipo === 'renovacion'
                            ? ref.comision_renovacion_pct
                            : (ref.comision_nueva_pct ?? ref.comision_pct);
                          f('referido_comision_pct', pct != null ? String(pct) : '');
                        }
                      }}
                      placeholder="Buscar referido..." />
                  </div>
                  <div className="form-group" style={{ flex:'0 1 140px', margin:0 }}>
                    <label className="form-label">% Referido</label>
                    <input className="form-input" type="number" step="0.01"
                      value={form.referido_comision_pct}
                      onChange={e => f('referido_comision_pct', e.target.value)}
                      disabled={!form.referido_id} />
                  </div>
                  {form.referido_id && form.referido_comision_pct !== '' && (
                    <div style={{ flex:'1 1 180px', fontSize:12, color:'var(--silver)', paddingBottom:10 }}>
                      Estimado: <strong style={{ color:'var(--sky-light)' }}>
                        {fmt$(parseFloat(form.prima||0) * (parseFloat(form.referido_comision_pct)||0) / 100)}
                      </strong>
                      <span style={{ marginLeft:6 }}>({form.referido_comision_pct}% × prima)</span>
                    </div>
                  )}
                </div>
              </div>

              {/* ── 4. Riesgo asegurado (preview: aseguradora / ramo / subramo / vigencia) ── */}
              <div style={{ marginTop:24 }}>
                <SectionTitle>RIESGO ASEGURADO</SectionTitle>
                <div className="form-grid form-grid-3">
                  <div className="form-group">
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4 }}>
                      <label className="form-label" style={{ margin:0 }}>Aseguradora *</label>
                      {canCreateAseg && (
                        <button className="btn btn-sm btn-secondary" style={{ fontSize:11, padding:'2px 8px' }}
                          onClick={()=>{ setAsegForm(EMPTY_ASEG); setShowCrearAseg(true); }} type="button">
                          <Building2 size={12} /> Nueva
                        </button>
                      )}
                    </div>
                    <SearchSelect options={aseguradoras} value={form.aseguradora_id} onChange={handleAsegChange} placeholder="Buscar aseguradora..." />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Emisión para la aseguradora</label>
                    <select className="form-select" value={form.tipo_emision} onChange={e=>f('tipo_emision', e.target.value)}>
                      <option value="nueva">Nueva</option>
                      <option value="renovada">Renovación</option>
                    </select>
                    <div style={{ fontSize:11, color:'var(--silver)', marginTop:4 }}>Cómo la clasifica la compañía de seguros — independiente de tu clasificación interna (arriba).</div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Ramo *</label>
                    <SearchSelect options={ramos} value={form.ramo_id} onChange={handleRamoChange} placeholder="Buscar ramo..." />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Subramo</label>
                    <SearchSelect
                      options={form.ramo_id
                        ? allSubramos.filter(s => String(s.ramo_id) === String(form.ramo_id))
                        : allSubramos}
                      value={form.subramo_id}
                      onChange={handleSubramoChange}
                      placeholder="Buscar subramo (auto-rellena ramo)..."
                    />
                  </div>
                  <div className="form-group"><label className="form-label">Fecha Inicio (vigencia)</label><input className="form-input" type="date" value={form.fecha_inicio} onChange={e=>{ f('fecha_inicio', e.target.value); f('fecha_vencimiento', sumarUnAnioISO(e.target.value)); }} /></div>
                  <div className="form-group"><label className="form-label">Fecha Vencimiento</label><input className="form-input" type="date" value={form.fecha_vencimiento} onChange={e=>f('fecha_vencimiento', e.target.value)} /></div>
                  <div className="form-group"><label className="form-label">Fecha Emisión</label><input className="form-input" type="date" value={form.fecha_emision} onChange={e=>f('fecha_emision', e.target.value)} /></div>
                </div>
              </div>

              {/* ── Detalle del riesgo y partes ── */}
              <div style={{ marginTop:24 }}>
                <SectionTitle>DETALLE DEL RIESGO Y PARTES</SectionTitle>
                <div className="form-grid form-grid-3">
                  <div className="form-group">
                    <label className="form-label">Gastos de Expedición</label>
                    <input className="form-input" type="number" step="0.01" value={form.gastos_expedicion} onChange={e=>f('gastos_expedicion', e.target.value)} placeholder="0.00" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">% Participación</label>
                    <input className="form-input" type="number" step="0.01" value={form.participacion} onChange={e=>f('participacion', e.target.value)} placeholder="100.00" />
                  </div>
                  <div className="form-group" style={{ gridColumn:'span 3' }}>
                    <label className="form-label">Descripción del Riesgo</label>
                    <input className="form-input" value={form.descripcion_riesgo} onChange={e=>f('descripcion_riesgo', e.target.value)} placeholder="Ej: placa, identificador del bien asegurado, código..." />
                  </div>

                  <div style={{ gridColumn:'span 3', fontSize:12, fontWeight:700, color:'var(--silver)', letterSpacing:1, marginTop:8 }}>BENEFICIARIO</div>
                  <div className="form-group" style={{ gridColumn:'span 2' }}>
                    <label className="form-label">Nombre del Beneficiario</label>
                    <input className="form-input" value={form.beneficiario_nombre} onChange={e=>f('beneficiario_nombre', e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Cédula del Beneficiario</label>
                    <input className="form-input" value={form.beneficiario_cedula} onChange={e=>f('beneficiario_cedula', e.target.value)} />
                  </div>
                  <div className="form-group" style={{ gridColumn:'span 3' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                      <input type="checkbox" id="ben-oneroso" checked={!!form.beneficiario_oneroso}
                        onChange={e=>f('beneficiario_oneroso', e.target.checked)}
                        style={{ accentColor:'var(--sky)', width:15, height:15, cursor:'pointer' }} />
                      <label htmlFor="ben-oneroso" style={{ fontSize:13, color:'var(--silver)', cursor:'pointer' }}>Beneficiario oneroso (ej: banco con hipoteca)</label>
                    </div>
                  </div>

                  <div style={{ gridColumn:'span 3', fontSize:12, fontWeight:700, color:'var(--silver)', letterSpacing:1, marginTop:8 }}>ASEGURADO (si difiere del tomador)</div>
                  <div className="form-group" style={{ gridColumn:'span 2' }}>
                    <label className="form-label">Nombre del Asegurado</label>
                    <input className="form-input" value={form.asegurado_nombre} onChange={e=>f('asegurado_nombre', e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Cédula del Asegurado</label>
                    <input className="form-input" value={form.asegurado_cedula} onChange={e=>f('asegurado_cedula', e.target.value)} />
                  </div>

                  <div style={{ gridColumn:'span 3', fontSize:12, fontWeight:700, color:'var(--silver)', letterSpacing:1, marginTop:8 }}>TOMADOR (quien contrata)</div>
                  <div className="form-group" style={{ gridColumn:'span 2' }}>
                    <label className="form-label">Nombre del Tomador</label>
                    <input className="form-input" value={form.tomador_nombre} onChange={e=>f('tomador_nombre', e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Cédula del Tomador</label>
                    <input className="form-input" value={form.tomador_cedula} onChange={e=>f('tomador_cedula', e.target.value)} />
                  </div>
                </div>
              </div>

              {/* ── Datos del vehículo (solo auto) ── van ANTES de las coberturas ── */}
              {isAuto && (
                <div style={{ marginTop:24 }}>
                  <SectionTitle>{modal === 'create' ? 'UNIDADES ASEGURADAS' : 'DATOS DEL VEHÍCULO'}</SectionTitle>
                  {modal === 'create' ? (
                    <>
                      <div style={{ fontSize:12, color:'var(--silver)', marginBottom:8 }}>Agrega todas las unidades de la póliza. Si es flota, usa "Agregar vehículo". Después de emitida, las unidades se cambian por endoso.</div>
                      <VehiculoListInput value={autoList} onChange={setAutoList} />
                    </>
                  ) : (<>
                  {polTieneFlota && (
                    <div style={{ display:'flex', alignItems:'flex-start', gap:8, padding:'9px 12px', marginBottom:12,
                      background:'rgba(var(--sky-rgb),0.08)', border:'1px solid rgba(var(--sky-rgb),0.25)', borderRadius:8, fontSize:12, color:'var(--sky-light)' }}>
                      <AlertTriangle size={14} style={{ flexShrink:0, marginTop:1 }} />
                      <span>Esta póliza tiene <strong>varios vehículos (flota)</strong>. Para no pisar los demás, los vehículos <strong>no se editan aquí</strong> — se agregan, quitan o cambian por <strong>endoso</strong>. Lo que edites en esta sección no se guardará.</span>
                    </div>
                  )}
                  <div className="form-grid form-grid-3">
                    <div className="form-group"><label className="form-label">Año{modal==='create' && ' *'}</label><input className="form-input" type="number" value={autoForm.anio} onChange={e=>avf('anio',e.target.value)} placeholder="2024" /></div>
                    <div className="form-group"><label className="form-label">Marca{modal==='create' && ' *'}</label><input className="form-input" value={autoForm.marca} onChange={e=>avf('marca',e.target.value)} placeholder="Toyota" /></div>
                    <div className="form-group"><label className="form-label">Modelo{modal==='create' && ' *'}</label><input className="form-input" value={autoForm.modelo} onChange={e=>avf('modelo',e.target.value)} placeholder="Corolla" /></div>
                    <div className="form-group"><label className="form-label">Color</label><input className="form-input" value={autoForm.color} onChange={e=>avf('color',e.target.value)} placeholder="Blanco" /></div>
                    <div className="form-group"><label className="form-label">Tipo</label>
                      <select className="form-select" value={autoForm.tipo_vehiculo} onChange={e=>avf('tipo_vehiculo',e.target.value)}>
                        <option value="">Seleccionar...</option>
                        {['Sedán','SUV','Pickup','Van','Camión','Motocicleta','Otro'].map(t=><option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>
                    <div className="form-group"><label className="form-label">Pasajeros</label><input className="form-input" type="number" value={autoForm.pasajeros} onChange={e=>avf('pasajeros',e.target.value)} placeholder="5" /></div>
                    <div className="form-group"><label className="form-label">VIN / No. Motor{modal==='create' && ' *'}</label><input className="form-input" value={autoForm.no_motor} onChange={e=>avf('no_motor',e.target.value)} /></div>

                    <div className="form-group" style={{ gridColumn:'span 2' }}>
                      <label className="form-label">Chasis{modal==='create' && !autoForm.chasis_igual_motor && ' *'}</label>
                      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:6 }}>
                        <input type="checkbox" id="chasis-igual" checked={autoForm.chasis_igual_motor}
                          onChange={e=>avf('chasis_igual_motor', e.target.checked)}
                          style={{ accentColor:'var(--sky)', width:14, height:14, cursor:'pointer' }} />
                        <label htmlFor="chasis-igual" style={{ fontSize:12, color:'var(--silver)', cursor:'pointer' }}>
                          Igual al No. de Motor
                        </label>
                      </div>
                      {!autoForm.chasis_igual_motor && (
                        <input className="form-input" value={autoForm.chasis} onChange={e=>avf('chasis',e.target.value)} placeholder="Número de chasis" />
                      )}
                      {autoForm.chasis_igual_motor && autoForm.no_motor && (
                        <div style={{ fontSize:12, color:'var(--sky-light)', padding:'6px 0' }}>→ {autoForm.no_motor}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Placa</label>
                      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:6 }}>
                        <input type="checkbox" id="placa-reportar" checked={autoForm.placa_por_reportar}
                          onChange={e=>avf('placa_por_reportar', e.target.checked)}
                          style={{ accentcolor:'var(--text-warning)', width:14, height:14, cursor:'pointer' }} />
                        <label htmlFor="placa-reportar" style={{ fontSize:12, color:'var(--text-warning)', cursor:'pointer' }}>
                          Por reportar
                        </label>
                      </div>
                      {!autoForm.placa_por_reportar && (
                        <input className="form-input" value={autoForm.placa} onChange={e=>avf('placa',e.target.value)} placeholder="AAA-000" />
                      )}
                      {autoForm.placa_por_reportar && (
                        <div style={{ fontSize:11, color:'var(--text-warning)', padding:'4px 0', display:'flex', alignItems:'center', gap:5 }}>
                          <AlertTriangle size={11} /> Se creará tarea CRM para dar seguimiento (30 días)
                        </div>
                      )}
                    </div>
                  </div>
                  </>)}
                </div>
              )}

              {/* ── Coberturas ── */}
              <div style={{ marginTop:24 }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                  <SectionTitle style={{ margin:0 }}>COBERTURAS</SectionTitle>
                  <button className="btn btn-sm btn-secondary" onClick={()=>setShowAddCob(s=>!s)}>
                    <Plus size={12} /> Agregar cobertura
                  </button>
                </div>
                {showAddCob && (
                  <div style={{ display:'flex', gap:8, marginBottom:12, flexWrap:'wrap', alignItems:'center' }}>
                    <div style={{ flex:1, minWidth:220 }}>
                      <SearchSelect options={coberturasDisponibles}
                        value={cobSelector === '__custom__' ? '' : cobSelector}
                        onChange={val=>{ setCobSelector(val ? String(val) : ''); setNuevaCobertura(''); }}
                        placeholder="Buscar cobertura…"
                        onCreate={()=>setCobSelector('__custom__')}
                        createLabel="Otra (personalizada)…" />
                    </div>
                    {cobSelector === '__custom__' && (
                      <input className="form-input" style={{ flex:1, minWidth:200 }} value={nuevaCobertura}
                        onChange={e=>setNuevaCobertura(e.target.value)}
                        onKeyDown={e=>e.key==='Enter'&&handleAddCobertura()} placeholder="Nombre de la cobertura…" />
                    )}
                    <button className="btn btn-primary btn-sm" onClick={handleAddCobertura} disabled={!cobSelector}>Agregar</button>
                    <button className="btn btn-secondary btn-sm" onClick={()=>{ setShowAddCob(false); setCobSelector(''); setNuevaCobertura(''); }}><X size={12} /></button>
                  </div>
                )}
                {polizaCoberturas.length === 0 ? (
                  <div className="text-silver text-sm" style={{ textAlign:'center', padding:'16px 0' }}>
                    {form.ramo_id
                      ? 'Aún no agregas coberturas. Usa "Agregar cobertura" para incluir las que apliquen.'
                      : 'Selecciona un ramo para poder agregar coberturas.'}
                  </div>
                ) : (
                  <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                    {polizaCoberturas.map((c, idx) => (
                      <div key={idx} style={{
                        background:'rgba(var(--navy-rgb),0.4)', borderRadius:8,
                        border: '1px solid rgba(var(--sky-rgb),0.2)',
                      }}>
                        {/* Header de la cobertura */}
                        <div style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px' }}>
                          <button onClick={()=>handleRemoveCobertura(idx)} title="Quitar cobertura"
                            style={{ background:'none', border:'none', cursor:'pointer', color:'var(--silver)', padding:2, flexShrink:0, display:'flex' }}>
                            <Trash2 size={15} />
                          </button>

                          <span style={{ flex:1, display:'flex', flexDirection:'column', gap:2 }}>
                            <span style={{ fontSize:13, fontWeight:600 }}>
                              {c.nombre}
                              {c.es_personalizada && <span style={{ fontSize:10, marginLeft:6, color:'var(--sky-light)' }}>personalizada</span>}
                            </span>
                            <CoberturaDesc descripcion={c.descripcion} />
                          </span>

                          {/* Selector de nivel de límite (solo Auto: LC / DPA / GM) */}
                          {isAuto && (() => {
                            const tipo = detectAutoTipo(c.nombre);
                            const ops = autoOpcionesPorTipo(autoLimiteOpciones, tipo);
                            if (!tipo || ops.length === 0) return null;
                            return (
                              <select
                                disabled={!c.incluida}
                                value={c.nivel_limite_id || ''}
                                onChange={e => {
                                  const op = ops.find(o => String(o.id) === e.target.value);
                                  updateCobertura(idx, 'nivel_limite_id', e.target.value);
                                  if (op) {
                                    updateCobertura(idx, 'suma_asegurada',
                                      op.limite_accidente != null ? String(op.limite_accidente)
                                      : op.limite_persona != null ? String(op.limite_persona) : '');
                                    updateCobertura(idx, 'otros', op.etiqueta || '');
                                  }
                                }}
                                style={{ ...inputSm, width:150, flexShrink:0 }}>
                                <option value="">Nivel {tipo}...</option>
                                {ops.map(o => <option key={o.id} value={o.id}>{o.etiqueta}</option>)}
                              </select>
                            );
                          })()}

                          {/* Desglose por persona / por accidente (cuando el límite es de ese tipo) */}
                          {(() => {
                            const bd = nivelBreakdown(c);
                            if (!bd) return null;
                            return (
                              <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', gap:1, flexShrink:0, fontSize:11, lineHeight:1.35 }}>
                                <span style={{ color:'var(--sky-light)', fontWeight:600 }}>{fmt$(bd.persona)} <span style={{ color:'var(--silver)', fontWeight:400 }}>por persona</span></span>
                                <span style={{ color:'var(--sky-light)', fontWeight:600 }}>{fmt$(bd.accidente)} <span style={{ color:'var(--silver)', fontWeight:400 }}>por accidente</span></span>
                              </div>
                            );
                          })()}

                          {/* Límite / Sub-límite toggle */}
                          <div style={{ display:'flex', borderRadius:6, overflow:'hidden', border:'1px solid rgba(var(--silver-rgb),0.2)', flexShrink:0 }}>
                            {['limite','sub_limite'].map(t => (
                              <button key={t} onClick={()=>updateCobertura(idx,'tipo_limite',t)}
                                style={{ padding:'3px 10px', fontSize:11, border:'none', cursor:'pointer', fontFamily:'var(--font)',
                                  background: c.tipo_limite===t ? 'var(--sky)' : 'transparent',
                                  color: c.tipo_limite===t ? '#fff' : 'var(--silver)' }}>
                                {t === 'limite' ? 'Límite' : 'Sub-límite'}
                              </button>
                            ))}
                          </div>

                          {/* Suma asegurada (solo cuando NO es un límite por persona/accidente) */}
                          {!nivelBreakdown(c) && (
                            <div style={{ display:'flex', alignItems:'center', gap:6, flexShrink:0 }}>
                              <span style={{ fontSize:11, color:'var(--silver)' }}>SA $</span>
                              <input type="number" step="0.01" value={c.suma_asegurada}
                                disabled={!c.incluida}
                                onChange={e=>updateCobertura(idx,'suma_asegurada',e.target.value)}
                                placeholder="0.00" style={{ width:110, ...inputSm }} />
                            </div>
                          )}

                          <button onClick={()=>toggleCobExpanded(idx)}
                            style={{ background:'none', border:'none', cursor:'pointer', color:'var(--silver)', padding:4, flexShrink:0 }}>
                            {c.expanded ? <ChevronUp size={14}/> : <ChevronDown size={14}/>}
                          </button>
                        </div>

                        {/* Detalle expandible: deducible + otros */}
                        {c.expanded && c.incluida && (
                          <div style={{ padding:'0 14px 12px 38px' }}>
                            {renderDeducibleFields(c, idx)}
                            <div style={{ marginTop:10 }}>
                              <input type="text" value={c.otros} onChange={e=>updateCobertura(idx,'otros',e.target.value)}
                                placeholder="Notas / condiciones adicionales..."
                                style={{ width:'100%', ...inputSm }} />
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* ── Notas ── */}
              <div className="form-group" style={{ marginTop:20 }}>
                <label className="form-label">Notas</label>
                <textarea className="form-textarea" value={form.notas} onChange={e=>f('notas', e.target.value)} />
              </div>

              {/* ── Documentos de Póliza ── */}
              {selected?.id && (
                <div style={{ marginTop:24 }}>
                  <div style={{ fontSize:12, fontWeight:700, letterSpacing:1, marginBottom:12, color:'var(--silver)' }}>DOCUMENTOS DE PÓLIZA</div>
                  <DocManager
                    polizaId={selected.id}
                    linkedClienteId={selected.cliente_id}
                    categoriasPermitidas={['poliza','otro']}
                    readOnly={!canEdit('polizas')}
                  />
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closeModal}>Cancelar</button>
              <button className="btn btn-secondary" onClick={()=>handleSave(true)} style={{ display:'flex', alignItems:'center', gap:6 }}>
                <Save size={14} /> Guardar Borrador
              </button>
              <button className="btn btn-primary" onClick={()=>handleSave(false)}>
                {modal === 'create' ? 'Registrar Póliza' : 'Guardar Cambios'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Mini-modal: Crear Cliente */}
      {showCrearCliente && (
        <div className="modal-overlay" style={{ zIndex:1200 }} onClick={()=>setShowCrearCliente(false)}>
          <div className="modal modal-lg" onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <div><div className="modal-title">Nuevo Cliente</div><div className="text-silver text-sm">Se seleccionará automáticamente</div></div>
              <button className="btn btn-icon btn-secondary btn-sm" onClick={()=>setShowCrearCliente(false)}><X size={16} /></button>
            </div>
            <div className="modal-body">
              <div className="form-grid form-grid-2">
                <div className="form-group" style={{ gridColumn:'span 2' }}>
                  <label className="form-label">Tipo</label>
                  <select className="form-select" value={cliForm.tipo} onChange={e=>cf('tipo', e.target.value)}>
                    <option value="natural">Persona Natural</option>
                    <option value="juridica">Persona Jurídica</option>
                  </select>
                </div>
                {cliForm.tipo === 'natural' ? (<>
                  <div className="form-group"><label className="form-label">Primer Nombre *</label><input className="form-input" value={cliForm.primer_nombre} onChange={e=>cf('primer_nombre',e.target.value)} /></div>
                  <div className="form-group"><label className="form-label">Segundo Nombre</label><input className="form-input" value={cliForm.segundo_nombre} onChange={e=>cf('segundo_nombre',e.target.value)} /></div>
                  <div className="form-group"><label className="form-label">Primer Apellido *</label><input className="form-input" value={cliForm.primer_apellido} onChange={e=>cf('primer_apellido',e.target.value)} /></div>
                  <div className="form-group"><label className="form-label">Segundo Apellido</label><input className="form-input" value={cliForm.segundo_apellido} onChange={e=>cf('segundo_apellido',e.target.value)} /></div>
                  <div className="form-group"><label className="form-label">Ap. de Casada</label><input className="form-input" value={cliForm.apellido_casada} onChange={e=>cf('apellido_casada',e.target.value)} /></div>
                </>) : (
                  <div className="form-group" style={{ gridColumn:'span 2' }}><label className="form-label">Razón Social *</label><input className="form-input" value={cliForm.nombre} onChange={e=>cf('nombre',e.target.value)} /></div>
                )}
                <div className="form-group"><label className="form-label">Cédula / RUC</label><input className="form-input" value={cliForm.cedula_ruc} onChange={e=>cf('cedula_ruc',e.target.value)} /></div>
                <div className="form-group"><label className="form-label">Teléfono</label><input className="form-input" value={cliForm.telefono} onChange={e=>cf('telefono',e.target.value)} /></div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={()=>setShowCrearCliente(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={handleGuardarCliente} disabled={savingCli}>{savingCli ? 'Guardando...' : 'Crear y Seleccionar'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Mini-modal: Crear Aseguradora */}
      {showCrearAseg && (
        <div className="modal-overlay" style={{ zIndex:1200 }} onClick={()=>setShowCrearAseg(false)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <div><div className="modal-title">Nueva Aseguradora</div><div className="text-silver text-sm">Se seleccionará automáticamente</div></div>
              <button className="btn btn-icon btn-secondary btn-sm" onClick={()=>setShowCrearAseg(false)}><X size={16} /></button>
            </div>
            <div className="modal-body">
              <div className="form-grid form-grid-2">
                <div className="form-group" style={{ gridColumn:'span 2' }}><label className="form-label">Nombre *</label><input className="form-input" value={asegForm.nombre} onChange={e=>af('nombre',e.target.value)} placeholder="Ej: Mapfre Panamá" /></div>
                <div className="form-group"><label className="form-label">Código</label><input className="form-input" value={asegForm.codigo} onChange={e=>af('codigo',e.target.value)} /></div>
                <div className="form-group"><label className="form-label">Contacto</label><input className="form-input" value={asegForm.contacto} onChange={e=>af('contacto',e.target.value)} /></div>
                <div className="form-group"><label className="form-label">Teléfono</label><input className="form-input" value={asegForm.telefono} onChange={e=>af('telefono',e.target.value)} /></div>
                <div className="form-group"><label className="form-label">Email</label><input className="form-input" type="email" value={asegForm.email} onChange={e=>af('email',e.target.value)} /></div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={()=>setShowCrearAseg(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={handleGuardarAseg} disabled={savingAseg}>{savingAseg ? 'Guardando...' : 'Crear y Seleccionar'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal de Confirmación de Ajuste de Comisión ── */}
      {showAjusteConfirm && pendingAjuste && (
        <div className="modal-overlay" style={{ zIndex:1300 }} onClick={()=>{ setShowAjusteConfirm(false); setPendingAjuste(null); }}>
          <div className="modal" style={{ maxWidth:540 }} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <div className="modal-title" style={{ color:'var(--text-warning)' }}>Ajuste de Comisión</div>
                <div className="text-silver text-sm">Se generará un registro de ajuste automático</div>
              </div>
              <button className="btn btn-icon btn-secondary btn-sm" onClick={()=>{ setShowAjusteConfirm(false); setPendingAjuste(null); }}><X size={16} /></button>
            </div>
            <div className="modal-body">
              <div style={{ padding:'12px 14px', background:'rgba(245, 158, 11, 0.08)', borderRadius:8, border:'1px solid rgba(245, 158, 11, 0.3)', marginBottom:16 }}>
                <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
                  <AlertTriangle size={16} style={{ color:'var(--text-warning)', flexShrink:0 }} />
                  <span style={{ fontSize:13, fontWeight:600, color:'var(--text-warning)' }}>Corrección detectada</span>
                </div>
                {pendingAjuste.ramo_cambio && (
                  <div style={{ fontSize:12, color:'#e2e8f0', marginBottom:4 }}>
                    % comisión del ramo: <strong style={{ color:'var(--text-danger)' }}>{pendingAjuste.pctRamoViejo}%</strong> → <strong style={{ color:'var(--text-success)' }}>{pendingAjuste.pctRamoNuevo}%</strong>
                  </div>
                )}
                {pendingAjuste.agenteCambios?.map((a, i) => (
                  <div key={i} style={{ fontSize:12, color:'#e2e8f0', marginBottom:4 }}>
                    % agente <strong>{a.nombre}</strong>: <strong style={{ color:'var(--text-danger)' }}>{a.pctViejo}%</strong> → <strong style={{ color:'var(--text-success)' }}>{a.pctNuevo}%</strong>
                  </div>
                ))}
                <div style={{ fontSize:12, color:'var(--silver)', marginTop:6 }}>
                  Hay {pendingAjuste.comsPagadas.length} comisión{pendingAjuste.comsPagadas.length > 1 ? 'es' : ''} ya liquidada{pendingAjuste.comsPagadas.length > 1 ? 's' : ''} que se ajustarán.
                </div>
              </div>

              <div style={{ fontSize:12, fontWeight:700, color:'var(--silver)', letterSpacing:1, marginBottom:10 }}>AJUSTES A REGISTRAR</div>
              <div style={{ background:'rgba(var(--navy-rgb),0.4)', borderRadius:8, overflow:'hidden', marginBottom:16 }}>
                <table style={{ width:'100%', borderCollapse:'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom:'1px solid rgba(var(--silver-rgb),0.1)' }}>
                      <th style={thSm}>Agente</th>
                      <th style={{ ...thSm, textAlign:'right' }}>Δ Al Agente</th>
                      <th style={{ ...thSm, textAlign:'right' }}>Δ A {abrev}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.values(pendingAjuste.byAgente).map((ag, i) => {
                      const nombre = agentes.find(a => String(a.id) === String(ag.agente_id))?.nombre || (ag.agente_id ? `Agente #${ag.agente_id}` : 'Sin agente');
                      const positivo = ag.delta_agente >= 0;
                      return (
                        <tr key={i} style={{ borderBottom:'1px solid rgba(var(--silver-rgb),0.05)' }}>
                          <td style={{ padding:'8px 12px', fontSize:13, fontWeight:600 }}>{nombre}</td>
                          <td style={{ padding:'8px 12px', textAlign:'right', fontSize:13, fontWeight:700, color: positivo ? '#22c55e' : '#ef4444' }}>
                            {positivo ? '+' : ''}{fmt$(ag.delta_agente)}
                          </td>
                          <td style={{ padding:'8px 12px', textAlign:'right', fontSize:13, fontWeight:700, color: ag.delta_ru >= 0 ? '#22c55e' : '#ef4444' }}>
                            {ag.delta_ru >= 0 ? '+' : ''}{fmt$(ag.delta_ru)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div style={{ fontSize:11, color:'var(--silver)', padding:'8px 12px', background:'rgba(var(--steel-rgb),0.3)', borderRadius:6 }}>
                Nota automática: "Ajuste por corrección de comisión — póliza {form.numero || selected?.id}, {pendingAjuste.descripcion}"
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={()=>{ setShowAjusteConfirm(false); setPendingAjuste(null); }}>
                Cancelar
              </button>
              <button className="btn btn-primary" style={{ background:'#f59e0b', bordercolor:'var(--text-warning)' }}
                onClick={()=> doGuardar(false, pendingAjuste)}>
                Confirmar y Guardar con Ajuste
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Ver */}
      {modal === 'view' && selected && (() => {
        const hoy = new Date().toISOString().slice(0,10);
        const totalPagos   = viewPagos.reduce((s,p)=>s+(parseFloat(p.monto)||0),0);
        const pagado       = viewPagos.filter(p=>p.estado==='pagado').reduce((s,p)=>s+(parseFloat(p.monto)||0),0);
        const pendiente    = totalPagos - pagado;
        const vencidasCnt  = viewPagos.filter(p=>p.estado==='pendiente'&&p.fecha_vencimiento&&p.fecha_vencimiento<hoy).length;
        return (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal modal-lg" style={{ maxWidth:800, maxHeight:'92vh', display:'flex', flexDirection:'column', overflow:'hidden' }} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <div style={{display:'flex',alignItems:'center',gap:10}}>
                  <div className="modal-title" style={{ color:'var(--sky)' }}>{selected.numero || 'Borrador'}</div>
                  <span className={`badge ${ESTADO_BADGE[selected.estado]||'badge-neutral'}`}>{etiquetaEstadoPoliza(selected.estado)}</span>
                </div>
                <div className="text-silver text-sm">{selected.cliente} · {selected.ramo} · {selected.aseguradora}</div>
              </div>
              <button className="btn btn-icon btn-secondary btn-sm" onClick={closeModal}><X size={16} /></button>
            </div>

            {/* Tabs */}
            <div style={{display:'flex',gap:2,padding:'0 24px',borderBottom:'1px solid rgba(var(--silver-rgb),0.1)',background:'rgba(var(--navy-rgb),0.3)'}}>
              {[
                ['info','Información'],
                ['coberturas', 'Riesgo cubierto'],
                ...(viewUnidades.length > 0 ? [['unidades', 'Unidades']] : []),
                ['endosos', 'Endosos'],
                ['pagos', 'Plan de Cobros'],
                ...(selected.facturacion_modo === 'periodica' ? [['periodos', selected.es_declarativa ? 'Declaraciones' : 'Períodos']] : []),
                ['gestiones', 'Gestiones'],
                ['reclamos', 'Reclamos'],
                ...(selected.es_declarativa ? [['cierre','Cierre']] : []),
                ['docs','Documentos'],
              ].filter(Boolean).map(([k,l])=>(
                <button key={k} onClick={()=>setViewTab(k)} style={{
                  padding:'10px 16px',border:'none',cursor:'pointer',background:'none',
                  fontFamily:'Outfit,sans-serif',fontSize:13,fontWeight:600,
                  color: viewTab===k ? 'var(--sky-light)' : 'var(--silver)',
                  borderBottom: viewTab===k ? '2px solid var(--sky)' : '2px solid transparent',
                  marginBottom:-1,
                }}>{l}</button>
              ))}
            </div>

            <div className="modal-body" style={{flex:1,minHeight:0,overflowY:'auto'}}>

              {/* ── Tab: Información ── */}
              {viewTab === 'info' && (
                <div>
                  {/* Datos principales */}
                  <div style={{marginBottom:20}}>
                    <div style={{fontSize:11,fontWeight:700,color:'var(--silver)',letterSpacing:1,marginBottom:12}}>DATOS GENERALES</div>
                    <div className="form-grid form-grid-3">
                      {[
                        ['Cliente',        selected.cliente],
                        ['Tipo',           selected.tipo === 'renovacion' ? 'Renovación' : 'Nueva'],
                        ['Póliza anterior', selected.tipo === 'renovacion' ? (viewPolizaAnterior || '—') : null],
                        ['Emisión p/ aseguradora', selected.tipo_emision ? (selected.tipo_emision === 'renovada' ? 'Renovación' : 'Nueva') : null],
                        ['Ramo',           selected.ramo],
                        ['Subramo',        selected.subramo_id ? allSubramos.find(s=>s.id===selected.subramo_id)?.nombre : null],
                        ['Aseguradora',    selected.aseguradora],
                        ['Ejecutivo',      selected.ejecutivo],
                        ['Prima',          selected.prima ? fmt$(selected.prima) : null],
                        ['Impuesto',       selected.impuesto!=null ? `${selected.impuesto}%` : null],
                        ['Total con imp.', selected.prima!=null && selected.impuesto!=null ? fmt$(parseFloat(selected.prima)*(1+parseFloat(selected.impuesto)/100)) : null],
                        ['Comisión Ramo',  selected.comision_ramo!=null ? `${selected.comision_ramo}%` : null],
                        ['Forma de Pago',  selected.forma_pago],
                        ['Facturación',    selected.facturacion_modo === 'periodica'
                          ? `Periódica — ${selected.periodo_frecuencia === 'trimestral' ? 'Trimestral' : 'Mensual'}${selected.declarativa_modo ? ` (declarativa ${selected.declarativa_modo})` : ''}` : null],
                        ['Frecuencia',     selected.facturacion_modo === 'periodica' ? null : selected.frecuencia_pago],
                        ['Cuotas',         selected.facturacion_modo === 'periodica' ? null : (selected.num_cuotas ? String(selected.num_cuotas) : null)],
                        ['Fecha Inicio',   fmtFecha(selected.fecha_inicio)],
                        ['Fecha Vencimiento', fmtFecha(selected.fecha_vencimiento)],
                        ['Fecha Emisión',  fmtFecha(selected.fecha_emision)],
                      ].filter(([,v])=>v).map(([l,v])=>(
                        <div key={l}>
                          <div className="text-xs text-silver" style={{marginBottom:2,textTransform:'uppercase'}}>{l}</div>
                          <div style={{fontSize:13,fontWeight:500}}>{v}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Solicitud de origen */}
                  {viewSolicitud && (
                    <div style={{marginBottom:20,padding:'10px 14px',background:'rgba(var(--sky-rgb),0.06)',borderRadius:8,border:'1px solid rgba(var(--sky-rgb),0.2)'}}>
                      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                        <div>
                          <div style={{fontSize:10,color:'var(--silver)',textTransform:'uppercase',marginBottom:4}}>Solicitud de Origen</div>
                          <div style={{fontSize:13,fontWeight:600,color:'var(--sky-light)'}}>
                            SOL-{String(viewSolicitud.id).padStart(4,'0')} — {viewSolicitud.tipo?.toUpperCase()}
                          </div>
                          <div style={{fontSize:12,color:'var(--silver)',marginTop:2}}>
                            {viewSolicitud.aseguradoras?.nombre} · {viewSolicitud.ramos?.nombre}
                            {viewSolicitud.prima_estimada ? ` · Prima estimada: $${Number(viewSolicitud.prima_estimada).toLocaleString('es-PA',{minimumFractionDigits:2})}` : ''}
                          </div>
                        </div>
                        <button className="btn btn-sm btn-secondary" style={{whiteSpace:'nowrap',fontSize:11}}
                          onClick={()=>{ sessionStorage.setItem('openSolicitudId', String(viewSolicitud.id)); sessionStorage.setItem('backFrom', 'polizas'); navigate('/solicitudes'); closeModal(); }}>
                          <Eye size={12}/> Ver solicitud
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Agentes */}
                  {viewAgentes.length > 0 && (
                    <div style={{marginBottom:20}}>
                      <div style={{fontSize:11,fontWeight:700,color:'var(--silver)',letterSpacing:1,marginBottom:10}}>AGENTES</div>
                      <div style={{background:'rgba(var(--navy-rgb),0.4)',borderRadius:8,overflow:'hidden'}}>
                        <table style={{width:'100%',borderCollapse:'collapse'}}>
                          <thead><tr style={{borderBottom:'1px solid rgba(var(--silver-rgb),0.1)'}}>
                            <th style={thSm}>Agente</th><th style={{...thSm,textAlign:'right'}}>% Comisión</th>
                          </tr></thead>
                          <tbody>
                            {viewAgentes.map((a,i)=>(
                              <tr key={i} style={{borderBottom:'1px solid rgba(var(--silver-rgb),0.05)'}}>
                                <td style={{padding:'8px 12px',fontSize:13,fontWeight:600}}>{a.agentes?.nombre}</td>
                                <td style={{padding:'8px 12px',textAlign:'right',fontSize:13,color:'var(--sky-light)'}}>{a.porcentaje}%</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {/* Referido */}
                  {selected.referido_id && (() => {
                    const ref = referidos.find(r => String(r.id) === String(selected.referido_id));
                    const pct = selected.referido_comision_pct != null ? parseFloat(selected.referido_comision_pct) : 0;
                    const estimado = parseFloat(selected.prima||0) * pct / 100;
                    return (
                      <div style={{marginBottom:20}}>
                        <div style={{fontSize:11,fontWeight:700,color:'var(--silver)',letterSpacing:1,marginBottom:10}}>REFERIDO</div>
                        <div style={{background:'rgba(var(--navy-rgb),0.4)',borderRadius:8,padding:'10px 14px',fontSize:13}}>
                          <strong>{ref?.nombre || `#${selected.referido_id}`}</strong>
                          <span style={{color:'var(--sky-light)',marginLeft:10}}>{pct}%</span>
                          <span style={{color:'var(--silver)',marginLeft:10}}>Estimado: {fmt$(estimado)}</span>
                        </div>
                      </div>
                    );
                  })()}

                  {/* PARTES, VEHÍCULO y DESCRIPCIÓN DEL RIESGO se muestran en la pestaña "Riesgo cubierto" */}
                  {selected.notas && (
                    <div style={{padding:'10px 14px',background:'rgba(var(--steel-rgb),0.3)',borderRadius:8}}>
                      <div className="text-xs text-silver" style={{marginBottom:4}}>NOTAS</div>
                      <div style={{fontSize:13}}>{selected.notas}</div>
                    </div>
                  )}
                </div>
              )}

              {/* ── Tab: Riesgo cubierto (partes + bien cubierto + coberturas) ── */}
              {viewTab === 'coberturas' && (
                <div>
                  {/* Partes: asegurado / tomador / beneficiario */}
                  {(selected.asegurado_nombre||selected.tomador_nombre||selected.beneficiario_nombre) && (
                    <div style={{marginBottom:20}}>
                      <div style={{fontSize:11,fontWeight:700,color:'var(--silver)',letterSpacing:1,marginBottom:10}}>PARTES</div>
                      <div className="form-grid form-grid-3">
                        {selected.asegurado_nombre && <div>
                          <div className="text-xs text-silver" style={{marginBottom:2}}>ASEGURADO</div>
                          <div style={{fontSize:13,fontWeight:500}}>{selected.asegurado_nombre}</div>
                          {selected.asegurado_cedula && <div style={{fontSize:11,color:'var(--silver)'}}>{selected.asegurado_cedula}</div>}
                        </div>}
                        {selected.tomador_nombre && <div>
                          <div className="text-xs text-silver" style={{marginBottom:2}}>TOMADOR</div>
                          <div style={{fontSize:13,fontWeight:500}}>{selected.tomador_nombre}</div>
                          {selected.tomador_cedula && <div style={{fontSize:11,color:'var(--silver)'}}>{selected.tomador_cedula}</div>}
                        </div>}
                        {selected.beneficiario_nombre && <div>
                          <div className="text-xs text-silver" style={{marginBottom:2}}>BENEFICIARIO{selected.beneficiario_oneroso?' (Oneroso)':''}</div>
                          <BeneficiarioConfidencial nombre={selected.beneficiario_nombre} cedula={selected.beneficiario_cedula}
                            actualizadoEl={selected.beneficiarios_actualizado_el}
                            nameStyle={{fontSize:13,fontWeight:500}} subStyle={{fontSize:11,color:'var(--silver)'}} />
                        </div>}
                      </div>
                    </div>
                  )}

                  {/* Bien cubierto: auto → datos del/los vehículo(s) (flota); otros ramos → descripción del riesgo */}
                  {viewAutos.length > 0 && (
                    <div style={{marginBottom:20}}>
                      <div style={{fontSize:11,fontWeight:700,color:'var(--silver)',letterSpacing:1,marginBottom:10}}>
                        {viewAutos.length > 1 ? `VEHÍCULOS ASEGURADOS (${viewAutos.length})` : 'VEHÍCULO ASEGURADO'}
                      </div>
                      {viewAutos.map((av, idx) => (
                        <div key={av.id || idx} style={{background:'rgba(var(--steel-rgb),0.25)',borderRadius:8,padding:'14px 16px',marginBottom: idx < viewAutos.length - 1 ? 10 : 0}}>
                          {viewAutos.length > 1 && (
                            <div style={{fontSize:11,color:'var(--sky-light)',fontWeight:700,marginBottom:8}}>
                              Vehículo {idx + 1}{av.placa && av.placa !== 'Por reportar' ? ` — ${av.placa}` : ''}
                            </div>
                          )}
                          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'10px 20px'}}>
                            {[
                              ['Año',        av.anio],
                              ['Marca',      av.marca],
                              ['Modelo',     av.modelo],
                              ['Color',      av.color],
                              ['Tipo',       av.tipo_vehiculo],
                              ['Pasajeros',  av.pasajeros],
                              ['No. Motor',  av.no_motor],
                              ['Chasis',     av.chasis_igual_motor ? av.no_motor : av.chasis],
                              ['Placa',      av.placa_por_reportar ? 'Por reportar' : av.placa],
                              ['Propietario (RUV)', av.dueno_nombre ? `${av.dueno_nombre}${av.dueno_cedula ? ' — ' + av.dueno_cedula : ''}` : null],
                            ].filter(([,v])=>v!=null&&v!=='').map(([l,v])=>(
                              <div key={l}>
                                <div style={{fontSize:10,color:'var(--silver)',textTransform:'uppercase',marginBottom:2}}>{l}</div>
                                <div style={{fontSize:13,fontWeight:500}}>{v}</div>
                              </div>
                            ))}
                          </div>
                          {(av._coberturas || []).length > 0 && (
                            <div style={{ marginTop:10, paddingTop:10, borderTop:'1px dashed rgba(var(--silver-rgb),0.15)' }}>
                              <div style={{ fontSize:10, fontWeight:700, color:'var(--silver)', letterSpacing:0.5, marginBottom:6 }}>COBERTURAS DE ESTA UNIDAD</div>
                              {av._coberturas.map((c, ci) => (
                                <div key={ci} style={{ display:'flex', gap:10, fontSize:12, padding:'3px 0' }}>
                                  <span style={{ flex:1, fontWeight:600 }}>{c.nombre}</span>
                                  {c.suma_asegurada != null && <span style={{ color:'var(--sky-light)' }}>{fmt$(c.suma_asegurada)}</span>}
                                  {c.deducible && <span style={{ color:'var(--silver)' }}>Ded: {c.deducible}</span>}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  {viewAutos.length === 0 && selected.descripcion_riesgo && (
                    <div style={{marginBottom:20}}>
                      <div style={{fontSize:11,fontWeight:700,color:'var(--silver)',letterSpacing:1,marginBottom:10}}>BIEN / RIESGO CUBIERTO</div>
                      <div style={{padding:'12px 14px',background:'rgba(var(--steel-rgb),0.25)',borderRadius:8,fontSize:13}}>{selected.descripcion_riesgo}</div>
                    </div>
                  )}

                  <div style={{fontSize:11,fontWeight:700,color:'var(--silver)',letterSpacing:1,marginBottom:10}}>{viewAutos.length > 0 ? 'COBERTURAS DE LA PÓLIZA (todas las unidades)' : 'COBERTURAS'}</div>
                  {viewCoberturas.length === 0
                    ? <div style={{textAlign:'center',padding:'24px 0',color:'var(--silver)',fontSize:13}}>{viewAutos.length > 0 ? 'Sin coberturas a nivel de póliza (ver coberturas por unidad arriba)' : 'Sin coberturas registradas'}</div>
                    : <div style={{display:'flex',flexDirection:'column',gap:8}}>
                        {viewCoberturas.map((c,i)=>{
                          // Límite "por persona / por accidente" (auto: LC/DPA/GM). Si aplica,
                          // se muestra desglosado y NO se repite la etiqueta cruda en "otros".
                          const pa = detectAutoTipo(c.nombre) ? parsePersonaAccidente(c.otros) : null;
                          return (
                          <div key={i} style={{padding:'12px 14px',background:'rgba(var(--steel-rgb),0.25)',borderRadius:8,border:'1px solid rgba(var(--sky-rgb),0.15)'}}>
                            <div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
                              <span style={{flex:1,fontSize:13,fontWeight:600}}>{c.nombre}</span>
                              {c.tipo_limite && (
                                <span style={{fontSize:10,padding:'2px 8px',borderRadius:4,background:'rgba(var(--sky-rgb),0.15)',color:'var(--sky-light)',fontWeight:600}}>
                                  {c.tipo_limite==='sub_limite'?'Sub-límite':'Límite'}
                                </span>
                              )}
                              {pa ? (
                                <span style={{fontSize:12.5,color:'var(--sky-light)',fontWeight:700,textAlign:'right',lineHeight:1.35}}>
                                  {fmt$(pa.persona)} <span style={{color:'var(--silver)',fontWeight:400}}>por persona</span>
                                  <br/>{fmt$(pa.accidente)} <span style={{color:'var(--silver)',fontWeight:400}}>por accidente</span>
                                </span>
                              ) : (c.suma_asegurada!=null && (
                                <span style={{fontSize:13,color:'var(--sky-light)',fontWeight:700}}>{fmt$(c.suma_asegurada)}</span>
                              ))}
                            </div>
                            {c.deducible && <div style={{fontSize:11,color:'var(--silver)',marginTop:4}}>Deducible: {c.deducible}</div>}
                            {c.otros && !pa && <div style={{fontSize:11,color:'var(--silver)',marginTop:2}}>{c.otros}</div>}
                            {c._descripcion && <div style={{marginTop:4}}><CoberturaDesc descripcion={c._descripcion} /></div>}
                          </div>
                          );
                        })}
                      </div>
                  }
                </div>
              )}

              {/* ── Tab: Endosos ── */}
              {viewTab === 'endosos' && (
                <div>
                  {/* Acción: crear solicitud de endoso (usa el flujo de Solicitudes) */}
                  {canEdit('polizas') && selected.estado !== 'cancelada' && (
                    <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginBottom:12}}>
                      {/salud|m[eé]dic|vida/i.test(selected.ramo || '') && !selected.es_declarativa && selected.facturacion_modo !== 'periodica' && (
                        <button className="btn btn-secondary btn-sm" onClick={()=>setCpModal({ monto:'', fecha:new Date().toISOString().slice(0,10), file:null, guardando:false })}
                          title="Para Vida/Salud: cambia la mensualidad de las cuotas pendientes (con notificación de la aseguradora)">
                          <RotateCw size={13}/> Cambiar prima mensual
                        </button>
                      )}
                      <button className="btn btn-secondary btn-sm" onClick={()=>openEndosoInterno(selected)}
                        title="Cambio interno: la aseguradora NO envía documento. Se registra y aplica directo (fuera del ciclo normal).">
                        <Lock size={13}/> Endoso interno
                      </button>
                      <button className="btn btn-primary btn-sm" onClick={()=>irACrearEndoso(selected)}>
                        <Plus size={13}/> Crear solicitud de endoso
                      </button>
                    </div>
                  )}

                  {/* Modal: Cambiar prima mensual (salud) */}
                  {cpModal && (
                    <div className="modal-overlay" style={{ zIndex:1500 }} onClick={()=>{ if(!cpModal.guardando) setCpModal(null); }}>
                      <div className="modal" onClick={e=>e.stopPropagation()}>
                        <div className="modal-header">
                          <div className="modal-title">Cambiar prima mensual</div>
                          <button className="btn btn-icon btn-secondary btn-sm" onClick={()=>{ if(!cpModal.guardando) setCpModal(null); }}><X size={16}/></button>
                        </div>
                        <div className="modal-body">
                          <div style={{ fontSize:12, color:'var(--silver)', marginBottom:14 }}>
                            Actualiza las cuotas <strong>pendientes</strong> con vencimiento desde la fecha indicada al nuevo monto. Las cuotas ya pagadas no se tocan. Debes adjuntar la notificación de la aseguradora.
                          </div>
                          <div className="form-grid form-grid-2">
                            <div className="form-group"><label className="form-label">Nueva mensualidad (lo que paga el cliente) *</label><input className="form-input" type="number" step="0.01" value={cpModal.monto} onChange={e=>setCpModal(p=>({...p, monto:e.target.value}))} placeholder="70.00" /></div>
                            <div className="form-group"><label className="form-label">Aplica desde *</label><input className="form-input" type="date" value={cpModal.fecha} onChange={e=>setCpModal(p=>({...p, fecha:e.target.value}))} /></div>
                            <div className="form-group" style={{ gridColumn:'span 2' }}>
                              <label className="form-label">Notificación de la aseguradora (PDF) *</label>
                              <input type="file" accept="application/pdf,image/*" onChange={e=>setCpModal(p=>({...p, file:e.target.files?.[0]||null}))} style={{ fontSize:13, color:'var(--silver)' }} />
                              {cpModal.file && <div style={{ fontSize:12, color:'var(--sky-light)', marginTop:4 }}>Se subirá: {cpModal.file.name}</div>}
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button className="btn btn-secondary" onClick={()=>setCpModal(null)} disabled={cpModal.guardando}>Cancelar</button>
                          <button className="btn btn-primary" onClick={guardarCambioPrima} disabled={cpModal.guardando}>{cpModal.guardando?'Guardando...':'Aplicar cambio'}</button>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Solicitudes de endoso (aún no facturadas) — una línea cada una */}
                  {viewEndosoSolicitudes.length > 0 && (
                    <div style={{marginBottom:16}}>
                      <div style={{fontSize:11,fontWeight:700,color:'var(--text-warning)',letterSpacing:1,marginBottom:8}}>SOLICITUDES DE ENDOSO ({viewEndosoSolicitudes.length})</div>
                      <div style={{display:'flex',flexDirection:'column',gap:6}}>
                        {viewEndosoSolicitudes.map(s => {
                          const registrado = s.estado === 'endoso_recibido' || s.estado === 'enviado_cliente'; // ya aplicado a la póliza
                          const dp = parseFloat(s.prima);
                          const pasoIdx = ENDOSO_PASOS.indexOf(s.estado);
                          return (
                            <div key={s.id} onClick={()=>irAFacturarEndoso(s.id)} title="Ver la solicitud completa"
                              style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',padding:'9px 12px',background:'rgba(245, 158, 11, 0.07)',borderRadius:8,border:'1px solid rgba(245, 158, 11, 0.22)',cursor:'pointer'}}>
                              <span style={{fontSize:10,fontWeight:700,color:'var(--text-warning)',border:'1px solid rgba(245, 158, 11, 0.4)',borderRadius:4,padding:'1px 6px',whiteSpace:'nowrap'}}>SOLICITUD</span>
                              <span style={{flex:1,minWidth:140,fontSize:13,fontWeight:600}}>
                                {endosoTiposMap[s.tipo_endoso_id] || 'Endoso'}
                                <span style={{color:'var(--silver)',fontWeight:400,marginLeft:8,fontSize:11}}>SOL-{String(s.id).padStart(4,'0')}</span>
                              </span>
                              {!isNaN(dp) && dp !== 0 && (
                                <span style={{fontSize:12,fontWeight:700,color: dp>0?'#22c55e':'#ef4444',whiteSpace:'nowrap'}} title="Prima (s/imp.)">{dp>0?'+':''}{fmt$(dp)}</span>
                              )}
                              <span style={{fontSize:11,color:'var(--silver)',whiteSpace:'nowrap'}} title="Paso del ciclo del endoso">
                                Paso {Math.max(pasoIdx,0)+1}/4
                              </span>
                              <span className={`badge ${registrado?'badge-success':'badge-warning'}`} style={{whiteSpace:'nowrap'}}>{ENDOSO_ESTADO_LABEL[s.estado] || s.estado}</span>
                              {canEdit('polizas') && (
                                <button className="btn btn-primary btn-sm" style={{whiteSpace:'nowrap'}}
                                  onClick={ev=>{ ev.stopPropagation(); irAFacturarEndoso(s.id); }}
                                  title="Abrir la solicitud para gestionar el ciclo del endoso">
                                  <FileText size={12}/> Gestionar
                                </button>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Solicitudes de endoso ELIMINADAS (canceladas con motivo) — una línea cada una */}
                  {viewEndosoCancelados.length > 0 && (
                    <div style={{marginBottom:16}}>
                      <div style={{fontSize:11,fontWeight:700,color:'var(--text-danger)',letterSpacing:1,marginBottom:8}}>SOLICITUDES DE ENDOSO ELIMINADAS ({viewEndosoCancelados.length})</div>
                      <div style={{display:'flex',flexDirection:'column',gap:6}}>
                        {viewEndosoCancelados.map(s => (
                          <div key={s.id} style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',padding:'9px 12px',background:'rgba(239, 68, 68, 0.06)',borderRadius:8,border:'1px solid rgba(239, 68, 68, 0.2)',opacity:0.85}}>
                            <span style={{fontSize:10,fontWeight:700,color:'var(--text-danger)',border:'1px solid rgba(239, 68, 68, 0.4)',borderRadius:4,padding:'1px 6px',whiteSpace:'nowrap'}}>ELIMINADA</span>
                            <span style={{flex:1,minWidth:160,fontSize:13,fontWeight:600}}>
                              {endosoTiposMap[s.tipo_endoso_id] || 'Endoso'}
                              <span style={{color:'var(--silver)',fontWeight:400,marginLeft:8,fontSize:11}}>SOL-{String(s.id).padStart(4,'0')} · {fmtFecha(s.actualizado_en)||fmtFecha(s.creado_en)||''}</span>
                            </span>
                            <span style={{flexBasis:'100%',fontSize:12,color:'var(--text-danger)'}}>
                              Motivo: {s.motivo_cancelacion || 'Sin motivo registrado'}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {viewEndosos.length > 0 && (
                    <div style={{fontSize:11,fontWeight:700,color:'var(--silver)',letterSpacing:1,marginBottom:8}}>ENDOSOS APLICADOS</div>
                  )}
                  {viewEndosos.length === 0
                    ? ((viewEndosoSolicitudes.length === 0 && viewEndosoCancelados.length === 0) && <div style={{textAlign:'center',padding:'24px 0',color:'var(--silver)',fontSize:13}}>Sin endosos. Crea una solicitud de endoso arriba.</div>)
                    : <div style={{display:'flex',flexDirection:'column',gap:6}}>
                        {viewEndosos.map((e,i)=>{
                          const delta = parseFloat(e.delta_prima)||0;
                          const anulado = e.estado === 'anulado';
                          const docUrl = e.url_documento || (e.sol_archivos && e.sol_archivos.length>0 ? e.sol_archivos[0].url : null);
                          // Tipo(s) de endoso: un endoso puede traer varios cambios (cambios_json);
                          // se muestran todos por nombre del catálogo. Fallback a tipo_endoso_id.
                          const tiposEndoso = Array.isArray(e.cambios_json)
                            ? [...new Set(e.cambios_json.map(ch=>endosoTiposMap[ch.tipo_endoso_id]).filter(Boolean))]
                            : (e.tipo_endoso_id && endosoTiposMap[e.tipo_endoso_id] ? [endosoTiposMap[e.tipo_endoso_id]] : []);
                          const tipoLabel = tiposEndoso.join(' · ');
                          return (
                            <div key={i}>
                              <div onClick={()=>setEndosoDetalle(e)} title="Ver el detalle del endoso"
                                style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',padding:'9px 12px',background:'rgba(var(--steel-rgb),0.3)',borderRadius:8,border:'1px solid rgba(var(--silver-rgb),0.15)',opacity:anulado?0.55:1,cursor:'pointer'}}>
                                <span style={{fontSize:10,fontWeight:700,color:'var(--sky-light)',border:'1px solid rgba(var(--sky-rgb),0.4)',borderRadius:4,padding:'1px 6px',whiteSpace:'nowrap'}}>ENDOSO</span>
                                <span style={{flex:1,minWidth:150,display:'flex',flexDirection:'column',gap:2}}>
                                  <span style={{fontSize:13,fontWeight:600,textDecoration:anulado?'line-through':'none'}}>
                                    {e.descripcion || 'Endoso'}
                                    {e.tipo === 'cancelacion' && <span className="badge badge-danger" style={{marginLeft:6}}>Cancelación{e.metodo_calculo==='short_rate'?' · tasa corta':''}</span>}
                                    {e.tipo === 'prorroga' && <span className="badge badge-success" style={{marginLeft:6}}>Prórroga</span>}
                                    {e.numero_endoso && <span style={{color:'var(--silver)',fontWeight:400,marginLeft:8,fontSize:11}}>N° {e.numero_endoso}</span>}
                                  </span>
                                  {tipoLabel && <span style={{fontSize:11,color:'var(--sky-light)',fontWeight:500}}>{tipoLabel}</span>}
                                </span>
                                <span style={{fontSize:11,color:'var(--silver)',whiteSpace:'nowrap'}} title="Fecha del endoso (aseguradora / registro)">{fmtFecha(e.fecha)||fmtFecha(e.creado_en)||'—'}</span>
                                <span style={{fontSize:13,fontWeight:700,color: delta>0?'#22c55e':delta<0?'#ef4444':'var(--silver)',whiteSpace:'nowrap'}} title="Cambio en prima">{delta>0?'+':''}{fmt$(delta)}</span>
                                <span className={`badge ${anulado?'badge-danger':e.estado==='activo'?'badge-success':'badge-warning'}`} style={{whiteSpace:'nowrap'}}>{anulado?'anulado':(e.estado||'—')}</span>
                                {docUrl && (
                                  <a href="#" title="Documento del endoso"
                                    onClick={ev=>{ ev.preventDefault(); ev.stopPropagation(); abrirDocumento(docUrl); }}
                                    style={{color:'var(--sky-light)',display:'inline-flex',alignItems:'center',textDecoration:'none'}}>📎</a>
                                )}
                                {!anulado && canEdit('polizas') && (
                                  <button className="btn btn-secondary btn-sm" style={{borderColor:'rgba(239, 68, 68, 0.4)',padding:'3px 8px'}} title="Anular endoso"
                                    onClick={ev=>{ ev.stopPropagation(); setMotivoAnularEndoso(''); setAnularEndosoTarget(e); }}>
                                    <Trash2 size={12}/>
                                  </button>
                                )}
                              </div>
                              {anulado && e.motivo_anulacion && (
                                <div style={{fontSize:11,color:'var(--text-danger)',padding:'3px 12px 0'}}>Motivo de anulación: <span style={{color:'var(--text-danger)'}}>{e.motivo_anulacion}</span></div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                  }
                </div>
              )}

              {viewTab === 'pagos' && (
                <div>
                  {/* Acción: registrar pago (requiere permiso de cobros) */}
                  {canEdit('cobros') && !selected.es_declarativa && selected.estado !== 'cancelada' && (
                    <div style={{display:'flex',justifyContent:'flex-end',marginBottom:12}}>
                      <button className="btn btn-primary btn-sm" onClick={()=>{
                        setPagoForm({ monto_recibido:'', donde_pago:'Aseguradora', fecha_pago_aseg:new Date().toISOString().slice(0,10), forma_pago_real:'', num_recibo_aseg:'', notas_cobro:'' });
                        setShowPagoModal(true);
                      }}>
                        <Plus size={13}/> Registrar pago
                      </button>
                    </div>
                  )}
                  {viewPagos.length === 0
                    ? <div style={{textAlign:'center',padding:'32px 0',color:'var(--silver)',fontSize:13}}>Sin cuotas registradas</div>
                    : <>
                        <div className="table-wrapper" style={{marginBottom:12}}>
                          <table>
                            <thead><tr>
                              <th>Cuota</th><th>Monto</th><th>Vencimiento</th><th>Estado</th><th>Fecha Pago</th><th>Recibo {abrev}</th>
                            </tr></thead>
                            <tbody>
                              {viewPagos.map((p,i)=>{
                                const venc = p.fecha_vencimiento && p.fecha_vencimiento < hoy && p.estado==='pendiente';
                                return (
                                  <tr key={i} style={venc?{background:'rgba(239, 68, 68, 0.06)'}:{}}>
                                    <td style={{color:'var(--silver)',fontSize:12}}>{selected.es_declarativa ? nombreMes(p.fecha_vencimiento) : (p.cuota_num?`Cuota ${p.cuota_num}`:'—')}</td>
                                    <td style={{fontWeight:600,color:'var(--text-success)'}}>{fmt$(p.monto)}</td>
                                    <td style={{color:venc?'#ef4444':'inherit'}}>
                                      {fmtFecha(p.fecha_vencimiento)||'—'}
                                      {venc&&<span style={{marginLeft:6,fontSize:10,color:'var(--text-danger)',fontWeight:700}}>VENCIDA</span>}
                                    </td>
                                    <td><span className={`badge ${p.estado==='pagado'?'badge-success':venc?'badge-danger':'badge-warning'}`}>{p.estado}</span></td>
                                    <td style={{fontSize:12,color:'var(--silver)'}}>{fmtFecha(p.fecha_pago)||'—'}</td>
                                    <td style={{fontSize:11,color:'var(--sky-light)',fontFamily:'monospace'}}>{p.num_recibo_ru||'—'}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                        <div style={{display:'flex',gap:20,padding:'10px 14px',background:'rgba(var(--navy-rgb),0.4)',borderRadius:8,fontSize:13,flexWrap:'wrap'}}>
                          <span style={{color:'var(--silver)'}}>Total: <strong style={{color:'var(--text)'}}>{fmt$(totalPagos)}</strong></span>
                          <span style={{color:'var(--silver)'}}>Pagado: <strong style={{color:'var(--text-success)'}}>{fmt$(pagado)}</strong></span>
                          <span style={{color:'var(--silver)'}}>Pendiente: <strong style={{color:pendiente>0?'#f59e0b':'#22c55e'}}>{fmt$(pendiente)}</strong></span>
                          {vencidasCnt>0 && <span style={{color:'var(--text-danger)',fontWeight:700}}>⚠ {vencidasCnt} cuota(s) vencida(s)</span>}
                        </div>
                      </>
                  }
                </div>
              )}

              {/* ── Tab: Unidades (ubicación / equipo / asegurado) ── */}
              {viewTab === 'unidades' && (
                <div>
                  {(() => {
                    const TIPO_LBL = { ubicacion:'Ubicaciones', equipo:'Equipos', asegurado:'Asegurados', dependiente:'Dependientes' };
                    const grupos = {};
                    // Los dependientes NO son un grupo aparte: se anidan bajo su asegurado titular (parent_id).
                    const depsByParent = {};
                    viewUnidades.forEach(u => {
                      if (u.tipo === 'dependiente' && u.parent_id) { (depsByParent[u.parent_id] = depsByParent[u.parent_id] || []).push(u); }
                      else { (grupos[u.tipo] = grupos[u.tipo] || []).push(u); }
                    });
                    const filaUnidad = (u, compacta) => {
                      const deps = depsByParent[u.id] || [];
                      return (
                      <div key={u.id} style={{ padding: compacta ? '8px 12px' : '10px 14px', background: compacta ? 'rgba(var(--navy-rgb),0.4)' : 'rgba(var(--steel-rgb),0.3)', borderRadius:8, border: compacta ? 'none' : '1px solid rgba(var(--sky-rgb),0.15)' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                          <div style={{ flex:1 }}>
                            <div style={{ fontSize:13, fontWeight:600 }}>{u.nombre || '—'}</div>
                            {u.identificacion && <div style={{ fontSize:11, color:'var(--silver)' }}>{u.identificacion}</div>}
                          </div>
                          {u.valor != null && <span style={{ fontSize:13, fontWeight:600, color:'var(--sky-light)' }}>{fmt$(u.valor)}</span>}
                        </div>
                        {deps.length > 0 && (
                          <div style={{ marginTop:6, paddingLeft:14, borderLeft:'2px solid rgba(var(--sky-light-rgb),0.25)', display:'flex', flexDirection:'column', gap:3 }}>
                            {deps.map(d => (
                              <div key={d.id} style={{ fontSize:12, color:'var(--silver)' }}>
                                ↳ {d.nombre || '—'}{d.identificacion ? ` · ${d.identificacion}` : ''}
                                {d.datos && d.datos.parentesco ? <span style={{ color:'var(--sky-light)' }}> · {d.datos.parentesco}</span> : ''}
                                {d.valor != null ? ` · ${fmt$(d.valor)}` : ''}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      );
                    };
                    return Object.keys(grupos).map(tipo => {
                      // Colectivos (vida/salud): los asegurados entran/salen por PERÍODOS con
                      // cada factura. Para no ensuciar la vista, se agrupan por FECHA de
                      // inclusión, plegados: clic en el grupo para ver su listado.
                      if (tipo === 'asegurado' || tipo === 'dependiente') {
                        const porFecha = {};
                        grupos[tipo].forEach(u => {
                          const f = (u.creado_en || '').slice(0, 10) || 'sin-fecha';
                          (porFecha[f] = porFecha[f] || []).push(u);
                        });
                        const fechas = Object.keys(porFecha).sort().reverse();
                        return (
                          <div key={tipo} style={{ marginBottom:20 }}>
                            <div style={{ fontSize:11, fontWeight:700, color:'var(--silver)', letterSpacing:1, marginBottom:10 }}>{(TIPO_LBL[tipo]||tipo).toUpperCase()} POR FECHA</div>
                            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                              {fechas.map(f => {
                                const key = tipo + f;
                                const abierto = !!unidadesGrupoOpen[key];
                                return (
                                  <div key={f} style={{ background:'rgba(var(--steel-rgb),0.3)', borderRadius:8, border:'1px solid rgba(var(--sky-rgb),0.15)' }}>
                                    <button onClick={()=>setUnidadesGrupoOpen(p=>({ ...p, [key]: !p[key] }))}
                                      style={{ display:'flex', alignItems:'center', gap:10, width:'100%', padding:'10px 14px', background:'none', border:'none', cursor:'pointer', color:'var(--text)', fontFamily:'Outfit,sans-serif' }}>
                                      {abierto ? <ChevronUp size={14} style={{color:'var(--silver)'}}/> : <ChevronDown size={14} style={{color:'var(--silver)'}}/>}
                                      <span style={{ flex:1, textAlign:'left', fontSize:13, fontWeight:600 }}>{f === 'sin-fecha' ? 'Sin fecha' : fmtFecha(f)}</span>
                                      <span style={{ fontSize:12, color:'var(--silver)' }}>{porFecha[f].length} {TIPO_LBL[tipo].toLowerCase().replace(/s$/,'')}{porFecha[f].length!==1?'s':''}</span>
                                    </button>
                                    {abierto && (
                                      <div style={{ padding:'0 14px 10px', display:'flex', flexDirection:'column', gap:6 }}>
                                        {porFecha[f].map(u => filaUnidad(u, true))}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      }
                      // Ubicaciones / equipos: listado directo.
                      return (
                        <div key={tipo} style={{ marginBottom:20 }}>
                          <div style={{ fontSize:11, fontWeight:700, color:'var(--silver)', letterSpacing:1, marginBottom:10 }}>{(TIPO_LBL[tipo]||tipo).toUpperCase()}</div>
                          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                            {grupos[tipo].map(u => filaUnidad(u, false))}
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
              )}

              {/* ── Tab: Períodos (facturación periódica / por declaración) ── */}
              {viewTab === 'periodos' && (
                <div>
                  <div style={{ fontSize:12, color:'var(--silver)', marginBottom:12 }}>
                    {selected.es_declarativa ? (
                      <>Declarativa {selected.declarativa_modo ? `(${selected.declarativa_modo})` : ''}. Cada declaración se registra como un <strong>endoso</strong> y genera su <strong>propia letra</strong> en el mes declarado (varias declaraciones por mes admitidas). Puedes adjuntar la <strong>factura de la aseguradora</strong> y sus respaldos por mes. El recordatorio del mes en el CRM se cierra solo al declarar.</>
                    ) : (
                      <>Facturación periódica ({selected.periodo_frecuencia === 'trimestral' ? 'trimestral' : 'mensual'}). Cada período la aseguradora factura; registra el monto para enviarlo al cliente y entra al saco.</>
                    )}
                  </div>
                  {selected.es_declarativa && canEdit('polizas') && !declForm && (
                    <button className="btn btn-primary btn-sm" style={{ marginBottom:12 }}
                      onClick={()=>setDeclForm({ fecha: new Date().toISOString().slice(0,10), monto:'', descripcion:'', numero_endoso:'', tipoDocId: (tiposDocPoliza.find(t=>t.codigo==='FAC')||tiposDocPoliza[0])?.id || '', files:[] })}>
                      <Plus size={14}/> Registrar declaración (mes)
                    </button>
                  )}
                  {selected.es_declarativa && declForm && (
                    <div style={{ marginBottom:14, padding:'12px 14px', background:'rgba(var(--sky-rgb),0.06)', border:'1px solid rgba(var(--sky-rgb),0.2)', borderRadius:8 }}>
                      <div style={{ fontSize:12, fontWeight:700, color:'var(--sky-light)', marginBottom:10 }}>REGISTRAR DECLARACIÓN</div>
                      <div className="form-grid form-grid-3">
                        <div className="form-group"><label className="form-label">Fecha de la declaración (mes) *</label>
                          <input className="form-input" type="date" value={declForm.fecha} onChange={e=>setDeclForm(f=>({ ...f, fecha:e.target.value }))} /></div>
                        <div className="form-group"><label className="form-label">Monto declarado (prima, sin imp.) *</label>
                          <input className="form-input" type="number" step="0.01" value={declForm.monto} onChange={e=>setDeclForm(f=>({ ...f, monto:e.target.value }))} placeholder="0.00 (sin impuesto)" /></div>
                        <div className="form-group"><label className="form-label">N° de endoso (opcional)</label>
                          <input className="form-input" value={declForm.numero_endoso} onChange={e=>setDeclForm(f=>({ ...f, numero_endoso:e.target.value }))} placeholder="Referencia" /></div>
                      </div>
                      <div className="form-group"><label className="form-label">Descripción (opcional)</label>
                        <input className="form-input" value={declForm.descripcion} onChange={e=>setDeclForm(f=>({ ...f, descripcion:e.target.value }))} placeholder="Ej: declaración de julio" /></div>
                      <div className="form-group">
                        <label className="form-label">Documentos de respaldo (factura de la aseguradora, etc.)</label>
                        <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                          <select className="form-select" style={{ width:200 }} value={declForm.tipoDocId} onChange={e=>setDeclForm(f=>({ ...f, tipoDocId:e.target.value }))}>
                            {tiposDocPoliza.map(t=><option key={t.id} value={t.id}>{t.nombre}</option>)}
                          </select>
                          <input className="form-input" type="file" multiple style={{ flex:1, minWidth:180 }} onChange={e=>{ const nf=Array.from(e.target.files||[]); setDeclForm(f=>({ ...f, files:[...(f.files||[]), ...nf] })); e.target.value=''; }} />
                        </div>
                        {(declForm.files||[]).length>0 && (
                          <div style={{ display:'flex', flexDirection:'column', gap:4, marginTop:8 }}>
                            {declForm.files.map((file,i)=>(
                              <div key={i} style={{ display:'flex', alignItems:'center', gap:8, fontSize:12.5 }}>
                                <Paperclip size={13} style={{ color:'var(--sky-light)' }}/>
                                <span style={{ flex:1 }}>{file.name}</span>
                                <button type="button" className="btn btn-secondary btn-sm" onClick={()=>setDeclForm(f=>({ ...f, files:f.files.filter((_,j)=>j!==i) }))}><X size={12}/></button>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      <div style={{ fontSize:11, color:'var(--silver)', margin:'6px 0 10px' }}>Se registra como <strong>endoso</strong> y genera su <strong>propia letra</strong> (con impuesto) con vencimiento en la fecha declarada; entra al saco. La comisión se genera cuando el cliente <strong>paga</strong>.</div>
                      <div style={{ display:'flex', gap:8 }}>
                        <button className="btn btn-primary btn-sm" disabled={savingDecl} onClick={guardarDeclaracion}>{savingDecl ? 'Guardando…' : 'Registrar declaración'}</button>
                        <button className="btn btn-secondary btn-sm" onClick={()=>setDeclForm(null)}>Cancelar</button>
                      </div>
                    </div>
                  )}
                  {viewPeriodos.length === 0 ? (
                    <div style={{ color:'var(--silver)', fontSize:13, padding:16 }}>
                      Aún no hay períodos. Se generan automáticamente al abrir el CRM (una tarea por período al ejecutivo de cuenta).
                    </div>
                  ) : (
                    <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                      {viewPeriodos.map(per => {
                        const facturado = per.estado === 'facturado';
                        const editando = periodoFactura && periodoFactura.periodo.id === per.id;
                        // Declarativa: las declaraciones del mes son letras de endoso cuyo
                        // vencimiento cae dentro del período. Se muestran (varias por mes OK).
                        const declaraciones = selected.es_declarativa
                          ? (viewPagos || []).filter(p => p.origen === 'endoso'
                              && p.fecha_vencimiento >= per.periodo_inicio && p.fecha_vencimiento <= per.periodo_fin)
                          : [];
                        const totalDecl = declaraciones.reduce((s, p) => s + (parseFloat(p.monto) || 0), 0);
                        return (
                          <div key={per.id} style={{ padding:'10px 14px', background:'rgba(var(--steel-rgb),0.3)', borderRadius:8, border:'1px solid rgba(var(--silver-rgb),0.12)' }}>
                            <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                              <div style={{ flex:1 }}>
                                <div style={{ fontSize:14, fontWeight:600 }}>{etiquetaPeriodo(per.periodo_label)}</div>
                                <div style={{ fontSize:11, color:'var(--silver)' }}>{fmtFecha(per.periodo_inicio)} – {fmtFecha(per.periodo_fin)}{per.fecha_vencimiento ? ` · vence ${fmtFecha(per.fecha_vencimiento)}` : ''}</div>
                              </div>
                              {selected.es_declarativa ? (
                                declaraciones.length > 0 ? (
                                  <>
                                    <span style={{ fontSize:13, color:'var(--silver)' }}>{declaraciones.length} declaración{declaraciones.length !== 1 ? 'es' : ''}</span>
                                    <span style={{ fontSize:14, fontWeight:600 }}>{fmt$(totalDecl)}</span>
                                    <span className="badge badge-success">Declarado</span>
                                  </>
                                ) : (
                                  <span className="badge badge-warning">Sin declarar</span>
                                )
                              ) : facturado ? (
                                <>
                                  <span style={{ fontSize:14, fontWeight:600 }}>${Number(per.monto||0).toLocaleString('es-PA',{minimumFractionDigits:2})}</span>
                                  <span className="badge badge-success">Facturado</span>
                                </>
                              ) : (
                                <>
                                  <span className="badge badge-warning">Pendiente</span>
                                  {canEdit('polizas') && !editando && (
                                    <button className="btn btn-primary btn-sm"
                                      onClick={()=>setPeriodoFactura({ periodo: per, monto:'', fecha_factura:'', fecha_envio_cliente:'', notas:'' })}>
                                      Registrar factura
                                    </button>
                                  )}
                                </>
                              )}
                            </div>
                            {selected.es_declarativa && declaraciones.length > 0 && (
                              <div style={{ marginTop:8, paddingTop:8, borderTop:'1px solid rgba(var(--silver-rgb),0.12)', display:'flex', flexDirection:'column', gap:4 }}>
                                {declaraciones.map(d => (
                                  <div key={d.id} style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'var(--silver)' }}>
                                    <span>Declaración · vence {fmtFecha(d.fecha_vencimiento)} · {d.estado}</span>
                                    <span style={{ fontWeight:600, color:'var(--text)' }}>{fmt$(d.monto)}</span>
                                  </div>
                                ))}
                              </div>
                            )}
                            {selected.es_declarativa && (() => {
                              const docsPer = (viewPeriodoDocs || []).filter(d => String(d.periodo_id) === String(per.id));
                              const facturaTipoId = (tiposDocPoliza.find(t=>t.codigo==='FAC')||tiposDocPoliza[0])?.id || '';
                              if (docsPer.length === 0 && !canEdit('polizas')) return null;
                              return (
                                <div style={{ marginTop:8, paddingTop:8, borderTop:'1px solid rgba(var(--silver-rgb),0.12)' }}>
                                  <div style={{ fontSize:11, color:'var(--silver)', marginBottom:4 }}>Documentos de respaldo</div>
                                  {docsPer.map(d => (
                                    <div key={d.id} style={{ display:'flex', alignItems:'center', gap:8, fontSize:12.5, marginBottom:3 }}>
                                      <Paperclip size={13} style={{ color:'var(--sky-light)' }} />
                                      <a href="#" onClick={ev=>{ ev.preventDefault(); abrirDocumento(d.storage_path); }} style={{ color:'var(--sky-light)', textDecoration:'none' }}>{d.nombre_archivo || 'Documento'}</a>
                                      {d.tipos_documento?.nombre && <span className="badge badge-neutral text-xs">{d.tipos_documento.nombre}</span>}
                                    </div>
                                  ))}
                                  {canEdit('polizas') && (
                                    <label style={{ fontSize:12, color:'var(--sky-light)', cursor:'pointer', display:'inline-flex', alignItems:'center', gap:6, marginTop:4 }}>
                                      <Plus size={12}/> Adjuntar factura / respaldo
                                      <input type="file" style={{ display:'none' }} onChange={e=>{ const file=e.target.files?.[0]; if(file) adjuntarFacturaPeriodo(per, file, facturaTipoId); e.target.value=''; }} />
                                    </label>
                                  )}
                                </div>
                              );
                            })()}
                            {editando && (
                              <div style={{ marginTop:10, paddingTop:10, borderTop:'1px solid rgba(var(--silver-rgb),0.12)' }}>
                                <div className="form-grid form-grid-3">
                                  <div className="form-group">
                                    <label className="form-label">Monto de la factura *</label>
                                    <input className="form-input" type="number" step="0.01" value={periodoFactura.monto}
                                      onChange={e=>setPeriodoFactura(p=>({ ...p, monto:e.target.value }))} placeholder="0.00" />
                                  </div>
                                  <div className="form-group">
                                    <label className="form-label">Fecha de factura</label>
                                    <input className="form-input" type="date" value={periodoFactura.fecha_factura}
                                      onChange={e=>setPeriodoFactura(p=>({ ...p, fecha_factura:e.target.value }))} />
                                  </div>
                                  <div className="form-group">
                                    <label className="form-label">Enviada al cliente</label>
                                    <input className="form-input" type="date" value={periodoFactura.fecha_envio_cliente}
                                      onChange={e=>setPeriodoFactura(p=>({ ...p, fecha_envio_cliente:e.target.value }))} />
                                  </div>
                                </div>
                                <div style={{ display:'flex', gap:8, marginTop:8 }}>
                                  <button className="btn btn-primary btn-sm" disabled={guardandoPeriodo} onClick={guardarFacturaPeriodo}>
                                    {guardandoPeriodo ? 'Guardando...' : 'Facturar período'}
                                  </button>
                                  <button className="btn btn-secondary btn-sm" onClick={()=>setPeriodoFactura(null)}>Cancelar</button>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}

              {/* ── Tab: Gestiones (bitácora de cobro y de póliza/renovación) ── */}
              {viewTab === 'gestiones' && (
                (() => {
                  const ACCION_LBL = { nota:'Nota', posponer:'Pospuesta', cerrar:'Cierre', asignacion:'Asignación' };
                  const renderGest = (g, color) => (
                    <div key={g.id} style={{padding:'10px 14px',background:'rgba(var(--navy-rgb),0.4)',borderRadius:8,borderLeft:`3px solid ${color}`}}>
                      <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:4,flexWrap:'wrap'}}>
                        <span style={{fontSize:10,padding:'2px 8px',borderRadius:4,background:'rgba(var(--silver-rgb),0.15)',color:'var(--silver)',fontWeight:600}}>{ACCION_LBL[g.accion] || g.accion}</span>
                      </div>
                      <div style={{fontSize:13,whiteSpace:'pre-wrap'}}>{g.detalle}</div>
                      <div style={{fontSize:11,color:'var(--silver)',marginTop:4}}>{g.usuarios?.nombre || 'Sistema'} · {fmtFechaHora(g.creado_en)}</div>
                    </div>
                  );
                  return (
                <div>
                  <div style={{fontSize:12,color:'var(--silver)',marginBottom:16,padding:'8px 12px',background:'rgba(var(--sky-rgb),0.07)',borderRadius:8,border:'1px solid rgba(var(--sky-rgb),0.18)'}}>
                    Historial de gestiones de esta póliza (notas, posposiciones, cierres), aunque la tarea ya no esté activa. <strong>Cobro</strong> = seguimiento de pago; <strong>Renovación/Póliza</strong> = seguimiento de renovación y endosos.
                  </div>

                  <div style={{fontSize:11,fontWeight:700,color:'var(--sky-light)',letterSpacing:1,marginBottom:8}}>GESTIONES DE COBRO ({viewBitacoraCobros.length})</div>
                  {viewBitacoraCobros.length === 0
                    ? <div style={{fontSize:12,color:'var(--silver)',marginBottom:20}}>Sin gestiones de cobro registradas.</div>
                    : <div style={{display:'flex',flexDirection:'column',gap:8,marginBottom:22}}>
                        {viewBitacoraCobros.map(g=>renderGest(g, 'rgba(var(--sky-rgb),0.6)'))}
                      </div>
                  }

                  <div style={{fontSize:11,fontWeight:700,color:'var(--text-success)',letterSpacing:1,marginBottom:8}}>GESTIONES DE RENOVACIÓN / PÓLIZA ({viewBitacoraPolizas.length})</div>
                  {viewBitacoraPolizas.length === 0
                    ? <div style={{fontSize:12,color:'var(--silver)'}}>Sin gestiones de renovación/póliza registradas.</div>
                    : <div style={{display:'flex',flexDirection:'column',gap:8}}>
                        {viewBitacoraPolizas.map(g=>renderGest(g, 'rgba(34, 197, 94, 0.5)'))}
                      </div>
                  }
                </div>
                  );
                })()
              )}

              {/* ── Tab: Cierre (regularización, solo declarativas) ── */}
              {viewTab === 'cierre' && (
                <RegularizacionPanel poliza={selected} onChange={() => openView(selected)} />
              )}

              {/* ── Tab: Reclamos ── */}
              {viewTab === 'reclamos' && (
                <div>
                  {viewReclamos.length === 0 ? (
                    <div style={{textAlign:'center',padding:'32px 0',color:'var(--silver)',fontSize:13}}>
                      Esta póliza no tiene reclamos registrados.
                    </div>
                  ) : (<>
                    {(() => {
                      const abiertos = viewReclamos.filter(r => RECLAMO_ABIERTO.includes(r.estado)).length;
                      return (
                        <div style={{fontSize:12,marginBottom:12,color: abiertos>0 ? '#f59e0b' : 'var(--silver)',display:'flex',alignItems:'center',gap:6}}>
                          {abiertos>0 ? <><AlertTriangle size={13}/> {abiertos} reclamo{abiertos!==1?'s':''} abierto{abiertos!==1?'s':''} de {viewReclamos.length}</> : `${viewReclamos.length} reclamo${viewReclamos.length!==1?'s':''}, ninguno abierto`}
                        </div>
                      );
                    })()}
                    <div style={{display:'flex',flexDirection:'column',gap:8}}>
                      {viewReclamos.map(rc => (
                        <div key={rc.id} style={{padding:'12px 14px',background:'rgba(var(--steel-rgb),0.25)',borderRadius:8,border:'1px solid rgba(var(--sky-rgb),0.15)'}}>
                          <div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
                            <span style={{fontSize:13,fontWeight:700}}>{rc.numero || 'Sin número'}</span>
                            {rc.numero_aseguradora && <span style={{fontSize:11,color:'var(--silver)'}}>Aseg.: {rc.numero_aseguradora}</span>}
                            <span className={`badge ${RECLAMO_BADGE[rc.estado] || 'badge-neutral'}`} style={{marginLeft:'auto'}}>
                              {String(rc.estado || '').replace('_',' ')}{rc.estado==='cerrado' && rc.motivo_cierre ? ` · ${({pagado_aseguradora:'pagado',declinado_aseguradora:'declinado',manual:'manual'})[rc.motivo_cierre]||''}` : ''}
                            </span>
                          </div>
                          {rc.descripcion && <div style={{fontSize:12,color:'#c9d6e5',marginTop:6}}>{rc.descripcion}</div>}
                          <div style={{display:'flex',gap:16,flexWrap:'wrap',marginTop:8,fontSize:11,color:'var(--silver)'}}>
                            {rc.fecha_siniestro && <span>Siniestro: {fmtFecha(rc.fecha_siniestro)}</span>}
                            {rc.monto_reclamado!=null && <span>Reclamado: {fmt$(rc.monto_reclamado)}</span>}
                            {rc.monto_aprobado!=null && <span>Aprobado: {fmt$(rc.monto_aprobado)}</span>}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>)}
                </div>
              )}

              {/* ── Tab: Documentos ── */}
              {viewTab === 'docs' && (
                <>
                {viewArchivosSol.length > 0 && (
                  <div style={{marginBottom:14}}>
                    <div style={{fontSize:11,color:'var(--silver)',textTransform:'uppercase',marginBottom:8}}>Documentos de la solicitud de origen</div>
                    <div style={{display:'flex',flexDirection:'column',gap:6}}>
                      {viewArchivosSol.map(a => (
                        <a key={a.id} href="#" onClick={(e)=>{ e.preventDefault(); abrirDocumento(a.url); }}
                          style={{display:'flex',alignItems:'center',gap:8,padding:'8px 12px',background:'rgba(var(--sky-rgb),0.08)',borderRadius:8,border:'1px solid rgba(var(--sky-rgb),0.18)',fontSize:13,color:'var(--sky-light)',textDecoration:'none'}}>
                          <FileText size={13}/> {a.nombre}
                          {a.tipo_doc ? <span style={{color:'var(--silver)',marginLeft:6}}>· {a.tipo_doc}</span> : null}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
                <DocManager
                  polizaId={selected.id}
                  solicitudId={selected.solicitud_id || null}
                  linkedClienteId={selected.cliente_id}
                  categoriasPermitidas={['solicitud','poliza','cliente_natural','cliente_juridico','otro']}
                  readOnly={!canEdit('polizas')}
                />
                </>
              )}

            </div>

            <div className="modal-footer">
              {sessionStorage.getItem('backFrom') === 'solicitudes' && (
                <button className="btn btn-secondary btn-sm" style={{marginRight:'auto'}}
                  onClick={()=>{ sessionStorage.removeItem('backFrom'); sessionStorage.setItem('openSolicitudId', String(selected.solicitud_id)); closeModal(); navigate('/solicitudes'); }}>
                  ← Volver a Solicitud
                </button>
              )}
              {sessionStorage.getItem('backFrom') === 'cobros' && (
                <button className="btn btn-secondary btn-sm" style={{marginRight:'auto'}}
                  onClick={()=>{ sessionStorage.removeItem('backFrom'); closeModal(); navigate('/cobros'); }}>
                  ← Volver a Cobros
                </button>
              )}
              {sessionStorage.getItem('backFrom') === 'comisiones' && (
                <button className="btn btn-secondary btn-sm" style={{marginRight:'auto'}}
                  onClick={()=>{ sessionStorage.removeItem('backFrom'); closeModal(); navigate('/comisiones'); }}>
                  ← Volver a Comisiones
                </button>
              )}
              {/* El menú Editar/Renovar es de la PÓLIZA: solo aparece en la pestaña Información */}
              {viewTab === 'info' && canEdit('polizas') && (
                <button className="btn btn-secondary btn-sm" onClick={()=>{closeModal();setTimeout(()=>openEdit(selected),50);}}>
                  <Edit2 size={13}/> Editar
                </button>
              )}
              {viewTab === 'info' && canEdit('polizas') && (
                <button className="btn btn-secondary btn-sm" onClick={()=>{closeModal();setTimeout(()=>openRenovar(selected),50);}}>
                  <RotateCw size={13}/> Renovar
                </button>
              )}
              <button className="btn btn-secondary" onClick={closeModal}>Cerrar</button>
            </div>
          </div>
        </div>
        );
      })()}

      {/* Modal: registrar pago (pestaña Plan de Cobros) */}
      {showPagoModal && selected && (
        <div className="modal-overlay" style={{ zIndex:1400 }} onClick={()=>{ if(!savingPago) setShowPagoModal(false); }}>
          <div className="modal" style={{ maxWidth:480 }} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <div className="modal-title">Registrar Pago</div>
                <div className="text-silver text-sm">{selected.numero} · {selected.cliente}</div>
              </div>
              <button className="btn btn-icon btn-secondary btn-sm" onClick={()=>{ if(!savingPago) setShowPagoModal(false); }}><X size={16} /></button>
            </div>
            <div className="modal-body">
              <div style={{fontSize:12,color:'var(--silver)',marginBottom:14,padding:'8px 12px',background:'rgba(var(--sky-rgb),0.07)',borderRadius:8,border:'1px solid rgba(var(--sky-rgb),0.18)'}}>
                El pago se aplica como <strong>saco</strong>: cubre las cuotas más antiguas primero (incluida la vigencia anterior si la hay). Genera la comisión del cobro automáticamente.
              </div>
              <div className="form-grid form-grid-2">
                <div className="form-group">
                  <label className="form-label">Monto recibido *</label>
                  <input className="form-input" type="number" step="0.01" value={pagoForm.monto_recibido}
                    onChange={e=>setPagoForm(p=>({...p,monto_recibido:e.target.value}))} placeholder="0.00" autoFocus />
                </div>
                <div className="form-group">
                  <label className="form-label">Fecha del pago *</label>
                  <input className="form-input" type="date" value={pagoForm.fecha_pago_aseg}
                    onChange={e=>setPagoForm(p=>({...p,fecha_pago_aseg:e.target.value}))} />
                </div>
                <div className="form-group">
                  <label className="form-label">¿Dónde se pagó?</label>
                  <select className="form-select" value={pagoForm.donde_pago}
                    onChange={e=>setPagoForm(p=>({...p,donde_pago:e.target.value}))}>
                    <option value="Aseguradora">Aseguradora</option>
                    <option value="RU">Oficina</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Forma de pago</label>
                  <select className="form-select" value={pagoForm.forma_pago_real}
                    onChange={e=>setPagoForm(p=>({...p,forma_pago_real:e.target.value}))}>
                    <option value="">Sin especificar</option>
                    <option value="TC">Tarjeta de Crédito</option>
                    <option value="ACH">ACH</option>
                    <option value="Yappy">Yappy</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Cheque">Cheque</option>
                  </select>
                </div>
                {pagoForm.donde_pago === 'RU' ? (
                  <div className="form-group" style={{ gridColumn:'span 2' }}>
                    <label className="form-label">N° de recibo</label>
                    <div style={{fontSize:12, color:'var(--sky-light)', padding:'9px 12px', background:'rgba(var(--sky-rgb),0.08)', border:'1px solid rgba(var(--sky-rgb),0.25)', borderRadius:8}}>
                      El sistema asigna el número de recibo de oficina automáticamente al confirmar.
                    </div>
                  </div>
                ) : (
                  <div className="form-group" style={{ gridColumn:'span 2' }}>
                    <label className="form-label">N° de recibo (aseguradora)</label>
                    <input className="form-input" value={pagoForm.num_recibo_aseg}
                      onChange={e=>setPagoForm(p=>({...p,num_recibo_aseg:e.target.value}))} placeholder="El que dio la aseguradora" />
                  </div>
                )}
                <div className="form-group" style={{ gridColumn:'span 2' }}>
                  <label className="form-label">Notas</label>
                  <textarea className="form-textarea" value={pagoForm.notas_cobro}
                    onChange={e=>setPagoForm(p=>({...p,notas_cobro:e.target.value}))} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={()=>{ if(!savingPago) setShowPagoModal(false); }} disabled={savingPago}>Cancelar</button>
              <button className="btn btn-primary" onClick={handleRegistrarPago} disabled={savingPago}>
                {savingPago ? 'Registrando...' : 'Registrar pago'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal éxito de pago en oficina: recibo asignado + imprimir */}
      {reciboExito && <ReciboCobroExito datos={reciboExito} onClose={() => setReciboExito(null)} />}

      {/* Modal: detalle de un endoso APLICADO (clic en la línea de la pestaña Endosos) */}
      {endosoDetalle && (() => {
        const e = endosoDetalle;
        const delta = parseFloat(e.delta_prima) || 0;
        const anulado = e.estado === 'anulado';
        const docUrl = e.url_documento || (e.sol_archivos && e.sol_archivos.length > 0 ? e.sol_archivos[0].url : null);
        const cambios = Array.isArray(e.cambios_json) ? e.cambios_json
          : (e.cambios_json && typeof e.cambios_json === 'object' ? [{ tipo_endoso_id: e.tipo_endoso_id, cambios: e.cambios_json }] : []);
        return (
          <div className="modal-overlay" style={{ zIndex:1400 }} onClick={()=>setEndosoDetalle(null)}>
            <div className="modal" style={{ maxWidth:600 }} onClick={ev=>ev.stopPropagation()}>
              <style>{`.endoso-det{border-collapse:collapse;margin-top:4px;font-size:12px} .endoso-det td{padding:2px 10px 2px 0} .endoso-det .lbl{color:#8FA8C0;white-space:nowrap}`}</style>
              <div className="modal-header">
                <div>
                  <div className="modal-title">Endoso{e.numero_endoso ? ` N° ${e.numero_endoso}` : ''}</div>
                  <div className="text-silver text-sm">{e.descripcion || '—'}</div>
                </div>
                <button className="btn btn-icon btn-secondary btn-sm" onClick={()=>setEndosoDetalle(null)}><X size={16}/></button>
              </div>
              <div className="modal-body">
                <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:14 }}>
                  <span className={`badge ${anulado?'badge-danger':e.estado==='activo'?'badge-success':'badge-warning'}`}>{anulado?'Anulado':(e.estado||'—')}</span>
                  {e.es_interno && <span className="badge badge-info">Endoso interno</span>}
                  {e.tipo === 'cancelacion' && <span className="badge badge-danger">Cancelación{e.metodo_calculo==='short_rate'?' · tasa corta':''}</span>}
                  {e.tipo === 'prorroga' && <span className="badge badge-success">Prórroga</span>}
                </div>
                <div className="form-grid form-grid-3" style={{ marginBottom:14 }}>
                  {[
                    ['Fecha del endoso', fmtFecha(e.fecha) || '—'],
                    ['Registrado', fmtFecha(e.creado_en) || '—'],
                    ['Movimiento de prima', <span style={{ color: delta>0?'#22c55e':delta<0?'#ef4444':'var(--silver)', fontWeight:700 }}>{delta>0?'+':''}{fmt$(delta)}</span>],
                  ].map(([l,v])=>(
                    <div key={l}>
                      <div className="text-xs text-silver" style={{ marginBottom:2, textTransform:'uppercase' }}>{l}</div>
                      <div style={{ fontSize:13, fontWeight:500 }}>{v}</div>
                    </div>
                  ))}
                </div>
                {anulado && e.motivo_anulacion && (
                  <div style={{ padding:'8px 12px', background:'rgba(239, 68, 68, 0.08)', border:'1px solid rgba(239, 68, 68, 0.25)', borderRadius:8, fontSize:12, color:'var(--text-danger)', marginBottom:14 }}>
                    Motivo de anulación: {e.motivo_anulacion}
                  </div>
                )}
                {cambios.length > 0 && (
                  <div style={{ padding:'10px 14px', background:'rgba(var(--steel-rgb),0.3)', borderRadius:8, marginBottom:14 }}>
                    <div className="text-xs text-silver" style={{ marginBottom:8 }}>CAMBIOS APLICADOS</div>
                    <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                      {cambios.map((ch, i) => {
                        const t = endosoTiposLista.find(x=>String(x.id)===String(ch.tipo_endoso_id));
                        const detalle = t?.target ? describirCambioHTML(t.target, ch.cambios) : '';
                        return (
                          <div key={i}>
                            <div style={{ fontSize:13, fontWeight:600 }}>{t?.nombre || endosoTiposMap[ch.tipo_endoso_id] || 'Cambio'}</div>
                            {detalle
                              ? <table className="endoso-det"><tbody dangerouslySetInnerHTML={{ __html: detalle }} /></table>
                              : <div style={{ fontSize:12, color:'var(--silver)' }}>Sin detalle capturado.</div>}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {docUrl && (
                  <a href="#" onClick={(ev)=>{ ev.preventDefault(); abrirDocumento(docUrl); }}
                    style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'8px 12px', background:'rgba(var(--sky-rgb),0.08)', border:'1px solid rgba(var(--sky-rgb),0.18)', borderRadius:8, fontSize:13, color:'var(--sky-light)', textDecoration:'none' }}>
                    📎 {e.nombre_documento || 'Documento del endoso'}
                  </a>
                )}
              </div>
              <div className="modal-footer">
                {e.solicitud_id && (
                  <button className="btn btn-secondary btn-sm" style={{ marginRight:'auto' }}
                    onClick={()=>{ setEndosoDetalle(null); irAFacturarEndoso(e.solicitud_id); }}>
                    <FileText size={13}/> Ver solicitud SOL-{String(e.solicitud_id).padStart(4,'0')}
                  </button>
                )}
                <button className="btn btn-secondary" onClick={()=>setEndosoDetalle(null)}>Cerrar</button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Modal: motivo de anulación de endoso */}
      {anularEndosoTarget && (
        <div className="modal-overlay" style={{ zIndex:1400 }} onClick={()=>{ if(!anulandoEndoso) setAnularEndosoTarget(null); }}>
          <div className="modal" style={{ maxWidth:480 }} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title" style={{ color:'var(--text-danger)' }}>Anular Endoso</div>
              <button className="btn btn-icon btn-secondary btn-sm" onClick={()=>setAnularEndosoTarget(null)}><X size={16}/></button>
            </div>
            <div className="modal-body">
              <div style={{ fontSize:13, marginBottom:12 }}>
                Vas a anular el endoso <strong>"{anularEndosoTarget.descripcion || ''}"</strong> ({fmt$(anularEndosoTarget.delta_prima)} de prima).
                Se revertirán los saldos que generó en la póliza (el dinero cobrado se redistribuye) y el endoso quedará marcado como anulado en el listado.
              </div>
              <label className="form-label">Motivo de la anulación *</label>
              <textarea className="form-textarea" rows={3} value={motivoAnularEndoso}
                onChange={e=>setMotivoAnularEndoso(e.target.value)}
                placeholder="¿Por qué se anula este endoso?" />
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={()=>setAnularEndosoTarget(null)} disabled={anulandoEndoso}>Cancelar</button>
              <button className="btn btn-primary" onClick={confirmAnularEndoso} disabled={anulandoEndoso || !motivoAnularEndoso.trim()}>
                {anulandoEndoso ? 'Anulando...' : 'Anular endoso'}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

// ── Helpers de estilo ────────────────────────────────────────────
const inputSm = {
  padding:'4px 8px', background:'rgba(var(--steel-rgb),0.5)',
  border:'1px solid rgba(var(--silver-rgb),0.2)', borderRadius:6,
  color:'var(--text)', fontFamily:'var(--font)', fontSize:12,
};

const thSm = {
  padding:'8px 12px', textAlign:'left',
  fontSize:11, color:'var(--silver)', fontWeight:600,
};

// Rótulo pequeño sobre cada filtro de la barra superior de Pólizas
const filterLabel = {
  fontSize:10, fontWeight:700, letterSpacing:0.5,
  color:'var(--silver)', textTransform:'uppercase', paddingLeft:2,
};

function SectionTitle({ children, style }) {
  return (
    <div style={{ fontSize:12, fontWeight:700, color:'var(--silver)', letterSpacing:1, marginBottom:10, ...style }}>
      {children}
    </div>
  );
}
